
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $6ab30f785569541a$var$KissFFTModule = (()=>{
    var _scriptDir = "file:///node_modules/webfft/lib/kissfft/KissFFT.mjs";
    return function(moduleArg = {}) {
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject)=>{
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var wasmExports;
        var ABORT = false;
        var EXITSTATUS;
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        wasmBinaryFile = "data:application/octet-stream;base64,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";
        if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        function getBinarySync(file) {
            if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
            var binary = tryParseAsDataURI(file);
            if (binary) return binary;
            if (readBinary) return readBinary(file);
            throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function instantiateSync(file, info) {
            var module;
            var binary = getBinarySync(file);
            module = new WebAssembly.Module(binary);
            var instance = new WebAssembly.Instance(module, info);
            return [
                instance,
                module
            ];
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                wasmExports = exports;
                wasmMemory = wasmExports["c"];
                updateMemoryViews();
                wasmTable = wasmExports["j"];
                addOnInit(wasmExports["d"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            var result = instantiateSync(wasmBinaryFile, info);
            return receiveInstance(result[0]);
        }
        var callRuntimeCallbacks = (callbacks)=>{
            while(callbacks.length > 0)callbacks.shift()(Module);
        };
        var _emscripten_memcpy_big = (dest, src, num)=>HEAPU8.copyWithin(dest, src, src + num);
        var abortOnCannotGrowMemory = (requestedSize)=>{
            abort("OOM");
        };
        var _emscripten_resize_heap = (requestedSize)=>{
            var oldSize = HEAPU8.length;
            requestedSize >>>= 0;
            abortOnCannotGrowMemory(requestedSize);
        };
        function getCFunc(ident) {
            var func = Module["_" + ident];
            return func;
        }
        var writeArrayToMemory = (array, buffer)=>{
            HEAP8.set(array, buffer);
        };
        var lengthBytesUTF8 = (str)=>{
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        var stringToUTF8OnStack = (str)=>{
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
        };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
            var str = "";
            while(idx < endPtr){
                var u0 = heapOrArray[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heapOrArray[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = heapOrArray[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
            return str;
        };
        var UTF8ToString = (ptr, maxBytesToRead)=>ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        var ccall = function(ident, returnType, argTypes, args, opts) {
            var toC = {
                "string": (str)=>{
                    var ret = 0;
                    if (str !== null && str !== undefined && str !== 0) ret = stringToUTF8OnStack(str);
                    return ret;
                },
                "array": (arr)=>{
                    var ret = stackAlloc(arr.length);
                    writeArrayToMemory(arr, ret);
                    return ret;
                }
            };
            function convertReturnValue(ret) {
                if (returnType === "string") return UTF8ToString(ret);
                if (returnType === "boolean") return Boolean(ret);
                return ret;
            }
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            if (args) for(var i = 0; i < args.length; i++){
                var converter = toC[argTypes[i]];
                if (converter) {
                    if (stack === 0) stack = stackSave();
                    cArgs[i] = converter(args[i]);
                } else cArgs[i] = args[i];
            }
            var ret = func.apply(null, cArgs);
            function onDone(ret) {
                if (stack !== 0) stackRestore(stack);
                return convertReturnValue(ret);
            }
            ret = onDone(ret);
            return ret;
        };
        var cwrap = function(ident, returnType, argTypes, opts) {
            var numericArgs = !argTypes || argTypes.every((type)=>type === "number" || type === "boolean");
            var numericRet = returnType !== "string";
            if (numericRet && numericArgs && !opts) return getCFunc(ident);
            return function() {
                return ccall(ident, returnType, argTypes, arguments, opts);
            };
        };
        var wasmImports = {
            b: _emscripten_memcpy_big,
            a: _emscripten_resize_heap
        };
        var asm = createWasm();
        var ___wasm_call_ctors = asm["d"];
        var _kiss_fft_free = Module["_kiss_fft_free"] = asm["e"];
        var _free = Module["_free"] = asm["f"];
        var _kiss_fft_alloc = Module["_kiss_fft_alloc"] = asm["g"];
        var _malloc = Module["_malloc"] = asm["h"];
        var _kiss_fft = Module["_kiss_fft"] = asm["i"];
        var ___errno_location = asm["__errno_location"];
        var stackSave = asm["k"];
        var stackRestore = asm["l"];
        var stackAlloc = asm["m"];
        function intArrayFromBase64(s) {
            try {
                var decoded = atob(s);
                var bytes = new Uint8Array(decoded.length);
                for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
                return bytes;
            } catch (_) {
                throw new Error("Converting base64 string to bytes failed.");
            }
        }
        function tryParseAsDataURI(filename) {
            if (!isDataURI(filename)) return;
            return intArrayFromBase64(filename.slice(dataURIPrefix.length));
        }
        Module["ccall"] = ccall;
        Module["cwrap"] = cwrap;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        run();
        return moduleArg;
    };
})();
var $6ab30f785569541a$export$2e2bcd8739ae039 = $6ab30f785569541a$var$KissFFTModule;


"use strict";
var $e2b86b9f09fd2141$var$kissFFTModule = (0, $6ab30f785569541a$export$2e2bcd8739ae039)({});
var $e2b86b9f09fd2141$var$kiss_fft_alloc = $e2b86b9f09fd2141$var$kissFFTModule.cwrap("kiss_fft_alloc", "number", [
    "number",
    "number",
    "number",
    "number"
]);
var $e2b86b9f09fd2141$var$kiss_fft = $e2b86b9f09fd2141$var$kissFFTModule.cwrap("kiss_fft", "void", [
    "number",
    "number",
    "number"
]);
var $e2b86b9f09fd2141$var$kiss_fft_free = $e2b86b9f09fd2141$var$kissFFTModule.cwrap("kiss_fft_free", "void", [
    "number"
]);
class $e2b86b9f09fd2141$var$KissFftWrapperWasm {
    constructor(size){
        this.size = size;
        this.fcfg = $e2b86b9f09fd2141$var$kiss_fft_alloc(this.size, false);
        this.icfg = $e2b86b9f09fd2141$var$kiss_fft_alloc(this.size, true);
        this.inptr = $e2b86b9f09fd2141$var$kissFFTModule._malloc(this.size * 8);
        this.cin = new Float32Array($e2b86b9f09fd2141$var$kissFFTModule.HEAPU8.buffer, this.inptr, this.size * 2);
    }
    fft = function(inputArray) {
        // TODO: figure out how to move this into the constructor without breaking things (unit tests will catch it)
        const outptr = $e2b86b9f09fd2141$var$kissFFTModule._malloc(this.size * 8);
        const cout = new Float32Array($e2b86b9f09fd2141$var$kissFFTModule.HEAPU8.buffer, outptr, this.size * 2);
        this.cin.set(inputArray);
        $e2b86b9f09fd2141$var$kiss_fft(this.fcfg, this.inptr, outptr);
        // we need to free the memory of outptr before we return, so we need this too
        let outputArray = new Float32Array(this.size * 2);
        outputArray.set(cout);
        $e2b86b9f09fd2141$var$kissFFTModule._free(outptr);
        return outputArray;
    };
    dispose() {
        $e2b86b9f09fd2141$var$kiss_fft_free(this.fcfg);
        $e2b86b9f09fd2141$var$kiss_fft_free(this.icfg);
        $e2b86b9f09fd2141$var$kissFFTModule._free(this.inptr);
    }
}
var $e2b86b9f09fd2141$export$2e2bcd8739ae039 = $e2b86b9f09fd2141$var$KissFftWrapperWasm;


"use strict";
function $6e53715879594e22$var$FFT_indutny(size) {
    this.size = size | 0;
    if (this.size <= 1 || (this.size & this.size - 1) !== 0) throw new Error("FFT size must be a power of two and bigger than 1");
    this._csize = size << 1;
    // NOTE: Use of `var` is intentional for old V8 versions
    var table = new Array(this.size * 2);
    for(var i = 0; i < table.length; i += 2){
        const angle = Math.PI * i / this.size;
        table[i] = Math.cos(angle);
        table[i + 1] = -Math.sin(angle);
    }
    this.table = table;
    // Find size's power of two
    var power = 0;
    for(var t = 1; this.size > t; t <<= 1)power++;
    // Calculate initial step's width:
    //   * If we are full radix-4 - it is 2x smaller to give inital len=8
    //   * Otherwise it is the same as `power` to give len=4
    this._width = power % 2 === 0 ? power - 1 : power;
    // Pre-compute bit-reversal patterns
    this._bitrev = new Array(1 << this._width);
    for(var j = 0; j < this._bitrev.length; j++){
        this._bitrev[j] = 0;
        for(var shift = 0; shift < this._width; shift += 2){
            var revShift = this._width - shift - 2;
            this._bitrev[j] |= (j >>> shift & 3) << revShift;
        }
    }
    this._out = null;
    this._data = null;
    this._inv = 0;
}
$6e53715879594e22$var$FFT_indutny.prototype.fromComplexArray = function fromComplexArray(complex, storage) {
    var res = storage || new Array(complex.length >>> 1);
    for(var i = 0; i < complex.length; i += 2)res[i >>> 1] = complex[i];
    return res;
};
$6e53715879594e22$var$FFT_indutny.prototype.createComplexArray = function createComplexArray() {
    const res = new Array(this._csize);
    for(var i = 0; i < res.length; i++)res[i] = 0;
    return res;
};
$6e53715879594e22$var$FFT_indutny.prototype.toComplexArray = function toComplexArray(input, storage) {
    var res = storage || this.createComplexArray();
    for(var i = 0; i < res.length; i += 2){
        res[i] = input[i >>> 1];
        res[i + 1] = 0;
    }
    return res;
};
$6e53715879594e22$var$FFT_indutny.prototype.completeSpectrum = function completeSpectrum(spectrum) {
    var size = this._csize;
    var half = size >>> 1;
    for(var i = 2; i < half; i += 2){
        spectrum[size - i] = spectrum[i];
        spectrum[size - i + 1] = -spectrum[i + 1];
    }
};
$6e53715879594e22$var$FFT_indutny.prototype.transform = function transform(out, data) {
    if (out === data) throw new Error("Input and output buffers must be different");
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._transform4();
    this._out = null;
    this._data = null;
};
$6e53715879594e22$var$FFT_indutny.prototype.realTransform = function realTransform(out, data) {
    if (out === data) throw new Error("Input and output buffers must be different");
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._realTransform4();
    this._out = null;
    this._data = null;
};
$6e53715879594e22$var$FFT_indutny.prototype.inverseTransform = function inverseTransform(out, data) {
    if (out === data) throw new Error("Input and output buffers must be different");
    this._out = out;
    this._data = data;
    this._inv = 1;
    this._transform4();
    for(var i = 0; i < out.length; i++)out[i] /= this.size;
    this._out = null;
    this._data = null;
};
// radix-4 implementation
//
// NOTE: Uses of `var` are intentional for older V8 version that do not
// support both `let compound assignments` and `const phi`
$6e53715879594e22$var$FFT_indutny.prototype._transform4 = function _transform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform2(outOff, off, step);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform4(outOff, off, step);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var quarterLen = len >>> 2;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len){
            // Full case
            var limit = outOff + quarterLen;
            for(var i = outOff, k = 0; i < limit; i += 2, k += step){
                const A = i;
                const B = A + quarterLen;
                const C = B + quarterLen;
                const D = C + quarterLen;
                // Original values
                const Ar = out[A];
                const Ai = out[A + 1];
                const Br = out[B];
                const Bi = out[B + 1];
                const Cr = out[C];
                const Ci = out[C + 1];
                const Dr = out[D];
                const Di = out[D + 1];
                // Middle values
                const MAr = Ar;
                const MAi = Ai;
                const tableBr = table[k];
                const tableBi = inv * table[k + 1];
                const MBr = Br * tableBr - Bi * tableBi;
                const MBi = Br * tableBi + Bi * tableBr;
                const tableCr = table[2 * k];
                const tableCi = inv * table[2 * k + 1];
                const MCr = Cr * tableCr - Ci * tableCi;
                const MCi = Cr * tableCi + Ci * tableCr;
                const tableDr = table[3 * k];
                const tableDi = inv * table[3 * k + 1];
                const MDr = Dr * tableDr - Di * tableDi;
                const MDi = Dr * tableDi + Di * tableDr;
                // Pre-Final values
                const T0r = MAr + MCr;
                const T0i = MAi + MCi;
                const T1r = MAr - MCr;
                const T1i = MAi - MCi;
                const T2r = MBr + MDr;
                const T2i = MBi + MDi;
                const T3r = inv * (MBr - MDr);
                const T3i = inv * (MBi - MDi);
                // Final values
                const FAr = T0r + T2r;
                const FAi = T0i + T2i;
                const FCr = T0r - T2r;
                const FCi = T0i - T2i;
                const FBr = T1r + T3i;
                const FBi = T1i - T3r;
                const FDr = T1r - T3i;
                const FDi = T1i + T3r;
                out[A] = FAr;
                out[A + 1] = FAi;
                out[B] = FBr;
                out[B + 1] = FBi;
                out[C] = FCr;
                out[C + 1] = FCi;
                out[D] = FDr;
                out[D + 1] = FDi;
            }
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$6e53715879594e22$var$FFT_indutny.prototype._singleTransform2 = function _singleTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const evenI = data[off + 1];
    const oddR = data[off + step];
    const oddI = data[off + step + 1];
    const leftR = evenR + oddR;
    const leftI = evenI + oddI;
    const rightR = evenR - oddR;
    const rightI = evenI - oddI;
    out[outOff] = leftR;
    out[outOff + 1] = leftI;
    out[outOff + 2] = rightR;
    out[outOff + 3] = rightI;
};
// radix-4
//
// NOTE: Only called for len=8
$6e53715879594e22$var$FFT_indutny.prototype._singleTransform4 = function _singleTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Ai = data[off + 1];
    const Br = data[off + step];
    const Bi = data[off + step + 1];
    const Cr = data[off + step2];
    const Ci = data[off + step2 + 1];
    const Dr = data[off + step3];
    const Di = data[off + step3 + 1];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T0i = Ai + Ci;
    const T1r = Ar - Cr;
    const T1i = Ai - Ci;
    const T2r = Br + Dr;
    const T2i = Bi + Di;
    const T3r = inv * (Br - Dr);
    const T3i = inv * (Bi - Di);
    // Final values
    const FAr = T0r + T2r;
    const FAi = T0i + T2i;
    const FBr = T1r + T3i;
    const FBi = T1i - T3r;
    const FCr = T0r - T2r;
    const FCi = T0i - T2i;
    const FDr = T1r - T3i;
    const FDi = T1i + T3r;
    out[outOff] = FAr;
    out[outOff + 1] = FAi;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = FCi;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};
// Real input radix-4 implementation
$6e53715879594e22$var$FFT_indutny.prototype._realTransform4 = function _realTransform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform2(outOff, off >>> 1, step >>> 1);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform4(outOff, off >>> 1, step >>> 1);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var halfLen = len >>> 1;
        var quarterLen = halfLen >>> 1;
        var hquarterLen = quarterLen >>> 1;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len)for(var i = 0, k = 0; i <= hquarterLen; i += 2, k += step){
            var A = outOff + i;
            var B = A + quarterLen;
            var C = B + quarterLen;
            var D = C + quarterLen;
            // Original values
            var Ar = out[A];
            var Ai = out[A + 1];
            var Br = out[B];
            var Bi = out[B + 1];
            var Cr = out[C];
            var Ci = out[C + 1];
            var Dr = out[D];
            var Di = out[D + 1];
            // Middle values
            var MAr = Ar;
            var MAi = Ai;
            var tableBr = table[k];
            var tableBi = inv * table[k + 1];
            var MBr = Br * tableBr - Bi * tableBi;
            var MBi = Br * tableBi + Bi * tableBr;
            var tableCr = table[2 * k];
            var tableCi = inv * table[2 * k + 1];
            var MCr = Cr * tableCr - Ci * tableCi;
            var MCi = Cr * tableCi + Ci * tableCr;
            var tableDr = table[3 * k];
            var tableDi = inv * table[3 * k + 1];
            var MDr = Dr * tableDr - Di * tableDi;
            var MDi = Dr * tableDi + Di * tableDr;
            // Pre-Final values
            var T0r = MAr + MCr;
            var T0i = MAi + MCi;
            var T1r = MAr - MCr;
            var T1i = MAi - MCi;
            var T2r = MBr + MDr;
            var T2i = MBi + MDi;
            var T3r = inv * (MBr - MDr);
            var T3i = inv * (MBi - MDi);
            // Final values
            var FAr = T0r + T2r;
            var FAi = T0i + T2i;
            var FBr = T1r + T3i;
            var FBi = T1i - T3r;
            out[A] = FAr;
            out[A + 1] = FAi;
            out[B] = FBr;
            out[B + 1] = FBi;
            // Output final middle point
            if (i === 0) {
                var FCr = T0r - T2r;
                var FCi = T0i - T2i;
                out[C] = FCr;
                out[C + 1] = FCi;
                continue;
            }
            // Do not overwrite ourselves
            if (i === hquarterLen) continue;
            // In the flipped case:
            // MAi = -MAi
            // MBr=-MBi, MBi=-MBr
            // MCr=-MCr
            // MDr=MDi, MDi=MDr
            var ST0r = T1r;
            var ST0i = -T1i;
            var ST1r = T0r;
            var ST1i = -T0i;
            var ST2r = -inv * T3i;
            var ST2i = -inv * T3r;
            var ST3r = -inv * T2i;
            var ST3i = -inv * T2r;
            var SFAr = ST0r + ST2r;
            var SFAi = ST0i + ST2i;
            var SFBr = ST1r + ST3i;
            var SFBi = ST1i - ST3r;
            var SA = outOff + quarterLen - i;
            var SB = outOff + halfLen - i;
            out[SA] = SFAr;
            out[SA + 1] = SFAi;
            out[SB] = SFBr;
            out[SB + 1] = SFBi;
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$6e53715879594e22$var$FFT_indutny.prototype._singleRealTransform2 = function _singleRealTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const oddR = data[off + step];
    const leftR = evenR + oddR;
    const rightR = evenR - oddR;
    out[outOff] = leftR;
    out[outOff + 1] = 0;
    out[outOff + 2] = rightR;
    out[outOff + 3] = 0;
};
// radix-4
//
// NOTE: Only called for len=8
$6e53715879594e22$var$FFT_indutny.prototype._singleRealTransform4 = function _singleRealTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Br = data[off + step];
    const Cr = data[off + step2];
    const Dr = data[off + step3];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T1r = Ar - Cr;
    const T2r = Br + Dr;
    const T3r = inv * (Br - Dr);
    // Final values
    const FAr = T0r + T2r;
    const FBr = T1r;
    const FBi = -T3r;
    const FCr = T0r - T2r;
    const FDr = T1r;
    const FDi = T3r;
    out[outOff] = FAr;
    out[outOff + 1] = 0;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = 0;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};
var $6e53715879594e22$export$2e2bcd8739ae039 = $6e53715879594e22$var$FFT_indutny;


class $0a835dc3ef5a3230$var$IndutnyFftWrapperJavascript {
    constructor(size){
        this.size = size;
        this.indutnyFft = new (0, $6e53715879594e22$export$2e2bcd8739ae039)(size);
    }
    fft(inputArr) {
        const outputArr = new Float32Array(2 * this.size);
        this.indutnyFft.transform(outputArr, inputArr);
        return outputArr;
    }
}
var $0a835dc3ef5a3230$export$2e2bcd8739ae039 = $0a835dc3ef5a3230$var$IndutnyFftWrapperJavascript;


var $ceb5aadfac8b6a23$var$CrossModule = (()=>{
    var _scriptDir = "file:///node_modules/webfft/lib/cross/Cross.mjs";
    return function(moduleArg = {}) {
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject)=>{
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var wasmExports;
        var ABORT = false;
        var EXITSTATUS;
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        wasmBinaryFile = "data:application/octet-stream;base64,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";
        if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        function getBinarySync(file) {
            if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
            var binary = tryParseAsDataURI(file);
            if (binary) return binary;
            if (readBinary) return readBinary(file);
            throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function instantiateSync(file, info) {
            var module;
            var binary = getBinarySync(file);
            module = new WebAssembly.Module(binary);
            var instance = new WebAssembly.Instance(module, info);
            return [
                instance,
                module
            ];
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                wasmExports = exports;
                wasmMemory = wasmExports["b"];
                updateMemoryViews();
                wasmTable = wasmExports["e"];
                addOnInit(wasmExports["c"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            var result = instantiateSync(wasmBinaryFile, info);
            return receiveInstance(result[0]);
        }
        var callRuntimeCallbacks = (callbacks)=>{
            while(callbacks.length > 0)callbacks.shift()(Module);
        };
        var abortOnCannotGrowMemory = (requestedSize)=>{
            abort("OOM");
        };
        var _emscripten_resize_heap = (requestedSize)=>{
            var oldSize = HEAPU8.length;
            requestedSize >>>= 0;
            abortOnCannotGrowMemory(requestedSize);
        };
        function getCFunc(ident) {
            var func = Module["_" + ident];
            return func;
        }
        var writeArrayToMemory = (array, buffer)=>{
            HEAP8.set(array, buffer);
        };
        var lengthBytesUTF8 = (str)=>{
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        var stringToUTF8OnStack = (str)=>{
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
        };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
            var str = "";
            while(idx < endPtr){
                var u0 = heapOrArray[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heapOrArray[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = heapOrArray[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
            return str;
        };
        var UTF8ToString = (ptr, maxBytesToRead)=>ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        var ccall = function(ident, returnType, argTypes, args, opts) {
            var toC = {
                "string": (str)=>{
                    var ret = 0;
                    if (str !== null && str !== undefined && str !== 0) ret = stringToUTF8OnStack(str);
                    return ret;
                },
                "array": (arr)=>{
                    var ret = stackAlloc(arr.length);
                    writeArrayToMemory(arr, ret);
                    return ret;
                }
            };
            function convertReturnValue(ret) {
                if (returnType === "string") return UTF8ToString(ret);
                if (returnType === "boolean") return Boolean(ret);
                return ret;
            }
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            if (args) for(var i = 0; i < args.length; i++){
                var converter = toC[argTypes[i]];
                if (converter) {
                    if (stack === 0) stack = stackSave();
                    cArgs[i] = converter(args[i]);
                } else cArgs[i] = args[i];
            }
            var ret = func.apply(null, cArgs);
            function onDone(ret) {
                if (stack !== 0) stackRestore(stack);
                return convertReturnValue(ret);
            }
            ret = onDone(ret);
            return ret;
        };
        var cwrap = function(ident, returnType, argTypes, opts) {
            var numericArgs = !argTypes || argTypes.every((type)=>type === "number" || type === "boolean");
            var numericRet = returnType !== "string";
            if (numericRet && numericArgs && !opts) return getCFunc(ident);
            return function() {
                return ccall(ident, returnType, argTypes, arguments, opts);
            };
        };
        var wasmImports = {
            a: _emscripten_resize_heap
        };
        var asm = createWasm();
        var ___wasm_call_ctors = asm["c"];
        var _fftCross = Module["_fftCross"] = asm["d"];
        var ___errno_location = asm["__errno_location"];
        var _malloc = Module["_malloc"] = asm["f"];
        var _free = Module["_free"] = asm["g"];
        var stackSave = asm["h"];
        var stackRestore = asm["i"];
        var stackAlloc = asm["j"];
        function intArrayFromBase64(s) {
            try {
                var decoded = atob(s);
                var bytes = new Uint8Array(decoded.length);
                for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
                return bytes;
            } catch (_) {
                throw new Error("Converting base64 string to bytes failed.");
            }
        }
        function tryParseAsDataURI(filename) {
            if (!isDataURI(filename)) return;
            return intArrayFromBase64(filename.slice(dataURIPrefix.length));
        }
        Module["ccall"] = ccall;
        Module["cwrap"] = cwrap;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        run();
        return moduleArg;
    };
})();
var $ceb5aadfac8b6a23$export$2e2bcd8739ae039 = $ceb5aadfac8b6a23$var$CrossModule;


"use strict";
var $cb0999f9945c1a39$var$crossModule = (0, $ceb5aadfac8b6a23$export$2e2bcd8739ae039)({});
var $cb0999f9945c1a39$var$fftCross = $cb0999f9945c1a39$var$crossModule.cwrap("fftCross", "void", [
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
]);
function $cb0999f9945c1a39$var$FFTCross(size) {
    this.size = size;
    this.n = size * 8;
    this.ptr = $cb0999f9945c1a39$var$crossModule._malloc(this.n * 4);
    this.ri = new Uint8Array($cb0999f9945c1a39$var$crossModule.HEAPU8.buffer, this.ptr, this.n);
    this.ii = new Uint8Array($cb0999f9945c1a39$var$crossModule.HEAPU8.buffer, this.ptr + this.n, this.n);
    this.transform = function(real, imag, inverse) {
        var ptr = this.ptr;
        var n = this.n;
        this.ri.set(new Uint8Array(real.buffer));
        this.ii.set(new Uint8Array(imag.buffer));
        $cb0999f9945c1a39$var$fftCross(this.size, inverse, ptr, ptr + n, ptr + n * 2, ptr + n * 3);
        var ro = new Float64Array($cb0999f9945c1a39$var$crossModule.HEAPU8.buffer, ptr + n * 2, this.size);
        var io = new Float64Array($cb0999f9945c1a39$var$crossModule.HEAPU8.buffer, ptr + n * 3, this.size);
        return {
            real: ro,
            imag: io
        };
    };
    this.dispose = function() {
        $cb0999f9945c1a39$var$crossModule._free(this.ptr);
    };
}
var $cb0999f9945c1a39$export$2e2bcd8739ae039 = $cb0999f9945c1a39$var$FFTCross;


class $344380f0e53c9fbc$var$CrossFftWrapperWasm {
    constructor(size){
        this.size = size;
        this.fftcross = new (0, $cb0999f9945c1a39$export$2e2bcd8739ae039)(size);
        this.real = new Float64Array(this.size);
        this.imag = new Float64Array(this.size);
    }
    fft(inputArr) {
        for(var i = 0; i < this.size; i++){
            this.real[i] = inputArr[2 * i];
            this.imag[i] = inputArr[2 * i + 1];
        }
        const out = this.fftcross.transform(this.real, this.imag, false);
        const outputArr = new Float32Array(2 * this.size);
        for(var i = 0; i < this.size; i++){
            outputArr[2 * i] = out.real[i];
            outputArr[2 * i + 1] = out.imag[i];
        }
        return outputArr;
    }
}
var $344380f0e53c9fbc$export$2e2bcd8739ae039 = $344380f0e53c9fbc$var$CrossFftWrapperWasm;


/*
 * Free FFT and convolution (JavaScript)
 *
 * Copyright (c) 2014 Project Nayuki
 * http://www.nayuki.io/page/free-small-fft-in-multiple-languages
 *
 * (MIT License)
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * - The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 * - The Software is provided "as is", without warranty of any kind, express or
 *   implied, including but not limited to the warranties of merchantability,
 *   fitness for a particular purpose and noninfringement. In no event shall the
 *   authors or copyright holders be liable for any claim, damages or other
 *   liability, whether in an action of contract, tort or otherwise, arising from,
 *   out of or in connection with the Software or the use or other dealings in the
 *   Software.
 *
 * Slightly restructured by Chris Cannam, cannam@all-day-breakfast.com
 */ "use strict";
/*
 * Construct an object for calculating the discrete Fourier transform (DFT) of size n, where n is a power of 2.
 */ function $508d2b67dc94a64d$var$FFTNayuki(n) {
    this.n = n;
    this.levels = -1;
    for(var i = 0; i < 32; i++)if (1 << i == n) this.levels = i; // Equal to log2(n)
    if (this.levels == -1) throw "Length is not a power of 2";
    this.cosTable = new Array(n / 2);
    this.sinTable = new Array(n / 2);
    for(var i = 0; i < n / 2; i++){
        this.cosTable[i] = Math.cos(2 * Math.PI * i / n);
        this.sinTable[i] = Math.sin(2 * Math.PI * i / n);
    }
    /*
   * Computes the discrete Fourier transform (DFT) of the given complex vector, storing the result back into the vector.
   * The vector's length must be equal to the size n that was passed to the object constructor, and this must be a power of 2. Uses the Cooley-Tukey decimation-in-time radix-2 algorithm.
   */ this.forward = function(real, imag) {
        var n = this.n;
        // Bit-reversed addressing permutation
        for(var i = 0; i < n; i++){
            var j = reverseBits(i, this.levels);
            if (j > i) {
                var temp = real[i];
                real[i] = real[j];
                real[j] = temp;
                temp = imag[i];
                imag[i] = imag[j];
                imag[j] = temp;
            }
        }
        // Cooley-Tukey decimation-in-time radix-2 FFT
        for(var size = 2; size <= n; size *= 2){
            var halfsize = size / 2;
            var tablestep = n / size;
            for(var i = 0; i < n; i += size)for(var j = i, k = 0; j < i + halfsize; j++, k += tablestep){
                var tpre = real[j + halfsize] * this.cosTable[k] + imag[j + halfsize] * this.sinTable[k];
                var tpim = -real[j + halfsize] * this.sinTable[k] + imag[j + halfsize] * this.cosTable[k];
                real[j + halfsize] = real[j] - tpre;
                imag[j + halfsize] = imag[j] - tpim;
                real[j] += tpre;
                imag[j] += tpim;
            }
        }
        // Returns the integer whose value is the reverse of the lowest 'bits' bits of the integer 'x'.
        function reverseBits(x, bits) {
            var y = 0;
            for(var i = 0; i < bits; i++){
                y = y << 1 | x & 1;
                x >>>= 1;
            }
            return y;
        }
    };
    /*
   * Computes the inverse discrete Fourier transform (IDFT) of the given complex vector, storing the result back into the vector.
   * The vector's length must be equal to the size n that was passed to the object constructor, and this must be a power of 2. This is a wrapper function. This transform does not perform scaling, so the inverse is not a true inverse.
   */ this.inverse = function(real, imag) {
        forward(imag, real);
    };
}
var $508d2b67dc94a64d$export$2e2bcd8739ae039 = $508d2b67dc94a64d$var$FFTNayuki;


class $3afa78de1adca6d4$var$NayukiFftWrapperJavascript {
    constructor(size){
        this.size = size;
        this.fftNayuki = new (0, $508d2b67dc94a64d$export$2e2bcd8739ae039)(size);
    }
    fft(inputArr) {
        // it uses the same buffer for input and output
        const real = new Float32Array(this.size);
        const imag = new Float32Array(this.size);
        const outputArr = new Float32Array(this.size * 2);
        for(var i = 0; i < this.size; ++i){
            real[i] = inputArr[i * 2];
            imag[i] = inputArr[i * 2 + 1];
        }
        this.fftNayuki.forward(real, imag); // this does the FFT, it uses the same buffer for input and output
        for(var i = 0; i < this.size; ++i){
            outputArr[i * 2] = real[i];
            outputArr[i * 2 + 1] = imag[i];
        }
        return outputArr;
    }
}
var $3afa78de1adca6d4$export$2e2bcd8739ae039 = $3afa78de1adca6d4$var$NayukiFftWrapperJavascript;


var $2ae81e664cee0237$var$NayukiCModule = (()=>{
    var _scriptDir = "file:///node_modules/webfft/lib/nayukic/NayukiCFFT.mjs";
    return function(moduleArg = {}) {
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject)=>{
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var wasmExports;
        var ABORT = false;
        var EXITSTATUS;
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        wasmBinaryFile = "data:application/octet-stream;base64,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";
        if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        function getBinarySync(file) {
            if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
            var binary = tryParseAsDataURI(file);
            if (binary) return binary;
            if (readBinary) return readBinary(file);
            throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function instantiateSync(file, info) {
            var module;
            var binary = getBinarySync(file);
            module = new WebAssembly.Module(binary);
            var instance = new WebAssembly.Instance(module, info);
            return [
                instance,
                module
            ];
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                wasmExports = exports;
                wasmMemory = wasmExports["b"];
                updateMemoryViews();
                wasmTable = wasmExports["l"];
                addOnInit(wasmExports["c"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            var result = instantiateSync(wasmBinaryFile, info);
            return receiveInstance(result[0]);
        }
        var callRuntimeCallbacks = (callbacks)=>{
            while(callbacks.length > 0)callbacks.shift()(Module);
        };
        var abortOnCannotGrowMemory = (requestedSize)=>{
            abort("OOM");
        };
        var _emscripten_resize_heap = (requestedSize)=>{
            var oldSize = HEAPU8.length;
            requestedSize >>>= 0;
            abortOnCannotGrowMemory(requestedSize);
        };
        function getCFunc(ident) {
            var func = Module["_" + ident];
            return func;
        }
        var writeArrayToMemory = (array, buffer)=>{
            HEAP8.set(array, buffer);
        };
        var lengthBytesUTF8 = (str)=>{
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        var stringToUTF8OnStack = (str)=>{
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
        };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
            var str = "";
            while(idx < endPtr){
                var u0 = heapOrArray[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heapOrArray[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = heapOrArray[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
            return str;
        };
        var UTF8ToString = (ptr, maxBytesToRead)=>ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        var ccall = function(ident, returnType, argTypes, args, opts) {
            var toC = {
                "string": (str)=>{
                    var ret = 0;
                    if (str !== null && str !== undefined && str !== 0) ret = stringToUTF8OnStack(str);
                    return ret;
                },
                "array": (arr)=>{
                    var ret = stackAlloc(arr.length);
                    writeArrayToMemory(arr, ret);
                    return ret;
                }
            };
            function convertReturnValue(ret) {
                if (returnType === "string") return UTF8ToString(ret);
                if (returnType === "boolean") return Boolean(ret);
                return ret;
            }
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            if (args) for(var i = 0; i < args.length; i++){
                var converter = toC[argTypes[i]];
                if (converter) {
                    if (stack === 0) stack = stackSave();
                    cArgs[i] = converter(args[i]);
                } else cArgs[i] = args[i];
            }
            var ret = func.apply(null, cArgs);
            function onDone(ret) {
                if (stack !== 0) stackRestore(stack);
                return convertReturnValue(ret);
            }
            ret = onDone(ret);
            return ret;
        };
        var cwrap = function(ident, returnType, argTypes, opts) {
            var numericArgs = !argTypes || argTypes.every((type)=>type === "number" || type === "boolean");
            var numericRet = returnType !== "string";
            if (numericRet && numericArgs && !opts) return getCFunc(ident);
            return function() {
                return ccall(ident, returnType, argTypes, arguments, opts);
            };
        };
        var wasmImports = {
            a: _emscripten_resize_heap
        };
        var asm = createWasm();
        var ___wasm_call_ctors = asm["c"];
        var _malloc = Module["_malloc"] = asm["d"];
        var _free = Module["_free"] = asm["e"];
        var _precalc = Module["_precalc"] = asm["f"];
        var _precalc_f = Module["_precalc_f"] = asm["g"];
        var _dispose = Module["_dispose"] = asm["h"];
        var _dispose_f = Module["_dispose_f"] = asm["i"];
        var _transform_radix2_precalc = Module["_transform_radix2_precalc"] = asm["j"];
        var _transform_radix2_precalc_f = Module["_transform_radix2_precalc_f"] = asm["k"];
        var ___errno_location = asm["__errno_location"];
        var stackSave = asm["m"];
        var stackRestore = asm["n"];
        var stackAlloc = asm["o"];
        function intArrayFromBase64(s) {
            try {
                var decoded = atob(s);
                var bytes = new Uint8Array(decoded.length);
                for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
                return bytes;
            } catch (_) {
                throw new Error("Converting base64 string to bytes failed.");
            }
        }
        function tryParseAsDataURI(filename) {
            if (!isDataURI(filename)) return;
            return intArrayFromBase64(filename.slice(dataURIPrefix.length));
        }
        Module["ccall"] = ccall;
        Module["cwrap"] = cwrap;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        run();
        return moduleArg;
    };
})();
var $2ae81e664cee0237$export$2e2bcd8739ae039 = $2ae81e664cee0237$var$NayukiCModule;


"use strict";
var $c86b0d7cac57b334$var$nayukiCModule = (0, $2ae81e664cee0237$export$2e2bcd8739ae039)({});
var $c86b0d7cac57b334$var$nc_precalc = $c86b0d7cac57b334$var$nayukiCModule.cwrap("precalc", "number", [
    "number"
]);
var $c86b0d7cac57b334$var$nc_dispose = $c86b0d7cac57b334$var$nayukiCModule.cwrap("dispose", "void", [
    "number"
]);
var $c86b0d7cac57b334$var$nc_transform_radix2_precalc = $c86b0d7cac57b334$var$nayukiCModule.cwrap("transform_radix2_precalc", "void", [
    "number",
    "number",
    "number",
    "number"
]);
var $c86b0d7cac57b334$var$nc_precalc_f = $c86b0d7cac57b334$var$nayukiCModule.cwrap("precalc_f", "number", [
    "number"
]);
var $c86b0d7cac57b334$var$nc_dispose_f = $c86b0d7cac57b334$var$nayukiCModule.cwrap("dispose_f", "void", [
    "number"
]);
var $c86b0d7cac57b334$var$nc_transform_radix2_precalc_f = $c86b0d7cac57b334$var$nayukiCModule.cwrap("transform_radix2_precalc_f", "void", [
    "number",
    "number",
    "number",
    "number"
]);
function $c86b0d7cac57b334$var$FFTNayukiC(n) {
    this.n = n;
    this.rptr = $c86b0d7cac57b334$var$nayukiCModule._malloc(n * 4 + n * 4);
    this.iptr = this.rptr + n * 4;
    this.rarr = new Float32Array($c86b0d7cac57b334$var$nayukiCModule.HEAPU8.buffer, this.rptr, n);
    this.iarr = new Float32Array($c86b0d7cac57b334$var$nayukiCModule.HEAPU8.buffer, this.iptr, n);
    this.tables = $c86b0d7cac57b334$var$nc_precalc_f(n);
    this.forward = function(real, imag) {
        this.rarr.set(real);
        this.iarr.set(imag);
        $c86b0d7cac57b334$var$nc_transform_radix2_precalc_f(this.rptr, this.iptr, this.n, this.tables);
        real.set(this.rarr);
        imag.set(this.iarr);
    };
    this.dispose = function() {
        $c86b0d7cac57b334$var$nayukiCModule._free(this.rptr);
        $c86b0d7cac57b334$var$nc_dispose_f(this.tables);
    };
}
var $c86b0d7cac57b334$export$2e2bcd8739ae039 = $c86b0d7cac57b334$var$FFTNayukiC;


class $85a7c385f342d95d$var$NayukiWasmFftWrapperWasm {
    constructor(size){
        this.size = size;
        this.fftNayuki = new (0, $c86b0d7cac57b334$export$2e2bcd8739ae039)(size);
    }
    fft(inputArr) {
        // it uses the same buffer for input and output
        const real = new Float32Array(this.size);
        const imag = new Float32Array(this.size);
        const outputArr = new Float32Array(this.size * 2);
        for(var i = 0; i < this.size; ++i){
            real[i] = inputArr[i * 2];
            imag[i] = inputArr[i * 2 + 1];
        }
        this.fftNayuki.forward(real, imag); // this does the FFT, it uses the same buffer for input and output
        for(var i = 0; i < this.size; ++i){
            outputArr[i * 2] = real[i];
            outputArr[i * 2 + 1] = imag[i];
        }
        return outputArr;
    }
}
var $85a7c385f342d95d$export$2e2bcd8739ae039 = $85a7c385f342d95d$var$NayukiWasmFftWrapperWasm;


/* Copyright (c) 2012, Jens Nockert <jens@ofmlabs.org>, Jussi Kalliokoski <jussi@ofmlabs.org>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ if (!$5fcaf388b8e37404$var$FFT) var $5fcaf388b8e37404$var$FFT = {};
(function(namespace) {
    "use strict";
    function butterfly2(output, outputOffset, outputStride, fStride, state, m) {
        var t = state.twiddle;
        for(var i = 0; i < m; i++){
            var s0_r = output[2 * (outputOffset + outputStride * i)], s0_i = output[2 * (outputOffset + outputStride * i) + 1];
            var s1_r = output[2 * (outputOffset + outputStride * (i + m))], s1_i = output[2 * (outputOffset + outputStride * (i + m)) + 1];
            var t1_r = t[2 * (0 + fStride * i)], t1_i = t[2 * (0 + fStride * i) + 1];
            var v1_r = s1_r * t1_r - s1_i * t1_i, v1_i = s1_r * t1_i + s1_i * t1_r;
            var r0_r = s0_r + v1_r, r0_i = s0_i + v1_i;
            var r1_r = s0_r - v1_r, r1_i = s0_i - v1_i;
            output[2 * (outputOffset + outputStride * i)] = r0_r, output[2 * (outputOffset + outputStride * i) + 1] = r0_i;
            output[2 * (outputOffset + outputStride * (i + m))] = r1_r, output[2 * (outputOffset + outputStride * (i + m)) + 1] = r1_i;
        }
    }
    function butterfly3(output, outputOffset, outputStride, fStride, state, m) {
        var t = state.twiddle;
        var m1 = m, m2 = 2 * m;
        var fStride1 = fStride, fStride2 = 2 * fStride;
        var e = t[2 * (0 + fStride * m) + 1];
        for(var i = 0; i < m; i++){
            var s0_r = output[2 * (outputOffset + outputStride * i)], s0_i = output[2 * (outputOffset + outputStride * i) + 1];
            var s1_r = output[2 * (outputOffset + outputStride * (i + m1))], s1_i = output[2 * (outputOffset + outputStride * (i + m1)) + 1];
            var t1_r = t[2 * (0 + fStride1 * i)], t1_i = t[2 * (0 + fStride1 * i) + 1];
            var v1_r = s1_r * t1_r - s1_i * t1_i, v1_i = s1_r * t1_i + s1_i * t1_r;
            var s2_r = output[2 * (outputOffset + outputStride * (i + m2))], s2_i = output[2 * (outputOffset + outputStride * (i + m2)) + 1];
            var t2_r = t[2 * (0 + fStride2 * i)], t2_i = t[2 * (0 + fStride2 * i) + 1];
            var v2_r = s2_r * t2_r - s2_i * t2_i, v2_i = s2_r * t2_i + s2_i * t2_r;
            var i0_r = v1_r + v2_r, i0_i = v1_i + v2_i;
            var r0_r = s0_r + i0_r, r0_i = s0_i + i0_i;
            output[2 * (outputOffset + outputStride * i)] = r0_r, output[2 * (outputOffset + outputStride * i) + 1] = r0_i;
            var i1_r = s0_r - i0_r * 0.5;
            var i1_i = s0_i - i0_i * 0.5;
            var i2_r = (v1_r - v2_r) * e;
            var i2_i = (v1_i - v2_i) * e;
            var r1_r = i1_r - i2_i;
            var r1_i = i1_i + i2_r;
            output[2 * (outputOffset + outputStride * (i + m1))] = r1_r, output[2 * (outputOffset + outputStride * (i + m1)) + 1] = r1_i;
            var r2_r = i1_r + i2_i;
            var r2_i = i1_i - i2_r;
            output[2 * (outputOffset + outputStride * (i + m2))] = r2_r, output[2 * (outputOffset + outputStride * (i + m2)) + 1] = r2_i;
        }
    }
    function butterfly4(output, outputOffset, outputStride, fStride, state, m) {
        var t = state.twiddle;
        var m1 = m, m2 = 2 * m, m3 = 3 * m;
        var fStride1 = fStride, fStride2 = 2 * fStride, fStride3 = 3 * fStride;
        for(var i = 0; i < m; i++){
            var s0_r = output[2 * (outputOffset + outputStride * i)], s0_i = output[2 * (outputOffset + outputStride * i) + 1];
            var s1_r = output[2 * (outputOffset + outputStride * (i + m1))], s1_i = output[2 * (outputOffset + outputStride * (i + m1)) + 1];
            var t1_r = t[2 * (0 + fStride1 * i)], t1_i = t[2 * (0 + fStride1 * i) + 1];
            var v1_r = s1_r * t1_r - s1_i * t1_i, v1_i = s1_r * t1_i + s1_i * t1_r;
            var s2_r = output[2 * (outputOffset + outputStride * (i + m2))], s2_i = output[2 * (outputOffset + outputStride * (i + m2)) + 1];
            var t2_r = t[2 * (0 + fStride2 * i)], t2_i = t[2 * (0 + fStride2 * i) + 1];
            var v2_r = s2_r * t2_r - s2_i * t2_i, v2_i = s2_r * t2_i + s2_i * t2_r;
            var s3_r = output[2 * (outputOffset + outputStride * (i + m3))], s3_i = output[2 * (outputOffset + outputStride * (i + m3)) + 1];
            var t3_r = t[2 * (0 + fStride3 * i)], t3_i = t[2 * (0 + fStride3 * i) + 1];
            var v3_r = s3_r * t3_r - s3_i * t3_i, v3_i = s3_r * t3_i + s3_i * t3_r;
            var i0_r = s0_r + v2_r, i0_i = s0_i + v2_i;
            var i1_r = s0_r - v2_r, i1_i = s0_i - v2_i;
            var i2_r = v1_r + v3_r, i2_i = v1_i + v3_i;
            var i3_r = v1_r - v3_r, i3_i = v1_i - v3_i;
            var r0_r = i0_r + i2_r, r0_i = i0_i + i2_i;
            if (state.inverse) {
                var r1_r = i1_r - i3_i;
                var r1_i = i1_i + i3_r;
            } else {
                var r1_r = i1_r + i3_i;
                var r1_i = i1_i - i3_r;
            }
            var r2_r = i0_r - i2_r, r2_i = i0_i - i2_i;
            if (state.inverse) {
                var r3_r = i1_r + i3_i;
                var r3_i = i1_i - i3_r;
            } else {
                var r3_r = i1_r - i3_i;
                var r3_i = i1_i + i3_r;
            }
            output[2 * (outputOffset + outputStride * i)] = r0_r, output[2 * (outputOffset + outputStride * i) + 1] = r0_i;
            output[2 * (outputOffset + outputStride * (i + m1))] = r1_r, output[2 * (outputOffset + outputStride * (i + m1)) + 1] = r1_i;
            output[2 * (outputOffset + outputStride * (i + m2))] = r2_r, output[2 * (outputOffset + outputStride * (i + m2)) + 1] = r2_i;
            output[2 * (outputOffset + outputStride * (i + m3))] = r3_r, output[2 * (outputOffset + outputStride * (i + m3)) + 1] = r3_i;
        }
    }
    function butterfly(output, outputOffset, outputStride, fStride, state, m, p) {
        var t = state.twiddle, n = state.n, scratch = new Float64Array(2 * p);
        for(var u = 0; u < m; u++){
            for(var q1 = 0, k = u; q1 < p; q1++, k += m){
                var x0_r = output[2 * (outputOffset + outputStride * k)], x0_i = output[2 * (outputOffset + outputStride * k) + 1];
                scratch[2 * q1] = x0_r, scratch[2 * q1 + 1] = x0_i;
            }
            for(var q1 = 0, k = u; q1 < p; q1++, k += m){
                var tOffset = 0;
                var x0_r = scratch[0], x0_i = scratch[1];
                output[2 * (outputOffset + outputStride * k)] = x0_r, output[2 * (outputOffset + outputStride * k) + 1] = x0_i;
                for(var q = 1; q < p; q++){
                    tOffset = (tOffset + fStride * k) % n;
                    var s0_r = output[2 * (outputOffset + outputStride * k)], s0_i = output[2 * (outputOffset + outputStride * k) + 1];
                    var s1_r = scratch[2 * q], s1_i = scratch[2 * q + 1];
                    var t1_r = t[2 * tOffset], t1_i = t[2 * tOffset + 1];
                    var v1_r = s1_r * t1_r - s1_i * t1_i, v1_i = s1_r * t1_i + s1_i * t1_r;
                    var r0_r = s0_r + v1_r, r0_i = s0_i + v1_i;
                    output[2 * (outputOffset + outputStride * k)] = r0_r, output[2 * (outputOffset + outputStride * k) + 1] = r0_i;
                }
            }
        }
    }
    function work(output, outputOffset, outputStride, f, fOffset, fStride, inputStride, factors, state) {
        var p = factors.shift();
        var m = factors.shift();
        if (m == 1) for(var i = 0; i < p * m; i++){
            var x0_r = f[2 * (fOffset + fStride * inputStride * i)], x0_i = f[2 * (fOffset + fStride * inputStride * i) + 1];
            output[2 * (outputOffset + outputStride * i)] = x0_r, output[2 * (outputOffset + outputStride * i) + 1] = x0_i;
        }
        else for(var i = 0; i < p; i++)work(output, outputOffset + outputStride * i * m, outputStride, f, fOffset + i * fStride * inputStride, fStride * p, inputStride, factors.slice(), state);
        switch(p){
            case 2:
                butterfly2(output, outputOffset, outputStride, fStride, state, m);
                break;
            case 3:
                butterfly3(output, outputOffset, outputStride, fStride, state, m);
                break;
            case 4:
                butterfly4(output, outputOffset, outputStride, fStride, state, m);
                break;
            default:
                butterfly(output, outputOffset, outputStride, fStride, state, m, p);
                break;
        }
    }
    var complex = function(n, inverse) {
        if (arguments.length < 2) throw new RangeError("You didn't pass enough arguments, passed `" + arguments.length + "'");
        var n = ~~n, inverse = !!inverse;
        if (n < 1) throw new RangeError("n is outside range, should be positive integer, was `" + n + "'");
        var state = {
            n: n,
            inverse: inverse,
            factors: [],
            twiddle: new Float64Array(2 * n),
            scratch: new Float64Array(2 * n)
        };
        var t = state.twiddle, theta = 2 * Math.PI / n;
        for(var i = 0; i < n; i++){
            if (inverse) var phase = theta * i;
            else var phase = -theta * i;
            t[2 * i] = Math.cos(phase);
            t[2 * i + 1] = Math.sin(phase);
        }
        var p = 4, v = Math.floor(Math.sqrt(n));
        while(n > 1){
            while(n % p){
                switch(p){
                    case 4:
                        p = 2;
                        break;
                    case 2:
                        p = 3;
                        break;
                    default:
                        p += 2;
                        break;
                }
                if (p > v) p = n;
            }
            n /= p;
            state.factors.push(p);
            state.factors.push(n);
        }
        this.state = state;
    };
    complex.prototype.simple = function(output, input, t) {
        this.process(output, 0, 1, input, 0, 1, t);
    };
    complex.prototype.process = function(output, outputOffset, outputStride, input, inputOffset, inputStride, t) {
        var outputStride = ~~outputStride, inputStride = ~~inputStride;
        var type = t == "real" ? t : "complex";
        if (outputStride < 1) throw new RangeError("outputStride is outside range, should be positive integer, was `" + outputStride + "'");
        if (inputStride < 1) throw new RangeError("inputStride is outside range, should be positive integer, was `" + inputStride + "'");
        if (type == "real") {
            for(var i = 0; i < this.state.n; i++){
                var x0_r = input[inputOffset + inputStride * i];
                var x0_i = 0.0;
                this.state.scratch[2 * i] = x0_r, this.state.scratch[2 * i + 1] = x0_i;
            }
            work(output, outputOffset, outputStride, this.state.scratch, 0, 1, 1, this.state.factors.slice(), this.state);
        } else if (input == output) {
            work(this.state.scratch, 0, 1, input, inputOffset, 1, inputStride, this.state.factors.slice(), this.state);
            for(var i = 0; i < this.state.n; i++){
                var x0_r = this.state.scratch[2 * i], x0_i = this.state.scratch[2 * i + 1];
                output[2 * (outputOffset + outputStride * i)] = x0_r, output[2 * (outputOffset + outputStride * i) + 1] = x0_i;
            }
        } else work(output, outputOffset, outputStride, input, inputOffset, 1, inputStride, this.state.factors.slice(), this.state);
    };
    namespace.complex = complex;
})($5fcaf388b8e37404$var$FFT);
var $5fcaf388b8e37404$export$2e2bcd8739ae039 = $5fcaf388b8e37404$var$FFT;


class $e5c0fc9409981cd9$var$NockertFftWrapperJavascript {
    constructor(size){
        this.size = size;
        this.nockertfft = new (0, $5fcaf388b8e37404$export$2e2bcd8739ae039).complex(size, false); // 2nd arg is for inverse
    }
    fft(inputArr) {
        const outputArr = new Float32Array(2 * this.size);
        this.nockertfft.simple(outputArr, inputArr, "complex");
        return outputArr;
    }
}
var $e5c0fc9409981cd9$export$2e2bcd8739ae039 = $e5c0fc9409981cd9$var$NockertFftWrapperJavascript;


// core operations
let $b6e578541c07c094$var$_n = 0; // order
let $b6e578541c07c094$var$_bitrev = null; // bit reversal table
let $b6e578541c07c094$var$_cstb = null; // sin/cos table
function $b6e578541c07c094$var$init(n) {
    if (n !== 0 && (n & n - 1) === 0) {
        $b6e578541c07c094$var$_n = n;
        $b6e578541c07c094$var$_initArray();
        $b6e578541c07c094$var$_makeBitReversalTable();
        $b6e578541c07c094$var$_makeCosSinTable();
    } else throw new Error("init: radix-2 required");
}
// 1D-FFT
function $b6e578541c07c094$var$fft1d(re, im) {
    $b6e578541c07c094$var$fastFourierTransform(re, im, 1);
}
// 1D-IFFT
function $b6e578541c07c094$var$ifft1d(re, im) {
    let n = 1 / $b6e578541c07c094$var$_n;
    $b6e578541c07c094$var$fastFourierTransform(re, im, -1);
    for(let i = 0; i < $b6e578541c07c094$var$_n; i++){
        re[i] *= n;
        im[i] *= n;
    }
}
// 1D-IFFT
function $b6e578541c07c094$var$bt1d(re, im) {
    $b6e578541c07c094$var$fastFourierTransform(re, im, -1);
}
// 2D-FFT Not very useful if the number of rows have to be equal to cols
function $b6e578541c07c094$var$fft2d(re, im) {
    let tre = [];
    let tim = [];
    let i = 0;
    // x-axis
    for(let y = 0; y < $b6e578541c07c094$var$_n; y++){
        i = y * $b6e578541c07c094$var$_n;
        for(let x1 = 0; x1 < $b6e578541c07c094$var$_n; x1++){
            tre[x1] = re[x1 + i];
            tim[x1] = im[x1 + i];
        }
        $b6e578541c07c094$var$fft1d(tre, tim);
        for(let x2 = 0; x2 < $b6e578541c07c094$var$_n; x2++){
            re[x2 + i] = tre[x2];
            im[x2 + i] = tim[x2];
        }
    }
    // y-axis
    for(let x = 0; x < $b6e578541c07c094$var$_n; x++){
        for(let y1 = 0; y1 < $b6e578541c07c094$var$_n; y1++){
            i = x + y1 * $b6e578541c07c094$var$_n;
            tre[y1] = re[i];
            tim[y1] = im[i];
        }
        $b6e578541c07c094$var$fft1d(tre, tim);
        for(let y2 = 0; y2 < $b6e578541c07c094$var$_n; y2++){
            i = x + y2 * $b6e578541c07c094$var$_n;
            re[i] = tre[y2];
            im[i] = tim[y2];
        }
    }
}
// 2D-IFFT
function $b6e578541c07c094$var$ifft2d(re, im) {
    let tre = [];
    let tim = [];
    let i = 0;
    // x-axis
    for(let y = 0; y < $b6e578541c07c094$var$_n; y++){
        i = y * $b6e578541c07c094$var$_n;
        for(let x1 = 0; x1 < $b6e578541c07c094$var$_n; x1++){
            tre[x1] = re[x1 + i];
            tim[x1] = im[x1 + i];
        }
        $b6e578541c07c094$var$ifft1d(tre, tim);
        for(let x2 = 0; x2 < $b6e578541c07c094$var$_n; x2++){
            re[x2 + i] = tre[x2];
            im[x2 + i] = tim[x2];
        }
    }
    // y-axis
    for(let x = 0; x < $b6e578541c07c094$var$_n; x++){
        for(let y1 = 0; y1 < $b6e578541c07c094$var$_n; y1++){
            i = x + y1 * $b6e578541c07c094$var$_n;
            tre[y1] = re[i];
            tim[y1] = im[i];
        }
        $b6e578541c07c094$var$ifft1d(tre, tim);
        for(let y2 = 0; y2 < $b6e578541c07c094$var$_n; y2++){
            i = x + y2 * $b6e578541c07c094$var$_n;
            re[i] = tre[y2];
            im[i] = tim[y2];
        }
    }
}
// core operation of FFT
function $b6e578541c07c094$var$fastFourierTransform(re, im, inv) {
    let d;
    let h;
    let ik;
    let m;
    let tmp;
    let wr;
    let wi;
    let xr;
    let xi;
    let n4 = $b6e578541c07c094$var$_n >> 2;
    // bit reversal
    for(let l = 0; l < $b6e578541c07c094$var$_n; l++){
        m = $b6e578541c07c094$var$_bitrev[l];
        if (l < m) {
            tmp = re[l];
            re[l] = re[m];
            re[m] = tmp;
            tmp = im[l];
            im[l] = im[m];
            im[m] = tmp;
        }
    }
    // butterfly operation
    for(let k = 1; k < $b6e578541c07c094$var$_n; k <<= 1){
        h = 0;
        d = $b6e578541c07c094$var$_n / (k << 1);
        for(let j = 0; j < k; j++){
            wr = $b6e578541c07c094$var$_cstb[h + n4];
            wi = inv * $b6e578541c07c094$var$_cstb[h];
            for(let i = j; i < $b6e578541c07c094$var$_n; i += k << 1){
                ik = i + k;
                xr = wr * re[ik] + wi * im[ik];
                xi = wr * im[ik] - wi * re[ik];
                re[ik] = re[i] - xr;
                re[i] += xr;
                im[ik] = im[i] - xi;
                im[i] += xi;
            }
            h += d;
        }
    }
}
// initialize the array (supports TypedArray)
function $b6e578541c07c094$var$_initArray() {
    if (typeof Uint32Array !== "undefined") $b6e578541c07c094$var$_bitrev = new Uint32Array($b6e578541c07c094$var$_n);
    else $b6e578541c07c094$var$_bitrev = [];
    if (typeof Float64Array !== "undefined") $b6e578541c07c094$var$_cstb = new Float64Array($b6e578541c07c094$var$_n * 1.25);
    else $b6e578541c07c094$var$_cstb = [];
}
//function _paddingZero() {
//    // TODO
//}
function $b6e578541c07c094$var$_makeBitReversalTable() {
    let i = 0;
    let j = 0;
    let k = 0;
    $b6e578541c07c094$var$_bitrev[0] = 0;
    while(++i < $b6e578541c07c094$var$_n){
        k = $b6e578541c07c094$var$_n >> 1;
        while(k <= j){
            j -= k;
            k >>= 1;
        }
        j += k;
        $b6e578541c07c094$var$_bitrev[i] = j;
    }
}
// makes trigonometric function table
function $b6e578541c07c094$var$_makeCosSinTable() {
    let n2 = $b6e578541c07c094$var$_n >> 1;
    let n4 = $b6e578541c07c094$var$_n >> 2;
    let n8 = $b6e578541c07c094$var$_n >> 3;
    let n2p4 = n2 + n4;
    let t = Math.sin(Math.PI / $b6e578541c07c094$var$_n);
    let dc = 2 * t * t;
    let ds = Math.sqrt(dc * (2 - dc));
    let c = $b6e578541c07c094$var$_cstb[n4] = 1;
    let s = $b6e578541c07c094$var$_cstb[0] = 0;
    t = 2 * dc;
    for(let i = 1; i < n8; i++){
        c -= dc;
        dc += t * c;
        s += ds;
        ds -= t * s;
        $b6e578541c07c094$var$_cstb[i] = s;
        $b6e578541c07c094$var$_cstb[n4 - i] = c;
    }
    if (n8 !== 0) $b6e578541c07c094$var$_cstb[n8] = Math.sqrt(0.5);
    for(let j = 0; j < n4; j++)$b6e578541c07c094$var$_cstb[n2 - j] = $b6e578541c07c094$var$_cstb[j];
    for(let k = 0; k < n2p4; k++)$b6e578541c07c094$var$_cstb[k + n2] = -$b6e578541c07c094$var$_cstb[k];
}
const $b6e578541c07c094$var$FFT = {
    init: $b6e578541c07c094$var$init,
    fft1d: $b6e578541c07c094$var$fft1d,
    ifft1d: $b6e578541c07c094$var$ifft1d,
    fft2d: $b6e578541c07c094$var$fft2d,
    ifft2d: $b6e578541c07c094$var$ifft2d,
    fft: $b6e578541c07c094$var$fft1d,
    ifft: $b6e578541c07c094$var$ifft1d,
    bt: $b6e578541c07c094$var$bt1d
};
var $b6e578541c07c094$export$2e2bcd8739ae039 = $b6e578541c07c094$var$FFT;


class $68127b33286950f9$var$MljsWebFftWrapperJavascript {
    constructor(size){
        this.size = size;
        this.FFT_mljs = (0, $b6e578541c07c094$export$2e2bcd8739ae039);
        this.FFT_mljs.init(size);
    }
    fft(inputArr) {
        const input_real = new Float32Array(this.size);
        const input_imag = new Float32Array(this.size);
        const outputArr = new Float32Array(2 * this.size);
        for(var i = 0; i < this.size; ++i){
            input_real[i] = inputArr[i * 2];
            input_imag[i] = inputArr[i * 2 + 1];
        }
        this.FFT_mljs.fft(input_real, input_imag); // performs fft in-place
        for(var i = 0; i < this.size; ++i){
            outputArr[i * 2] = input_real[i];
            outputArr[i * 2 + 1] = input_imag[i];
        }
        return outputArr;
    }
}
var $68127b33286950f9$export$2e2bcd8739ae039 = $68127b33286950f9$var$MljsWebFftWrapperJavascript;


// The following SIMD checkers were taken from 'wasm-feature-detect' NPM package:
async function $f61b772ddace0c47$var$relaxedSimd() {
    return await WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        15,
        1,
        13,
        0,
        65,
        1,
        253,
        15,
        65,
        2,
        253,
        15,
        253,
        128,
        2,
        11
    ]));
}
async function $f61b772ddace0c47$var$simd() {
    return await WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));
}
// Define the async function to check for Wasm and SIMD support
async function $f61b772ddace0c47$var$checkBrowserCapabilities() {
    let browserName = "Other";
    let browserVersion = "Unknown";
    let osName = "Other";
    let osVersion = "Unknown";
    let uad = navigator.userAgentData;
    let ua = navigator.userAgent;
    // Check if Edge, Chrome, or Opera (uses User Agent Data API)
    try {
        if (uad) {
            const values = await uad.getHighEntropyValues([
                "architecture",
                "model",
                "platform",
                "platformVersion",
                "uaFullVersion"
            ]);
            const brandInfo = uad.brands.find((brand)=>[
                    "Microsoft Edge",
                    "Google Chrome",
                    "Opera"
                ].includes(brand.brand));
            browserName = brandInfo ? brandInfo.brand : "Other";
            browserVersion = brandInfo ? `v${brandInfo.version}` : "Unknown";
            osName = values.platform ? values.platform : "Other";
            osVersion = values.platformVersion ? `v${values.platformVersion}` : "Unknown";
        }
        // user agent string parsing for mobile and firefox, safari
        // other browsers included in case mobile
        if (browserName === "Other" || osName === "Other") {
            const uaArr = ua.split(" ");
            const uaBrowser = uaArr[uaArr.length - 1];
            const isFirefox = /Firefox/.test(uaBrowser);
            // CriOS is Chrome for iOS and Chrome is Chrome for Android
            const isSafari = /Safari/.test(uaBrowser) && !/CriOS/.test(uaBrowser) && !/Chrome/.test(uaBrowser);
            const isChrome = /CriOS/.test(uaBrowser) || /Chrome/.test(uaBrowser);
            const isEdge = /Edg/.test(uaBrowser);
            const isOpera = /OPR/.test(uaBrowser);
            const browsers = [
                {
                    name: "Mozilla Firefox",
                    regex: /Firefox\/(\d+\.\d+)/,
                    flag: isFirefox
                },
                {
                    name: "Safari",
                    regex: /Version\/(\d+\.\d+)/,
                    flag: isSafari
                },
                {
                    name: "Google Chrome",
                    regex: /CriOS|Chrome\/(\d+\.\d+)/,
                    flag: isChrome
                },
                {
                    name: "Microsoft Edge",
                    regex: /Edg\/(\d+\.\d+)/,
                    flag: isEdge
                },
                {
                    name: "Opera",
                    regex: /OPR\/(\d+\.\d+)/,
                    flag: isOpera
                }
            ];
            for (const browser of browsers)if (browser.flag) {
                browserName = browser.name;
                const versionMatch = uaBrowser.match(browser.regex);
                browserVersion = versionMatch ? versionMatch[1] : "Unknown";
                break;
            }
            const osMatch = ua.match(/\(([^)]+)\)/);
            const osDetails = osMatch ? osMatch[1].split("; ") : [];
            console.log(osMatch);
            console.log(osDetails);
            const windowsVersionMap = {
                "10.0": "10",
                "6.3": "8.1",
                "6.2": "8",
                "6.1": "7",
                "6.0": "Vista",
                "5.2": "XP 64-bit",
                "5.1": "XP",
                "5.0": "2000"
            };
            const osInfo = [
                {
                    name: "Windows",
                    regex: /Windows NT/,
                    transform: (s)=>windowsVersionMap[s.split(" ")[2]],
                    index: 0
                },
                {
                    name: "Mac OS X",
                    regex: /Mac OS X/,
                    transform: (s)=>s.replace("_", ".").split(" ")[3],
                    index: 0
                },
                {
                    name: "Linux",
                    regex: /Linux/,
                    transform: ()=>"Unknown",
                    index: 0
                },
                {
                    name: "Android",
                    regex: /Android/,
                    transform: (s)=>s.split(" ")[1],
                    index: 0
                },
                {
                    name: "iOS",
                    regex: /iPhone/,
                    transform: (s)=>s.split(" ")[1].replace("_", "."),
                    index: 0
                }
            ];
            for (const os of osInfo)if (os.regex.test(osDetails[0])) {
                osName = os.name;
                console.log(`osDetails: ${osDetails}`);
                osVersion = os.transform ? os.transform(osDetails[1]) : os.versionMap[osDetails[1].split(" ")[os.index]];
                break;
            }
        }
    } catch (error) {
        console.error("Could not retrieve user agent data", error);
    }
    return {
        browserName: browserName,
        browserVersion: browserVersion,
        osName: osName,
        osVersion: osVersion,
        wasm: typeof WebAssembly === "object",
        relaxedSimd: await $f61b772ddace0c47$var$relaxedSimd(),
        simd: await $f61b772ddace0c47$var$simd()
    };
}
var // Export the function
$f61b772ddace0c47$export$2e2bcd8739ae039 = $f61b772ddace0c47$var$checkBrowserCapabilities;


var $14a5beb75050840c$var$KissFFTModule = (()=>{
    var _scriptDir = "file:///node_modules/webfft/lib/kissfftmodified/KissFFT.mjs";
    return function(moduleArg = {}) {
        var Module = moduleArg;
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise((resolve, reject)=>{
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest;
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.error.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var wasmExports;
        var ABORT = false;
        var EXITSTATUS;
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        wasmBinaryFile = "data:application/octet-stream;base64,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";
        if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        function getBinarySync(file) {
            if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
            var binary = tryParseAsDataURI(file);
            if (binary) return binary;
            if (readBinary) return readBinary(file);
            throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function instantiateSync(file, info) {
            var module;
            var binary = getBinarySync(file);
            module = new WebAssembly.Module(binary);
            var instance = new WebAssembly.Instance(module, info);
            return [
                instance,
                module
            ];
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                wasmExports = exports;
                wasmMemory = wasmExports["b"];
                updateMemoryViews();
                wasmTable = wasmExports["i"];
                addOnInit(wasmExports["c"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            var result = instantiateSync(wasmBinaryFile, info);
            return receiveInstance(result[0]);
        }
        var callRuntimeCallbacks = (callbacks)=>{
            while(callbacks.length > 0)callbacks.shift()(Module);
        };
        var abortOnCannotGrowMemory = (requestedSize)=>{
            abort("OOM");
        };
        var _emscripten_resize_heap = (requestedSize)=>{
            var oldSize = HEAPU8.length;
            requestedSize >>>= 0;
            abortOnCannotGrowMemory(requestedSize);
        };
        function getCFunc(ident) {
            var func = Module["_" + ident];
            return func;
        }
        var writeArrayToMemory = (array, buffer)=>{
            HEAP8.set(array, buffer);
        };
        var lengthBytesUTF8 = (str)=>{
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        };
        var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        };
        var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        var stringToUTF8OnStack = (str)=>{
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
        };
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : undefined;
        var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
            var str = "";
            while(idx < endPtr){
                var u0 = heapOrArray[idx++];
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                var u1 = heapOrArray[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                var u2 = heapOrArray[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
            return str;
        };
        var UTF8ToString = (ptr, maxBytesToRead)=>ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        var ccall = function(ident, returnType, argTypes, args, opts) {
            var toC = {
                "string": (str)=>{
                    var ret = 0;
                    if (str !== null && str !== undefined && str !== 0) ret = stringToUTF8OnStack(str);
                    return ret;
                },
                "array": (arr)=>{
                    var ret = stackAlloc(arr.length);
                    writeArrayToMemory(arr, ret);
                    return ret;
                }
            };
            function convertReturnValue(ret) {
                if (returnType === "string") return UTF8ToString(ret);
                if (returnType === "boolean") return Boolean(ret);
                return ret;
            }
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            if (args) for(var i = 0; i < args.length; i++){
                var converter = toC[argTypes[i]];
                if (converter) {
                    if (stack === 0) stack = stackSave();
                    cArgs[i] = converter(args[i]);
                } else cArgs[i] = args[i];
            }
            var ret = func.apply(null, cArgs);
            function onDone(ret) {
                if (stack !== 0) stackRestore(stack);
                return convertReturnValue(ret);
            }
            ret = onDone(ret);
            return ret;
        };
        var cwrap = function(ident, returnType, argTypes, opts) {
            var numericArgs = !argTypes || argTypes.every((type)=>type === "number" || type === "boolean");
            var numericRet = returnType !== "string";
            if (numericRet && numericArgs && !opts) return getCFunc(ident);
            return function() {
                return ccall(ident, returnType, argTypes, arguments, opts);
            };
        };
        var wasmImports = {
            a: _emscripten_resize_heap
        };
        var asm = createWasm();
        var ___wasm_call_ctors = asm["c"];
        var _kiss_fft_free = Module["_kiss_fft_free"] = asm["d"];
        var _free = Module["_free"] = asm["e"];
        var _kiss_fft_alloc = Module["_kiss_fft_alloc"] = asm["f"];
        var _malloc = Module["_malloc"] = asm["g"];
        var _kiss_fft = Module["_kiss_fft"] = asm["h"];
        var ___errno_location = asm["__errno_location"];
        var stackSave = asm["j"];
        var stackRestore = asm["k"];
        var stackAlloc = asm["l"];
        function intArrayFromBase64(s) {
            try {
                var decoded = atob(s);
                var bytes = new Uint8Array(decoded.length);
                for(var i = 0; i < decoded.length; ++i)bytes[i] = decoded.charCodeAt(i);
                return bytes;
            } catch (_) {
                throw new Error("Converting base64 string to bytes failed.");
            }
        }
        function tryParseAsDataURI(filename) {
            if (!isDataURI(filename)) return;
            return intArrayFromBase64(filename.slice(dataURIPrefix.length));
        }
        Module["ccall"] = ccall;
        Module["cwrap"] = cwrap;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function run() {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        run();
        return moduleArg;
    };
})();
var $14a5beb75050840c$export$2e2bcd8739ae039 = $14a5beb75050840c$var$KissFFTModule;


"use strict";
var $9052da28056a1f9d$var$kissFFTModule = (0, $14a5beb75050840c$export$2e2bcd8739ae039)({});
var $9052da28056a1f9d$var$kiss_fft_alloc = $9052da28056a1f9d$var$kissFFTModule.cwrap("kiss_fft_alloc", "number", [
    "number",
    "number",
    "number",
    "number"
]);
var $9052da28056a1f9d$var$kiss_fft = $9052da28056a1f9d$var$kissFFTModule.cwrap("kiss_fft", "void", [
    "number",
    "number",
    "number"
]);
var $9052da28056a1f9d$var$kiss_fft_free = $9052da28056a1f9d$var$kissFFTModule.cwrap("kiss_fft_free", "void", [
    "number"
]);
class $9052da28056a1f9d$var$KissFftModifiedWrapperWasm {
    constructor(size){
        this.size = size;
        this.fcfg = $9052da28056a1f9d$var$kiss_fft_alloc(size, false);
        this.icfg = $9052da28056a1f9d$var$kiss_fft_alloc(size, true);
        this.inptr = $9052da28056a1f9d$var$kissFFTModule._malloc(size * 8 + size * 8);
        this.cin = new Float32Array($9052da28056a1f9d$var$kissFFTModule.HEAPU8.buffer, this.inptr, size * 2);
    }
    fft = function(inputArray) {
        // TODO: figure out how to move this into the constructor without breaking things (unit tests will catch it)
        const outptr = $9052da28056a1f9d$var$kissFFTModule._malloc(this.size * 8);
        const cout = new Float32Array($9052da28056a1f9d$var$kissFFTModule.HEAPU8.buffer, outptr, this.size * 2);
        this.cin.set(inputArray);
        $9052da28056a1f9d$var$kiss_fft(this.fcfg, this.inptr, outptr);
        // we need to free the memory of outptr before we return, so we need this too
        let outputArray = new Float32Array(this.size * 2);
        outputArray.set(cout);
        $9052da28056a1f9d$var$kissFFTModule._free(outptr);
        return outputArray;
    };
    dispose() {
        $9052da28056a1f9d$var$kiss_fft_free(this.fcfg);
        $9052da28056a1f9d$var$kiss_fft_free(this.icfg);
        $9052da28056a1f9d$var$kissFFTModule._free(this.inptr);
    }
}
var $9052da28056a1f9d$export$2e2bcd8739ae039 = $9052da28056a1f9d$var$KissFftModifiedWrapperWasm;


"use strict";
/* Modification Notes
- Removing the inv part increased it by 3% or so
- Simplifying transform hurt because i was repeating the same math
- getting rid of the wrapper imrpoved it by like 1%
*/ function $b511dcd5781ca5c6$var$IndutnyModifiedFftWrapperJavascript(size) {
    this.size = size;
    this._csize = size << 1;
    var table = new Array(this.size * 2);
    for(var i = 0; i < table.length; i += 2){
        const angle = Math.PI * i / this.size;
        table[i] = Math.cos(angle);
        table[i + 1] = -Math.sin(angle);
    }
    this.table = table;
    // Find size's power of two
    var power = 0;
    for(var t = 1; this.size > t; t <<= 1)power++;
    // Calculate initial step's width, either 4 or 8 depending on the fftsize
    this._width = power % 2 === 0 ? power - 1 : power;
    // Pre-compute bit-reversal patterns
    this._bitrev = new Array(1 << this._width);
    for(var j = 0; j < this._bitrev.length; j++){
        this._bitrev[j] = 0;
        for(var shift = 0; shift < this._width; shift += 2){
            var revShift = this._width - shift - 2;
            this._bitrev[j] |= (j >>> shift & 3) << revShift;
        }
    }
    this._data = null;
}
// FFT
$b511dcd5781ca5c6$var$IndutnyModifiedFftWrapperJavascript.prototype.fft = function fft(data) {
    this._data = data;
    this._out = new Float32Array(2 * this.size);
    var size = this._csize;
    // Initial step (permute and transform)
    var step = 1 << this._width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    // len is either 4 or 8, and both are used for the common fft sizes
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform2(outOff, off, step);
    }
    else for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform4(outOff, off, step);
    }
    // Loop through steps in decreasing order
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var quarterLen = len >>> 2;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len){
            // Full case
            var limit = outOff + quarterLen;
            for(var i = outOff, k = 0; i < limit; i += 2, k += step){
                const A = i;
                const B = A + quarterLen;
                const C = B + quarterLen;
                const D = C + quarterLen;
                // Original values
                const Ar = this._out[A];
                const Ai = this._out[A + 1];
                const Br = this._out[B];
                const Bi = this._out[B + 1];
                const Cr = this._out[C];
                const Ci = this._out[C + 1];
                const Dr = this._out[D];
                const Di = this._out[D + 1];
                // Middle values
                const MAr = Ar;
                const MAi = Ai;
                const tableBr = this.table[k];
                const tableBi = this.table[k + 1];
                const MBr = Br * tableBr - Bi * tableBi;
                const MBi = Br * tableBi + Bi * tableBr;
                const tableCr = this.table[2 * k];
                const tableCi = this.table[2 * k + 1];
                const MCr = Cr * tableCr - Ci * tableCi;
                const MCi = Cr * tableCi + Ci * tableCr;
                const tableDr = this.table[3 * k];
                const tableDi = this.table[3 * k + 1];
                const MDr = Dr * tableDr - Di * tableDi;
                const MDi = Dr * tableDi + Di * tableDr;
                // Pre-Final values
                const T0r = MAr + MCr;
                const T0i = MAi + MCi;
                const T1r = MAr - MCr;
                const T1i = MAi - MCi;
                const T2r = MBr + MDr;
                const T2i = MBi + MDi;
                const T3r = MBr - MDr;
                const T3i = MBi - MDi;
                this._out[A] = T0r + T2r;
                this._out[A + 1] = T0i + T2i;
                this._out[B] = T1r + T3i;
                this._out[B + 1] = T1i - T3r;
                this._out[C] = T0r - T2r;
                this._out[C + 1] = T0i - T2i;
                this._out[D] = T1r - T3i;
                this._out[D + 1] = T1i + T3r;
            }
        }
    }
    return this._out;
};
// radix-2 (called for len=4)
$b511dcd5781ca5c6$var$IndutnyModifiedFftWrapperJavascript.prototype._singleTransform2 = function _singleTransform2(outOff, off, step) {
    const evenR = this._data[off];
    const evenI = this._data[off + 1];
    const oddR = this._data[off + step];
    const oddI = this._data[off + step + 1];
    this._out[outOff] = evenR + oddR;
    this._out[outOff + 1] = evenI + oddI;
    this._out[outOff + 2] = evenR - oddR;
    this._out[outOff + 3] = evenI - oddI;
};
// radix-4 (called for len=8)
$b511dcd5781ca5c6$var$IndutnyModifiedFftWrapperJavascript.prototype._singleTransform4 = function _singleTransform4(outOff, off, step) {
    const step2 = step * 2;
    const step3 = step * 3;
    const Ar = this._data[off];
    const Ai = this._data[off + 1];
    const Br = this._data[off + step];
    const Bi = this._data[off + step + 1];
    const Cr = this._data[off + step2];
    const Ci = this._data[off + step2 + 1];
    const Dr = this._data[off + step3];
    const Di = this._data[off + step3 + 1];
    const T0r = Ar + Cr;
    const T0i = Ai + Ci;
    const T1r = Ar - Cr;
    const T1i = Ai - Ci;
    const T2r = Br + Dr;
    const T2i = Bi + Di;
    const T3r = Br - Dr;
    const T3i = Bi - Di;
    this._out[outOff] = T0r + T2r;
    this._out[outOff + 1] = T0i + T2i;
    this._out[outOff + 2] = T1r + T3i;
    this._out[outOff + 3] = T1i - T3r;
    this._out[outOff + 4] = T0r - T2r;
    this._out[outOff + 5] = T0i - T2i;
    this._out[outOff + 6] = T1r - T3i;
    this._out[outOff + 7] = T1i + T3r;
};
var $b511dcd5781ca5c6$export$2e2bcd8739ae039 = $b511dcd5781ca5c6$var$IndutnyModifiedFftWrapperJavascript;


const $304b9fcf638b77cf$var$validSizes = [
    4,
    8,
    16,
    32,
    64,
    128,
    256,
    512,
    1024,
    2048,
    4096,
    8192,
    16384,
    32768,
    16384,
    32768,
    65536,
    131072
];
class $304b9fcf638b77cf$var$webfft {
    constructor(size = 128, subLibrary = "indutnyJavascript", useProfile = true){
        if (!$304b9fcf638b77cf$var$validSizes.includes(size)) throw new Error("Size must be a power of 2 between 4 and 131072");
        this.size = size;
        this.outputArr = new Float32Array(2 * size);
        this.subLibrary = subLibrary;
        this.fftLibrary = undefined;
        const profile = this.getCurrentProfile();
        if (profile && useProfile) this.setSubLibrary(profile.fastestSubLibrary);
        else this.setSubLibrary(subLibrary);
    }
    availableSubLibraries() {
        return [
            "kissWasm",
            "indutnyModifiedJavascript",
            "indutnyJavascript",
            "crossWasm",
            "mljsJavascript",
            "nockertJavascript",
            "nayuki3Wasm",
            "nayukiJavascript",
            //"dntjJavascript", // need to figure out the precise scale factor before we can use this one, mainly due to unit tests
            "kissfftmodifiedWasm"
        ];
    }
    // A subset of the libraries known to be quickest, and removing ones that are too similar to others
    availableSubLibrariesQuick() {
        return [
            "kissWasm",
            "indutnyModifiedJavascript"
        ];
    }
    getCurrentProfile() {
        // check if local storage is available
        if (typeof localStorage === "undefined") return undefined;
        if (!localStorage.getItem("webfftProfile")) return undefined; // No profile
        return JSON.parse(localStorage.getItem("webfftProfile"));
    }
    setSubLibrary(subLibrary) {
        switch(subLibrary){
            case "nayukiJavascript":
                this.fftLibrary = new (0, $3afa78de1adca6d4$export$2e2bcd8739ae039)(this.size);
                break;
            case "nayuki3Wasm":
                this.fftLibrary = new (0, $85a7c385f342d95d$export$2e2bcd8739ae039)(this.size);
                break;
            case "kissWasm":
                this.fftLibrary = new (0, $e2b86b9f09fd2141$export$2e2bcd8739ae039)(this.size);
                break;
            case "crossWasm":
                this.fftLibrary = new (0, $344380f0e53c9fbc$export$2e2bcd8739ae039)(this.size);
                if (this.size > 16384) this.fftLibrary = new (0, $0a835dc3ef5a3230$export$2e2bcd8739ae039)(this.size); // Cross throws "memory access out of bounds" for large sizes\
                break;
            case "nockertJavascript":
                this.fftLibrary = new (0, $e5c0fc9409981cd9$export$2e2bcd8739ae039)(this.size);
                break;
            //case "dntjJavascript":
            //  this.fftLibrary = new DntjWebFftWrapperJavascript(this.size);
            //  break;
            case "indutnyJavascript":
                this.fftLibrary = new (0, $0a835dc3ef5a3230$export$2e2bcd8739ae039)(this.size);
                break;
            case "mljsJavascript":
                this.fftLibrary = new (0, $68127b33286950f9$export$2e2bcd8739ae039)(this.size);
                break;
            case "kissfftmodifiedWasm":
                this.fftLibrary = new (0, $9052da28056a1f9d$export$2e2bcd8739ae039)(this.size);
                break;
            //case "viljaWasm":
            //  this.fftLibrary = new ViljaFftWrapperWasm(this.size);
            case "indutnyModifiedJavascript":
                this.fftLibrary = new (0, $b511dcd5781ca5c6$export$2e2bcd8739ae039)(this.size);
                break;
            default:
                //this.fftLibrary = new IndutnyFftWrapperJavascript(this.size);
                throw new Error("Invalid sublibrary");
        }
    }
    fft(inputArr) {
        if (inputArr.length !== 2 * this.size) throw new Error("Input array length must be == 2 * size");
        this.outputArr = this.fftLibrary.fft(inputArr);
        return this.outputArr;
    }
    // convinience function for people who want to use real-valued input.
    //   note that you still have to give it a size that is 2x your real-valued input length!!
    //   it doesn't actually speed it up by 2x
    //   output is complex but the lenght of inputArr because the negative freqs are removed
    fftr(inputArr) {
        var { outputArr: outputArr, fftLibrary: fftLibrary, size: size } = this;
        if (inputArr.length !== size) throw new Error("Input array length must be == size");
        const inputArrComplex = new Float32Array(2 * size);
        inputArrComplex.fill(0);
        for(let i = 0; i < size; i++)inputArrComplex[2 * i] = inputArr[i];
        outputArr = fftLibrary.fft(inputArrComplex);
        return outputArr.slice(size, size * 2);
    }
    // takes in an array of arrays each of length 2*size.  the outter array length must also be a power of two.  only supports complex
    fft2d(inputArray) {
        const innerLen = inputArray[0].length / 2;
        const outterLen = inputArray.length;
        if (innerLen !== this.size) throw new Error("Inner array length must be == 2 * size");
        if (!$304b9fcf638b77cf$var$validSizes.includes(outterLen)) throw new Error("Outter array length must be a power of 2 between 4 and 131072");
        let intermediateArray = [];
        for(let i = 0; i < outterLen; i++){
            this.outputArr = this.fft(inputArray[i]);
            intermediateArray.push(this.outputArr);
        }
        // change the sublibs fftsize to the outter
        this.dispose();
        this.size = outterLen;
        this.setSubLibrary(this.subLibrary); // this should reinitialize the sublib with the new size
        // normally at these point we would transpose the 2d array, but with javascript its easier to just incorporate it into the next step when we pull elements
        let finalArray = [];
        for(let i = 0; i < innerLen; i++){
            const newArray = new Float32Array(2 * outterLen);
            newArray.fill(0);
            for(let j = 0; j < outterLen; j++){
                newArray[2 * j] = intermediateArray[j][2 * i];
                newArray[2 * j + 1] = intermediateArray[j][2 * i + 1];
            }
            let temparray = new Float32Array(2 * outterLen);
            temparray = this.fft(newArray);
            finalArray.push(temparray);
        }
        // Now do a final transpose
        let outputArray = [];
        for(let i = 0; i < outterLen; i++){
            let newArray = new Float32Array(2 * innerLen);
            for(let j = 0; j < innerLen; j++){
                newArray[2 * j] = finalArray[j][2 * i];
                newArray[2 * j + 1] = finalArray[j][2 * i + 1];
            }
            outputArray.push(newArray);
        }
        // change back to original size
        this.dispose();
        this.size = innerLen;
        this.setSubLibrary(this.subLibrary); // this should reinitialize the sublib to the original size
        return outputArray;
    }
    profile(duration = 1, refresh = true, quick = false) {
        if (!refresh && this.getCurrentProfile()) return this.getCurrentProfile();
        const totalStart = performance.now();
        let subLibraries;
        if (quick) subLibraries = this.availableSubLibrariesQuick();
        else subLibraries = this.availableSubLibraries();
        let ffsPerSecond = [];
        const secondsPerRun = duration / subLibraries.length / 2; // split in half because of warmup
        for(let i = 0; i < subLibraries.length; i++){
            this.setSubLibrary(subLibraries[i]);
            // Create input array
            const ci = new Float32Array(2 * this.size);
            for(let j = 0; j < this.size; j++){
                ci[2 * j] = Math.random() - 0.5;
                ci[2 * j + 1] = Math.random() - 0.5;
            }
            // Warmup
            let start = performance.now();
            while((performance.now() - start) / 1e3 < secondsPerRun){
                const co = this.fft(ci);
            }
            // Benchmark
            start = performance.now();
            let numFfts = 0;
            while((performance.now() - start) / 1e3 < secondsPerRun){
                const co = this.fft(ci);
                numFfts++;
            }
            ffsPerSecond.push(1e3 * numFfts / (performance.now() - start));
            this.dispose();
        }
        const totalElapsed = (performance.now() - totalStart) / 1e3;
        // Update current FFT method
        let argmax = ffsPerSecond.indexOf(Math.max(...ffsPerSecond));
        const profileObj = {
            fftsPerSecond: ffsPerSecond,
            subLibraries: subLibraries,
            totalElapsed: totalElapsed,
            fastestSubLibrary: subLibraries[argmax]
        };
        console.log("Setting sublibrary to", profileObj.fastestSubLibrary);
        this.setSubLibrary(profileObj.fastestSubLibrary);
        if (typeof localStorage !== "undefined") localStorage.setItem("webfftProfile", JSON.stringify(profileObj));
        return profileObj;
    }
    async checkBrowserCapabilities() {
        return await (0, $f61b772ddace0c47$export$2e2bcd8739ae039)();
    }
    dispose() {
        if (this.fftLibrary && this.fftLibrary.dispose !== undefined) this.fftLibrary.dispose();
    }
}
var $304b9fcf638b77cf$export$2e2bcd8739ae039 = $304b9fcf638b77cf$var$webfft;


/**
 * Utility functions for frequency conversions and calculations
 * Extracted for testability
 */ // Logarithmic scale constants
var $5525881969d9a665$exports = {};
'use strict';
function $5525881969d9a665$var$FFT(size) {
    this.size = size | 0;
    if (this.size <= 1 || (this.size & this.size - 1) !== 0) throw new Error('FFT size must be a power of two and bigger than 1');
    this._csize = size << 1;
    // NOTE: Use of `var` is intentional for old V8 versions
    var table = new Array(this.size * 2);
    for(var i = 0; i < table.length; i += 2){
        const angle = Math.PI * i / this.size;
        table[i] = Math.cos(angle);
        table[i + 1] = -Math.sin(angle);
    }
    this.table = table;
    // Find size's power of two
    var power = 0;
    for(var t = 1; this.size > t; t <<= 1)power++;
    // Calculate initial step's width:
    //   * If we are full radix-4 - it is 2x smaller to give inital len=8
    //   * Otherwise it is the same as `power` to give len=4
    this._width = power % 2 === 0 ? power - 1 : power;
    // Pre-compute bit-reversal patterns
    this._bitrev = new Array(1 << this._width);
    for(var j = 0; j < this._bitrev.length; j++){
        this._bitrev[j] = 0;
        for(var shift = 0; shift < this._width; shift += 2){
            var revShift = this._width - shift - 2;
            this._bitrev[j] |= (j >>> shift & 3) << revShift;
        }
    }
    this._out = null;
    this._data = null;
    this._inv = 0;
}
$5525881969d9a665$exports = $5525881969d9a665$var$FFT;
$5525881969d9a665$var$FFT.prototype.fromComplexArray = function fromComplexArray(complex, storage) {
    var res = storage || new Array(complex.length >>> 1);
    for(var i = 0; i < complex.length; i += 2)res[i >>> 1] = complex[i];
    return res;
};
$5525881969d9a665$var$FFT.prototype.createComplexArray = function createComplexArray() {
    const res = new Array(this._csize);
    for(var i = 0; i < res.length; i++)res[i] = 0;
    return res;
};
$5525881969d9a665$var$FFT.prototype.toComplexArray = function toComplexArray(input, storage) {
    var res = storage || this.createComplexArray();
    for(var i = 0; i < res.length; i += 2){
        res[i] = input[i >>> 1];
        res[i + 1] = 0;
    }
    return res;
};
$5525881969d9a665$var$FFT.prototype.completeSpectrum = function completeSpectrum(spectrum) {
    var size = this._csize;
    var half = size >>> 1;
    for(var i = 2; i < half; i += 2){
        spectrum[size - i] = spectrum[i];
        spectrum[size - i + 1] = -spectrum[i + 1];
    }
};
$5525881969d9a665$var$FFT.prototype.transform = function transform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._transform4();
    this._out = null;
    this._data = null;
};
$5525881969d9a665$var$FFT.prototype.realTransform = function realTransform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 0;
    this._realTransform4();
    this._out = null;
    this._data = null;
};
$5525881969d9a665$var$FFT.prototype.inverseTransform = function inverseTransform(out, data) {
    if (out === data) throw new Error('Input and output buffers must be different');
    this._out = out;
    this._data = data;
    this._inv = 1;
    this._transform4();
    for(var i = 0; i < out.length; i++)out[i] /= this.size;
    this._out = null;
    this._data = null;
};
// radix-4 implementation
//
// NOTE: Uses of `var` are intentional for older V8 version that do not
// support both `let compound assignments` and `const phi`
$5525881969d9a665$var$FFT.prototype._transform4 = function _transform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform2(outOff, off, step);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleTransform4(outOff, off, step);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var quarterLen = len >>> 2;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len){
            // Full case
            var limit = outOff + quarterLen;
            for(var i = outOff, k = 0; i < limit; i += 2, k += step){
                const A = i;
                const B = A + quarterLen;
                const C = B + quarterLen;
                const D = C + quarterLen;
                // Original values
                const Ar = out[A];
                const Ai = out[A + 1];
                const Br = out[B];
                const Bi = out[B + 1];
                const Cr = out[C];
                const Ci = out[C + 1];
                const Dr = out[D];
                const Di = out[D + 1];
                // Middle values
                const MAr = Ar;
                const MAi = Ai;
                const tableBr = table[k];
                const tableBi = inv * table[k + 1];
                const MBr = Br * tableBr - Bi * tableBi;
                const MBi = Br * tableBi + Bi * tableBr;
                const tableCr = table[2 * k];
                const tableCi = inv * table[2 * k + 1];
                const MCr = Cr * tableCr - Ci * tableCi;
                const MCi = Cr * tableCi + Ci * tableCr;
                const tableDr = table[3 * k];
                const tableDi = inv * table[3 * k + 1];
                const MDr = Dr * tableDr - Di * tableDi;
                const MDi = Dr * tableDi + Di * tableDr;
                // Pre-Final values
                const T0r = MAr + MCr;
                const T0i = MAi + MCi;
                const T1r = MAr - MCr;
                const T1i = MAi - MCi;
                const T2r = MBr + MDr;
                const T2i = MBi + MDi;
                const T3r = inv * (MBr - MDr);
                const T3i = inv * (MBi - MDi);
                // Final values
                const FAr = T0r + T2r;
                const FAi = T0i + T2i;
                const FCr = T0r - T2r;
                const FCi = T0i - T2i;
                const FBr = T1r + T3i;
                const FBi = T1i - T3r;
                const FDr = T1r - T3i;
                const FDi = T1i + T3r;
                out[A] = FAr;
                out[A + 1] = FAi;
                out[B] = FBr;
                out[B + 1] = FBi;
                out[C] = FCr;
                out[C + 1] = FCi;
                out[D] = FDr;
                out[D + 1] = FDi;
            }
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$5525881969d9a665$var$FFT.prototype._singleTransform2 = function _singleTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const evenI = data[off + 1];
    const oddR = data[off + step];
    const oddI = data[off + step + 1];
    const leftR = evenR + oddR;
    const leftI = evenI + oddI;
    const rightR = evenR - oddR;
    const rightI = evenI - oddI;
    out[outOff] = leftR;
    out[outOff + 1] = leftI;
    out[outOff + 2] = rightR;
    out[outOff + 3] = rightI;
};
// radix-4
//
// NOTE: Only called for len=8
$5525881969d9a665$var$FFT.prototype._singleTransform4 = function _singleTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Ai = data[off + 1];
    const Br = data[off + step];
    const Bi = data[off + step + 1];
    const Cr = data[off + step2];
    const Ci = data[off + step2 + 1];
    const Dr = data[off + step3];
    const Di = data[off + step3 + 1];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T0i = Ai + Ci;
    const T1r = Ar - Cr;
    const T1i = Ai - Ci;
    const T2r = Br + Dr;
    const T2i = Bi + Di;
    const T3r = inv * (Br - Dr);
    const T3i = inv * (Bi - Di);
    // Final values
    const FAr = T0r + T2r;
    const FAi = T0i + T2i;
    const FBr = T1r + T3i;
    const FBi = T1i - T3r;
    const FCr = T0r - T2r;
    const FCi = T0i - T2i;
    const FDr = T1r - T3i;
    const FDi = T1i + T3r;
    out[outOff] = FAr;
    out[outOff + 1] = FAi;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = FCi;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};
// Real input radix-4 implementation
$5525881969d9a665$var$FFT.prototype._realTransform4 = function _realTransform4() {
    var out = this._out;
    var size = this._csize;
    // Initial step (permute and transform)
    var width = this._width;
    var step = 1 << width;
    var len = size / step << 1;
    var outOff;
    var t;
    var bitrev = this._bitrev;
    if (len === 4) for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform2(outOff, off >>> 1, step >>> 1);
    }
    else // len === 8
    for(outOff = 0, t = 0; outOff < size; outOff += len, t++){
        const off = bitrev[t];
        this._singleRealTransform4(outOff, off >>> 1, step >>> 1);
    }
    // Loop through steps in decreasing order
    var inv = this._inv ? -1 : 1;
    var table = this.table;
    for(step >>= 2; step >= 2; step >>= 2){
        len = size / step << 1;
        var halfLen = len >>> 1;
        var quarterLen = halfLen >>> 1;
        var hquarterLen = quarterLen >>> 1;
        // Loop through offsets in the data
        for(outOff = 0; outOff < size; outOff += len)for(var i = 0, k = 0; i <= hquarterLen; i += 2, k += step){
            var A = outOff + i;
            var B = A + quarterLen;
            var C = B + quarterLen;
            var D = C + quarterLen;
            // Original values
            var Ar = out[A];
            var Ai = out[A + 1];
            var Br = out[B];
            var Bi = out[B + 1];
            var Cr = out[C];
            var Ci = out[C + 1];
            var Dr = out[D];
            var Di = out[D + 1];
            // Middle values
            var MAr = Ar;
            var MAi = Ai;
            var tableBr = table[k];
            var tableBi = inv * table[k + 1];
            var MBr = Br * tableBr - Bi * tableBi;
            var MBi = Br * tableBi + Bi * tableBr;
            var tableCr = table[2 * k];
            var tableCi = inv * table[2 * k + 1];
            var MCr = Cr * tableCr - Ci * tableCi;
            var MCi = Cr * tableCi + Ci * tableCr;
            var tableDr = table[3 * k];
            var tableDi = inv * table[3 * k + 1];
            var MDr = Dr * tableDr - Di * tableDi;
            var MDi = Dr * tableDi + Di * tableDr;
            // Pre-Final values
            var T0r = MAr + MCr;
            var T0i = MAi + MCi;
            var T1r = MAr - MCr;
            var T1i = MAi - MCi;
            var T2r = MBr + MDr;
            var T2i = MBi + MDi;
            var T3r = inv * (MBr - MDr);
            var T3i = inv * (MBi - MDi);
            // Final values
            var FAr = T0r + T2r;
            var FAi = T0i + T2i;
            var FBr = T1r + T3i;
            var FBi = T1i - T3r;
            out[A] = FAr;
            out[A + 1] = FAi;
            out[B] = FBr;
            out[B + 1] = FBi;
            // Output final middle point
            if (i === 0) {
                var FCr = T0r - T2r;
                var FCi = T0i - T2i;
                out[C] = FCr;
                out[C + 1] = FCi;
                continue;
            }
            // Do not overwrite ourselves
            if (i === hquarterLen) continue;
            // In the flipped case:
            // MAi = -MAi
            // MBr=-MBi, MBi=-MBr
            // MCr=-MCr
            // MDr=MDi, MDi=MDr
            var ST0r = T1r;
            var ST0i = -T1i;
            var ST1r = T0r;
            var ST1i = -T0i;
            var ST2r = -inv * T3i;
            var ST2i = -inv * T3r;
            var ST3r = -inv * T2i;
            var ST3i = -inv * T2r;
            var SFAr = ST0r + ST2r;
            var SFAi = ST0i + ST2i;
            var SFBr = ST1r + ST3i;
            var SFBi = ST1i - ST3r;
            var SA = outOff + quarterLen - i;
            var SB = outOff + halfLen - i;
            out[SA] = SFAr;
            out[SA + 1] = SFAi;
            out[SB] = SFBr;
            out[SB + 1] = SFBi;
        }
    }
};
// radix-2 implementation
//
// NOTE: Only called for len=4
$5525881969d9a665$var$FFT.prototype._singleRealTransform2 = function _singleRealTransform2(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const evenR = data[off];
    const oddR = data[off + step];
    const leftR = evenR + oddR;
    const rightR = evenR - oddR;
    out[outOff] = leftR;
    out[outOff + 1] = 0;
    out[outOff + 2] = rightR;
    out[outOff + 3] = 0;
};
// radix-4
//
// NOTE: Only called for len=8
$5525881969d9a665$var$FFT.prototype._singleRealTransform4 = function _singleRealTransform4(outOff, off, step) {
    const out = this._out;
    const data = this._data;
    const inv = this._inv ? -1 : 1;
    const step2 = step * 2;
    const step3 = step * 3;
    // Original values
    const Ar = data[off];
    const Br = data[off + step];
    const Cr = data[off + step2];
    const Dr = data[off + step3];
    // Pre-Final values
    const T0r = Ar + Cr;
    const T1r = Ar - Cr;
    const T2r = Br + Dr;
    const T3r = inv * (Br - Dr);
    // Final values
    const FAr = T0r + T2r;
    const FBr = T1r;
    const FBi = -T3r;
    const FCr = T0r - T2r;
    const FDr = T1r;
    const FDi = T3r;
    out[outOff] = FAr;
    out[outOff + 1] = 0;
    out[outOff + 2] = FBr;
    out[outOff + 3] = FBi;
    out[outOff + 4] = FCr;
    out[outOff + 5] = 0;
    out[outOff + 6] = FDr;
    out[outOff + 7] = FDi;
};


class $98b3b2b1ae112f6a$export$7a6d453bc6bad96a {
    /** @private @readonly @type {number} */ _inputLength;
    /** @private @type {FFT} */ _fft;
    /** @private @type {(size: number) => T} */ _bufferSupplier;
    /** @private @type {T} */ _paddedInputBuffer;
    /** @private @type {T} */ _transformBuffer;
    /** @private @type {T} */ _inverseBuffer;
    /**
   * A helper method to create an {@link Autocorrelator} using
   * {@link Float32Array} buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {Autocorrelator<Float32Array>}
   */ static forFloat32Array(inputLength) {
        return new $98b3b2b1ae112f6a$export$7a6d453bc6bad96a(inputLength, (length)=>new Float32Array(length));
    }
    /**
   * A helper method to create an {@link Autocorrelator} using
   * {@link Float64Array} buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {Autocorrelator<Float64Array>}
   */ static forFloat64Array(inputLength) {
        return new $98b3b2b1ae112f6a$export$7a6d453bc6bad96a(inputLength, (length)=>new Float64Array(length));
    }
    /**
   * A helper method to create an {@link Autocorrelator} using `number[]`
   * buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {Autocorrelator<number[]>}
   */ static forNumberArray(inputLength) {
        return new $98b3b2b1ae112f6a$export$7a6d453bc6bad96a(inputLength, (length)=>Array(length));
    }
    /**
   * Constructs a new {@link Autocorrelator} able to handle input arrays of the
   * given length.
   *
   * @param inputLength {number} the input array length to support. This
   * `Autocorrelator` will only support operation on arrays of this length.
   * @param bufferSupplier {(length: number) => T} the function to use for
   * creating buffers, accepting the length of the buffer to create and
   * returning a new buffer of that length. The values of the returned buffer
   * need not be initialized in any particular way.
   */ constructor(inputLength, bufferSupplier){
        if (inputLength < 1) throw new Error(`Input length must be at least one`);
        this._inputLength = inputLength;
        // We need to double the input length to get correct results, and the FFT
        // algorithm we use requires a length that's a power of 2
        this._fft = new (0, (/*@__PURE__*/$parcel$interopDefault($5525881969d9a665$exports)))($98b3b2b1ae112f6a$var$ceilPow2(2 * inputLength));
        this._bufferSupplier = bufferSupplier;
        this._paddedInputBuffer = this._bufferSupplier(this._fft.size);
        this._transformBuffer = this._bufferSupplier(2 * this._fft.size);
        this._inverseBuffer = this._bufferSupplier(2 * this._fft.size);
    }
    /**
   * Returns the supported input length.
   *
   * @returns {number} the supported input length
   */ get inputLength() {
        return this._inputLength;
    }
    /**
   * Autocorrelates the given input data.
   *
   * @param input {ArrayLike<number>} the input data to autocorrelate
   * @param output {T} the output buffer into which to write the autocorrelated
   * data. If not provided, a new buffer will be created.
   * @returns {T} `output`
   */ autocorrelate(input, output = this._bufferSupplier(input.length)) {
        if (input.length !== this._inputLength) throw new Error(`Input must have length ${this._inputLength} but had length ${input.length}`);
        // Step 0: pad the input array with zeros
        for(let i = 0; i < input.length; i++)this._paddedInputBuffer[i] = input[i];
        for(let i = input.length; i < this._paddedInputBuffer.length; i++)this._paddedInputBuffer[i] = 0;
        // Step 1: get the DFT of the input array
        this._fft.realTransform(this._transformBuffer, this._paddedInputBuffer);
        // We need to fill in the right half of the array too
        this._fft.completeSpectrum(this._transformBuffer);
        // Step 2: multiply each entry by its conjugate
        const tb = this._transformBuffer;
        for(let i = 0; i < tb.length; i += 2){
            tb[i] = tb[i] * tb[i] + tb[i + 1] * tb[i + 1];
            tb[i + 1] = 0;
        }
        // Step 3: perform the inverse transform
        this._fft.inverseTransform(this._inverseBuffer, this._transformBuffer);
        // This last result (the inverse transform) contains the autocorrelation
        // data, which is completely real
        for(let i = 0; i < input.length; i++)output[i] = this._inverseBuffer[2 * i];
        return output;
    }
}
/**
 * Returns an array of all the key maximum positions in the given input array.
 *
 * In McLeod's paper, a key maximum is the highest maximum between a positively
 * sloped zero crossing and a negatively sloped one.
 *
 * TODO: it may be more efficient not to construct a new output array each time,
 * but that would also make the code more complicated (more so than the changes
 * that were needed to remove the other allocations).
 *
 * @param input {ArrayLike<number>}
 * @returns {number[]}
 */ function $98b3b2b1ae112f6a$var$getKeyMaximumIndices(input) {
    // The indices of the key maxima
    /** @type {number[]} */ const keyIndices = [];
    // Whether the last zero crossing found was positively sloped; equivalently,
    // whether we're looking for a key maximum
    let lookingForMaximum = false;
    // The largest local maximum found so far
    let max = -Infinity;
    // The index of the largest local maximum so far
    let maxIndex = -1;
    for(let i = 1; i < input.length - 1; i++){
        if (input[i - 1] <= 0 && input[i] > 0) {
            // Positively sloped zero crossing
            lookingForMaximum = true;
            maxIndex = i;
            max = input[i];
        } else if (input[i - 1] > 0 && input[i] <= 0) {
            // Negatively sloped zero crossing
            lookingForMaximum = false;
            if (maxIndex !== -1) keyIndices.push(maxIndex);
        } else if (lookingForMaximum && input[i] > max) {
            max = input[i];
            maxIndex = i;
        }
    }
    return keyIndices;
}
/**
 * Refines the chosen key maximum index chosen from the given data by
 * interpolating a parabola using the key maximum index and its two neighbors
 * and finding the position of that parabola's maximum value.
 *
 * This is described in section 5 of the MPM paper as a way to refine the
 * position of the maximum.
 *
 * @param index {number} the chosen key maximum index. This must be between `1`
 * and `data.length - 2`, inclusive, since it and its two neighbors need to be
 * valid indexes of `data`.
 * @param data {ArrayLike<number>} the input array from which `index` was chosen
 * @returns {[number, number]} a pair consisting of the refined key maximum index and the
 * interpolated value of `data` at that index (the latter of which is used as a
 * measure of clarity)
 */ function $98b3b2b1ae112f6a$var$refineResultIndex(index, data) {
    const [x0, x1, x2] = [
        index - 1,
        index,
        index + 1
    ];
    const [y0, y1, y2] = [
        data[x0],
        data[x1],
        data[x2]
    ];
    // The parabola going through the three data points can be written as
    // y = y0(x - x1)(x - x2)/(x0 - x1)(x0 - x2)
    //   + y1(x - x0)(x - x2)/(x1 - x0)(x1 - x2)
    //   + y2(x - x0)(x - x1)/(x2 - x0)(x2 - x1)
    // Given the definitions of x0, x1, and x2, we can simplify the denominators:
    // y = y0(x - x1)(x - x2)/2
    //   - y1(x - x0)(x - x2)
    //   + y2(x - x0)(x - x1)/2
    // We can expand this out and get the coefficients in standard form:
    // a = y0/2 - y1 + y2/2
    // b = -(y0/2)(x1 + x2) + y1(x0 + x2) - (y2/2)(x0 + x1)
    // c = y0x1x2/2 - y1x0x2 + y2x0x1/2
    // The index of the maximum is -b / 2a (by solving for x where the derivative
    // is 0).
    const a = y0 / 2 - y1 + y2 / 2;
    const b = -(y0 / 2) * (x1 + x2) + y1 * (x0 + x2) - y2 / 2 * (x0 + x1);
    const c = y0 * x1 * x2 / 2 - y1 * x0 * x2 + y2 * x0 * x1 / 2;
    const xMax = -b / (2 * a);
    const yMax = a * xMax * xMax + b * xMax + c;
    return [
        xMax,
        yMax
    ];
}
class $98b3b2b1ae112f6a$export$156849dc6cbe6b20 {
    /** @private @type {Autocorrelator<T>} */ _autocorrelator;
    /** @private @type {T} */ _nsdfBuffer;
    /** @private @type {number} */ _clarityThreshold = 0.9;
    /** @private @type {number} */ _minVolumeAbsolute = 0.0;
    /** @private @type {number} */ _maxInputAmplitude = 1.0;
    /**
   * A helper method to create an {@link PitchDetector} using {@link Float32Array} buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {PitchDetector<Float32Array>}
   */ static forFloat32Array(inputLength) {
        return new $98b3b2b1ae112f6a$export$156849dc6cbe6b20(inputLength, (length)=>new Float32Array(length));
    }
    /**
   * A helper method to create an {@link PitchDetector} using {@link Float64Array} buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {PitchDetector<Float64Array>}
   */ static forFloat64Array(inputLength) {
        return new $98b3b2b1ae112f6a$export$156849dc6cbe6b20(inputLength, (length)=>new Float64Array(length));
    }
    /**
   * A helper method to create an {@link PitchDetector} using `number[]` buffers.
   *
   * @param inputLength {number} the input array length to support
   * @returns {PitchDetector<number[]>}
   */ static forNumberArray(inputLength) {
        return new $98b3b2b1ae112f6a$export$156849dc6cbe6b20(inputLength, (length)=>Array(length));
    }
    /**
   * Constructs a new {@link PitchDetector} able to handle input arrays of the
   * given length.
   *
   * @param inputLength {number} the input array length to support. This
   * `PitchDetector` will only support operation on arrays of this length.
   * @param bufferSupplier {(inputLength: number) => T} the function to use for
   * creating buffers, accepting the length of the buffer to create and
   * returning a new buffer of that length. The values of the returned buffer
   * need not be initialized in any particular way.
   */ constructor(inputLength, bufferSupplier){
        this._autocorrelator = new $98b3b2b1ae112f6a$export$7a6d453bc6bad96a(inputLength, bufferSupplier);
        this._nsdfBuffer = bufferSupplier(inputLength);
    }
    /**
   * Returns the supported input length.
   *
   * @returns {number} the supported input length
   */ get inputLength() {
        return this._autocorrelator.inputLength;
    }
    /**
   * Sets the clarity threshold used when identifying the correct pitch (the constant
   * `k` from the MPM paper). The value must be between 0 (exclusive) and 1
   * (inclusive), with the most suitable range being between 0.8 and 1.
   *
   * @param threshold {number} the clarity threshold
   */ set clarityThreshold(threshold) {
        if (!Number.isFinite(threshold) || threshold <= 0 || threshold > 1) throw new Error("clarityThreshold must be a number in the range (0, 1]");
        this._clarityThreshold = threshold;
    }
    /**
   * Sets the minimum detectable volume, as an absolute number between 0 and
   * `maxInputAmplitude`, inclusive, to consider in a sample when detecting the
   * pitch. If a sample fails to meet this minimum volume, `findPitch` will
   * return a clarity of 0.
   *
   * Volume is calculated as the RMS (root mean square) of the input samples.
   *
   * @param volume {number} the minimum volume as an absolute amplitude value
   */ set minVolumeAbsolute(volume) {
        if (!Number.isFinite(volume) || volume < 0 || volume > this._maxInputAmplitude) throw new Error(`minVolumeAbsolute must be a number in the range [0, ${this._maxInputAmplitude}]`);
        this._minVolumeAbsolute = volume;
    }
    /**
   * Sets the minimum volume using a decibel measurement. Must be less than or
   * equal to 0: 0 indicates the loudest possible sound (see
   * `maxInputAmplitude`), -10 is a sound with a tenth of the volume of the
   * loudest possible sound, etc.
   *
   * Volume is calculated as the RMS (root mean square) of the input samples.
   *
   * @param db {number} the minimum volume in decibels, with 0 being the loudest
   * sound
   */ set minVolumeDecibels(db) {
        if (!Number.isFinite(db) || db > 0) throw new Error("minVolumeDecibels must be a number <= 0");
        this._minVolumeAbsolute = this._maxInputAmplitude * 10 ** (db / 10);
    }
    /**
   * Sets the maximum amplitude of an input reading. Must be greater than 0.
   *
   * @param amplitude {number} the maximum amplitude (absolute value) of an input reading
   */ set maxInputAmplitude(amplitude) {
        if (!Number.isFinite(amplitude) || amplitude <= 0) throw new Error("maxInputAmplitude must be a number > 0");
        this._maxInputAmplitude = amplitude;
    }
    /**
   * Returns the pitch detected using McLeod Pitch Method (MPM) along with a
   * measure of its clarity.
   *
   * The clarity is a value between 0 and 1 (potentially inclusive) that
   * represents how "clear" the pitch was. A clarity value of 1 indicates that
   * the pitch was very distinct, while lower clarity values indicate less
   * definite pitches.
   *
   * @param input {ArrayLike<number>} the time-domain input data
   * @param sampleRate {number} the sample rate at which the input data was
   * collected
   * @returns {[number, number]} the detected pitch, in Hz, followed by the
   * clarity. If a pitch cannot be determined from the input, such as if the
   * volume is too low (see `minVolumeAbsolute` and `minVolumeDecibels`), this
   * will be `[0, 0]`.
   */ findPitch(input, sampleRate) {
        // If the highest key maximum is less than the minimum volume, we don't need
        // to bother detecting the pitch, as the sample is too quiet.
        if (this._belowMinimumVolume(input)) return [
            0,
            0
        ];
        this._nsdf(input);
        const keyMaximumIndices = $98b3b2b1ae112f6a$var$getKeyMaximumIndices(this._nsdfBuffer);
        if (keyMaximumIndices.length === 0) // No key maxima means that we either don't have enough data to analyze or
        // that the data was flawed (such as an input array of zeroes)
        return [
            0,
            0
        ];
        // The highest key maximum
        const nMax = Math.max(...keyMaximumIndices.map((i)=>this._nsdfBuffer[i]));
        // Following the paper, we return the pitch corresponding to the first key
        // maximum higher than K * nMax. This is guaranteed not to be undefined, since
        // we know of at least one key maximum satisfying this condition (whichever
        // key maximum gave us nMax).
        const resultIndex = keyMaximumIndices.find((i)=>this._nsdfBuffer[i] >= this._clarityThreshold * nMax);
        const [refinedResultIndex, clarity] = $98b3b2b1ae112f6a$var$refineResultIndex(// @ts-expect-error resultIndex is guaranteed to be defined
        resultIndex, this._nsdfBuffer);
        // Due to floating point errors, the clarity may occasionally come out to be
        // slightly over 1.0. We can avoid incorrect results by clamping the value.
        return [
            sampleRate / refinedResultIndex,
            Math.min(clarity, 1.0)
        ];
    }
    /**
   * Returns whether the input audio data is below the minimum volume allowed by
   * the pitch detector.
   *
   * @private
   * @param input {ArrayLike<number>}
   * @returns {boolean}
   */ _belowMinimumVolume(input) {
        if (this._minVolumeAbsolute === 0) return false;
        let squareSum = 0;
        for(let i = 0; i < input.length; i++)squareSum += input[i] ** 2;
        return Math.sqrt(squareSum / input.length) < this._minVolumeAbsolute;
    }
    /**
   * Computes the NSDF of the input and stores it in the internal buffer. This
   * is equation (9) in the McLeod pitch method paper.
   *
   * @private
   * @param input {ArrayLike<number>}
   */ _nsdf(input) {
        // The function r'(tau) is the autocorrelation
        this._autocorrelator.autocorrelate(input, this._nsdfBuffer);
        // The function m'(tau) (defined in equation (6)) can be computed starting
        // with m'(0), which is equal to 2r'(0), and then iteratively modified to
        // get m'(1), m'(2), etc. For example, to get m'(1), we take m'(0) and
        // subtract x_0^2 and x_{W-1}^2. Then, to get m'(2), we take m'(1) and
        // subtract x_1^2 and x_{W-2}^2, and further values are similar (see the
        // note at the end of section 6 in the MPM paper).
        //
        // The resulting array values are 2 * r'(tau) / m'(tau). We use m below as
        // the incremental value of m'.
        let m = 2 * this._nsdfBuffer[0];
        /** @type {number} */ let i;
        // As pointed out by issuefiler on GitHub, we can take advantage of the fact
        // that m will never increase to avoid division by zero by ending this loop
        // once m === 0. The rest of the array values after m becomes 0 will just be
        // set to 0 themselves. We actually check for m > 0 rather than m === 0
        // because there may be small floating-point errors that cause m to become
        // negative rather than exactly 0.
        for(i = 0; i < this._nsdfBuffer.length && m > 0; i++){
            this._nsdfBuffer[i] = 2 * this._nsdfBuffer[i] / m;
            m -= input[i] ** 2 + input[input.length - i - 1] ** 2;
        }
        // If there are any array values remaining, it means m === 0 for those
        // values of tau, so we can just set them to 0
        for(; i < this._nsdfBuffer.length; i++)this._nsdfBuffer[i] = 0;
    }
}
/**
 * Rounds up the input to the next power of 2.
 *
 * @param {number} v
 * @returns {number} the next power of 2 at least as large as `v`
 */ function $98b3b2b1ae112f6a$var$ceilPow2(v) {
    // https://graphics.stanford.edu/~seander/bithacks.html#RoundUpPowerOf2
    v--;
    v |= v >> 1;
    v |= v >> 2;
    v |= v >> 4;
    v |= v >> 8;
    v |= v >> 16;
    v++;
    return v;
}


const $9423fef94170f602$export$878d38bdc5f36240 = Math.log(20); // Log of 20 Hz
const $9423fef94170f602$export$b2b7f898a901649c = Math.log(24000); // Log of 24000 Hz
const $9423fef94170f602$export$d6cb569153154aaa = $9423fef94170f602$export$b2b7f898a901649c - $9423fef94170f602$export$878d38bdc5f36240;
function $9423fef94170f602$export$a9541283a9baf9ba(logValue) {
    return (logValue - $9423fef94170f602$export$878d38bdc5f36240) / $9423fef94170f602$export$d6cb569153154aaa;
}
function $9423fef94170f602$export$680cfe635ad44f95(linearValue) {
    return $9423fef94170f602$export$878d38bdc5f36240 + linearValue * $9423fef94170f602$export$d6cb569153154aaa;
}
function $9423fef94170f602$export$88f000e2845b6e9(logValue) {
    return Math.exp(logValue);
}
function $9423fef94170f602$export$64c925a7641aeff1(frequency) {
    return Math.log(frequency);
}
function $9423fef94170f602$export$1ad85dae61f04882(y, canvasHeight, minFrequency, maxFrequency, isLogScale) {
    let freq;
    if (isLogScale) {
        const logMin = $9423fef94170f602$export$64c925a7641aeff1(minFrequency);
        const logMax = $9423fef94170f602$export$64c925a7641aeff1(maxFrequency);
        const logFreq = logMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (logMax - logMin);
        freq = $9423fef94170f602$export$88f000e2845b6e9(logFreq);
    } else {
        const linearMin = minFrequency;
        const linearMax = maxFrequency;
        freq = linearMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (linearMax - linearMin);
    }
    return freq;
}
function $9423fef94170f602$export$16eb22496a812eda(x, canvasWidth, totalTimeSpan) {
    if (canvasWidth <= 0) return 0;
    const clampedX = Math.min(Math.max(x, 0), canvasWidth);
    const fractionFromRight = (canvasWidth - clampedX) / canvasWidth;
    return fractionFromRight * totalTimeSpan;
}
function $9423fef94170f602$export$103a811ebcfb1cd8(frequency, canvasHeight, minFrequency, maxFrequency, isLogScale) {
    if (canvasHeight <= 1) return 0;
    const h = canvasHeight - 1;
    if (isLogScale) {
        const logMin = $9423fef94170f602$export$64c925a7641aeff1(minFrequency);
        const logMax = $9423fef94170f602$export$64c925a7641aeff1(maxFrequency);
        if (logMax === logMin) return 0;
        const logFreq = $9423fef94170f602$export$64c925a7641aeff1(frequency);
        return h - h * (logFreq - logMin) / (logMax - logMin);
    }
    if (maxFrequency === minFrequency) return 0;
    return h - h * (frequency - minFrequency) / (maxFrequency - minFrequency);
}
const $9423fef94170f602$export$489272c0c993496e = {
    rectangular: (buffer)=>{
        return buffer;
    },
    hann: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * 0.5 * (1 - Math.cos(2 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    },
    hamming: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * (0.54 - 0.46 * Math.cos(2 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    },
    blackman: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        const alpha = 0.16;
        const a0 = (1 - alpha) / 2;
        const a1 = 0.5;
        const a2 = alpha / 2;
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * (a0 - a1 * Math.cos(2 * Math.PI * i / (N - 1)) + a2 * Math.cos(4 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    }
};
const $9423fef94170f602$export$2ad73d393c16f81c = {
    rainbow: (value)=>{
        const hue = 240 - value / 255 * 240;
        return `hsl(${hue}, 100%, 50%)`;
    },
    'green-orange-red': (value)=>{
        let r = 0, g = 0, b = 0;
        const n = value / 255; // Normalized value from 0 to 1
        if (n < 0.33) {
            // Interpolate R, G, B from (0,0,0) to (34,139,34)
            r = Math.floor(n / 0.33 * 34);
            g = Math.floor(n / 0.33 * 139);
            b = Math.floor(n / 0.33 * 34);
        } else if (n < 0.66) {
            const n_phase = (n - 0.33) / 0.33;
            // Interpolate R from 34 to 255
            r = Math.floor(34 + n_phase * 221);
            // Interpolate G from 139 to 165
            g = Math.floor(139 + n_phase * 26);
            // Interpolate B from 34 to 0
            b = Math.floor(34 + n_phase * -34);
        } else {
            const n_phase = (n - 0.66) / 0.34;
            // Interpolate R from 255 to 255 (stays 255)
            r = 255;
            // Interpolate G from 165 to 0
            g = Math.floor(165 + n_phase * -165);
            // Interpolate B from 0 to 0 (stays 0)
            b = 0;
        }
        return `rgb(${r}, ${g}, ${b})`;
    },
    grayscale: (value)=>{
        const gray = Math.floor(value);
        return `rgb(${gray}, ${gray}, ${gray})`;
    }
};
function $9423fef94170f602$export$127cd0100acc1cbb(interleavedArray) {
    const result = [];
    // For real FFT, we only use the first half (positive frequencies)
    // webfft.fftr() already returns only positive frequencies
    // Reverse the order to match the original frequency scale
    for(let i = interleavedArray.length - 2; i >= 0; i -= 2)result.push([
        interleavedArray[i],
        interleavedArray[i + 1]
    ]);
    return result;
}
function $9423fef94170f602$export$c95abc0728c40af5({ thresholdSamples: thresholdSamples }) {
    let consecutive = 0;
    return {
        observe (buffer) {
            let allZero = true;
            for(let i = 0; i < buffer.length; i++)if (buffer[i] !== 0) {
                allZero = false;
                break;
            }
            if (allZero) {
                consecutive += buffer.length;
                return consecutive >= thresholdSamples;
            }
            consecutive = 0;
            return false;
        },
        reset () {
            consecutive = 0;
        },
        count () {
            return consecutive;
        }
    };
}
/**
 * Convert a frequency in Hz to the nearest equal-tempered note name (A4=440)
 * and the deviation in cents (-50..+50).
 *
 * Returns `null` for non-positive or non-finite inputs so callers can skip
 * rendering gracefully when the frequency is out of range.
 *
 * @param {number} frequency - Frequency in hertz.
 * @returns {{name: string, cents: number}|null}
 */ const $9423fef94170f602$var$NOTE_NAMES = [
    'C',
    'C#',
    'D',
    'D#',
    'E',
    'F',
    'F#',
    'G',
    'G#',
    'A',
    'A#',
    'B'
];
function $9423fef94170f602$export$5f7ad25582a6704(frequency) {
    if (!Number.isFinite(frequency) || frequency <= 0) return null;
    const midi = 69 + 12 * Math.log2(frequency / 440);
    const nearest = Math.round(midi);
    // `|| 0` normalises -0 to 0 so a clean match displays "0¢", not "-0¢".
    const cents = Math.round((midi - nearest) * 100) || 0;
    const name = $9423fef94170f602$var$NOTE_NAMES[(nearest % 12 + 12) % 12];
    const octave = Math.floor(nearest / 12) - 1;
    return {
        name: `${name}${octave}`,
        cents: cents
    };
}
function $9423fef94170f602$export$a9d8a688afde7617(availableWidth, sizes, measureTextWidth, paddingWidth) {
    if (sizes.length === 0) throw new Error('pickLabelFontSize requires at least one candidate size');
    for (const size of sizes){
        if (measureTextWidth(size) + paddingWidth <= availableWidth) return size;
    }
    return sizes[sizes.length - 1];
}
// Cache PitchDetector instances by input length. Constructing one allocates
// internal FFT buffers, so we reuse across frames — drawWaveform reads a
// different size depending on zoom, and the spectrogram pitch tracker uses
// a fixed 2048-sample analysis window.
const $9423fef94170f602$var$pitchDetectorCache = new Map();
function $9423fef94170f602$var$getPitchDetector(size) {
    let d = $9423fef94170f602$var$pitchDetectorCache.get(size);
    if (!d) {
        d = (0, $98b3b2b1ae112f6a$export$156849dc6cbe6b20).forFloat32Array(size);
        $9423fef94170f602$var$pitchDetectorCache.set(size, d);
    }
    return d;
}
function $9423fef94170f602$export$ce4db8ba7c962cd5(samples, opts) {
    const { sampleRate: sampleRate, clarityThreshold: clarityThreshold = 0.9 } = opts;
    if (!samples.length) return null;
    const detector = $9423fef94170f602$var$getPitchDetector(samples.length);
    const [pitch, clarity] = detector.findPitch(samples, sampleRate);
    if (!Number.isFinite(pitch) || pitch <= 0) return null;
    if (clarity < clarityThreshold) return null;
    return pitch;
}
function $9423fef94170f602$export$394c3d4ca7c2dc88(samples, omega) {
    const n = samples.length;
    if (n === 0) return null;
    let a = 0, b = 0;
    for(let i = 0; i < n; i++){
        a += samples[i] * Math.sin(omega * i);
        b += samples[i] * Math.cos(omega * i);
    }
    return Math.atan2(b, a);
}
function $9423fef94170f602$export$614f6e4eaa372dc2(samples, previousWaveform, previousGainLevel, currentGain) {
    const n = samples.length;
    let frameMax = 0;
    let fullEnergy = 0;
    for(let i = 0; i < n; i++){
        const s = samples[i];
        const abs = s < 0 ? -s : s;
        if (abs > frameMax) frameMax = abs;
        fullEnergy += s * s;
    }
    const rmsPeakEstimate = n > 0 ? Math.sqrt(fullEnergy / n) * Math.SQRT2 : 0;
    const targetGain = frameMax > rmsPeakEstimate ? frameMax : rmsPeakEstimate;
    const rate = targetGain > currentGain ? 0.3 : 0.2;
    let newGain = currentGain + (targetGain - currentGain) * rate;
    if (frameMax > newGain) newGain = frameMax;
    return {
        gain: newGain,
        frameMax: frameMax
    };
}


// Auto-generated by scripts/generate-build-info.mjs. Do not edit by hand.
const $3d71ce0911a911e8$export$69f848a15ca55ba2 = "78d44d5ee5f41cf26c5105ebb595d9d192595bb7";
const $3d71ce0911a911e8$export$17b81730949de002 = "2026-04-19T22:10:54Z";


let $6b17f08f738443dc$var$canvas;
let $6b17f08f738443dc$var$ctx;
let $6b17f08f738443dc$var$labelsCanvas;
let $6b17f08f738443dc$var$labelsCtx;
let $6b17f08f738443dc$var$cursorLineCanvas;
let $6b17f08f738443dc$var$cursorLineCtx;
let $6b17f08f738443dc$var$timeScaleCanvas;
let $6b17f08f738443dc$var$timeScaleCtx;
let $6b17f08f738443dc$var$waveformCanvas;
let $6b17f08f738443dc$var$waveformCtx;
let $6b17f08f738443dc$var$waveformGainLevel = 0.01; // Current AGC level, starts small
let $6b17f08f738443dc$var$previousWaveform = null; // Previous displayed waveform for correlation trigger
let $6b17f08f738443dc$var$previousGainLevel = 0; // Gain applied to previousWaveform when drawn (for overlap-based scaling)
// Time zoom: number of audio samples per pixel that are shown in the waveform
// window. 1 = default (one sample per pixel). <1 zooms in (less time shown);
// >1 zooms out (more time shown).
let $6b17f08f738443dc$var$waveformTimeZoom = 1.0;
const $6b17f08f738443dc$var$MIN_WAVEFORM_TIME_ZOOM = 0.1;
const $6b17f08f738443dc$var$MAX_WAVEFORM_TIME_ZOOM = 10.0;
const $6b17f08f738443dc$var$MIN_WAVEFORM_SAMPLES = 32;
const $6b17f08f738443dc$var$MAX_WAVEFORM_SAMPLES = 65536;
// Weight of the pitch-locked anchor bonus relative to the cross-correlation
// score in drawWaveform. 0 = pure correlation, higher = anchor dominates.
// User-controlled via the "Pitch anchor" slider.
let $6b17f08f738443dc$var$waveformAnchorWeight = 1.5;
// Pitch detection for the cyan fundamental overlay on the spectrogram.
// Updated once per draw() from a fixed analysis window out of the
// continuous audio buffer; `null` means no confident pitch.
let $6b17f08f738443dc$var$currentFundamentalHz = null;
let $6b17f08f738443dc$var$lastDetectedNoteName = null;
const $6b17f08f738443dc$var$PITCH_ANALYSIS_SAMPLES = 2048;
// Note-onset label candidate sizes (largest first) and the horizontal padding
// added around the text in its backdrop box.
const $6b17f08f738443dc$var$NOTE_LABEL_SIZES = [
    13,
    11,
    9,
    7
];
const $6b17f08f738443dc$var$NOTE_LABEL_PAD_X = 2;
// Note onset we've detected but not yet drawn. We hold the label back until
// either the note has lasted long enough to fit a full-size label, or a new
// note arrives (commit with the largest size that fits in the elapsed width).
// Short notes end up with small labels, long notes with big ones. Fields:
//   noteName      — nearest equal-tempered note name, e.g. "A4"
//   anchorX       — current x of the onset column; decrements with scroll
//   lineY         — y of the pitch line at onset (for vertical placement)
//   elapsedWidth  — pixels scrolled since onset; used to pick the size
let $6b17f08f738443dc$var$pendingNoteLabel = null;
let $6b17f08f738443dc$var$phosphorDecayMs = 150; // Phosphor decay time in ms (0 = off)
let $6b17f08f738443dc$var$lastWaveformDrawTime = 0; // Timestamp of last waveform draw
let $6b17f08f738443dc$var$audioContext;
let $6b17f08f738443dc$var$source;
let $6b17f08f738443dc$var$mediaStream = null; // getUserMedia MediaStream — kept so we can stop tracks and release the mic indicator
let $6b17f08f738443dc$var$isPaused = false;
let $6b17f08f738443dc$var$isVisibilityHidden = false; // True while the tab is backgrounded (Page Visibility API)
let $6b17f08f738443dc$var$lastDrawBodyTime = 0; // Timestamp of the last time draw() did real work (used for FPS cap)
let $6b17f08f738443dc$var$animationFrameId; // To store the requestAnimationFrame ID
let $6b17f08f738443dc$var$mouseCanvasX = -1; // Stores the mouse X position relative to the canvas, -1 when not on canvas
let $6b17f08f738443dc$var$mouseCanvasY = -1; // Stores the mouse Y position relative to the canvas, -1 when not on canvas
// FPS tracking variables
let $6b17f08f738443dc$var$fpsCounter = 0;
let $6b17f08f738443dc$var$fpsLastTime = 0;
let $6b17f08f738443dc$var$fpsDisplay;
// Performance optimization variables
let $6b17f08f738443dc$var$frameSkipCounter = 0;
let $6b17f08f738443dc$var$frameSkipThreshold = 1; // Process every Nth frame for large FFTs
let $6b17f08f738443dc$var$scrollingSpeed = 1.0; // Scrolling speed multiplier; 1.0 = SCROLL_REFERENCE_FPS pixels per second, independent of paint rate
let $6b17f08f738443dc$var$scrollAccumulator = 0; // Fractional pixels carried between frames so live scroll is time-based
// Pixels we have shifted the canvas by since the last right-edge paint. At low
// FPS or large FFTs the canvas shifts several pixels per body but only the FFT
// response paints new column data, so the unpainted pixels between columns
// would otherwise show the previous content that we just scrolled leftward
// (visible as stripes / black gaps). Accumulating the debt lets the FFT
// response paint an interpolated block that covers the whole gap.
let $6b17f08f738443dc$var$pendingShiftAmount = 0;
let $6b17f08f738443dc$var$previousFrameData = null; // Previous FFT column, used as the left endpoint when interpolating the gap
// Web Worker for FFT computation
let $6b17f08f738443dc$var$fftWorker;
let $6b17f08f738443dc$var$fftRequestId = 0;
let $6b17f08f738443dc$var$pendingFftRequest = null;
// Audio buffer for reprocessing
let $6b17f08f738443dc$var$audioBuffer = [];
let $6b17f08f738443dc$var$audioBufferSize = 2000; // Store enough frames to fill canvas width
let $6b17f08f738443dc$var$audioBufferIndex = 0;
let $6b17f08f738443dc$var$isReprocessing = false;
// Continuous audio buffer for temporal continuity
let $6b17f08f738443dc$var$continuousAudioBuffer = null;
let $6b17f08f738443dc$var$continuousBufferSize = 0;
let $6b17f08f738443dc$var$continuousBufferIndex = 0;
let $6b17f08f738443dc$var$continuousBufferFilled = false; // Track if buffer has been filled at least once
let $6b17f08f738443dc$var$latestTimeDomainData = null;
let $6b17f08f738443dc$var$flatlineDetector = null;
let $6b17f08f738443dc$var$autoRestartInProgress = false;
let $6b17f08f738443dc$var$lastAutoRestartAt = 0;
const $6b17f08f738443dc$var$AUTO_RESTART_COOLDOWN_MS = 5000;
let $6b17f08f738443dc$var$lastFftInputData = null;
let $6b17f08f738443dc$var$lastProcessedTimestamp = 0;
let $6b17f08f738443dc$var$minFrequency = 20; // Default to 20 Hz
let $6b17f08f738443dc$var$maxFrequency = 11025; // Default to 11025 Hz
// Zoom selection variables
let $6b17f08f738443dc$var$isSelecting = false;
let $6b17f08f738443dc$var$selectionStart = null;
let $6b17f08f738443dc$var$selectionEnd = null;
let $6b17f08f738443dc$var$selectionOverlay;
// Logarithmic scale conversion functions
const $6b17f08f738443dc$var$MIN_LOG_FREQ = Math.log(20); // Log of 20 Hz
const $6b17f08f738443dc$var$MAX_LOG_FREQ = Math.log(24000); // Log of 24000 Hz
const $6b17f08f738443dc$var$LOG_RANGE = $6b17f08f738443dc$var$MAX_LOG_FREQ - $6b17f08f738443dc$var$MIN_LOG_FREQ;
const $6b17f08f738443dc$var$BASE_ANIMATION_FPS = 60; // Initial FPS assumption for time calculations
const $6b17f08f738443dc$var$TIME_PER_PIXEL_SMOOTHING = 0.1; // EMA weight for time-per-pixel updates
const $6b17f08f738443dc$var$TIME_SCALE_UPDATE_INTERVAL_MS = 200; // Min interval between time scale redraws
const $6b17f08f738443dc$var$MIN_TIME_PER_PIXEL = 1 / ($6b17f08f738443dc$var$BASE_ANIMATION_FPS * 10);
// Cap the spectrogram paint rate. rAF callbacks from 120 Hz displays arrive
// much faster than the spectrogram needs — temporal detail comes from the FFT
// hop size, not the paint rate. The cap is user-controlled via the
// power-saver / high-performance slider (20–120 FPS).
//
// DRAW_INTERVAL_CUSHION_MS absorbs floating-point noise in the rAF cadence:
// on a 60 Hz display rAF fires every ~16.67 ms, and the elapsed-time comparison
// at the target boundary (e.g. 33.33 < 33.33) can flip either way, dropping us
// to every third frame (20 FPS) instead of every second (30 FPS). A 1 ms
// cushion keeps the comparison stable without measurably changing the rate.
let $6b17f08f738443dc$var$targetDrawFps = 30;
let $6b17f08f738443dc$var$targetDrawIntervalMs = 1000 / $6b17f08f738443dc$var$targetDrawFps;
const $6b17f08f738443dc$var$DRAW_INTERVAL_CUSHION_MS = 1;
// Reference rate used by the live scroll accumulator. scrollingSpeed = 1.0
// corresponds to SCROLL_REFERENCE_FPS pixels per second, matching the app's
// historical 60-FPS-uncapped behavior so existing saved slider values keep
// feeling the same regardless of the user's FPS cap.
const $6b17f08f738443dc$var$SCROLL_REFERENCE_FPS = 60;
let $6b17f08f738443dc$var$smoothedTimePerPixel = 1 / $6b17f08f738443dc$var$BASE_ANIMATION_FPS;
let $6b17f08f738443dc$var$lastFrameTimestamp = null;
let $6b17f08f738443dc$var$lastDrawnTimePerPixel = $6b17f08f738443dc$var$smoothedTimePerPixel;
let $6b17f08f738443dc$var$lastTimeScaleUpdate = 0;
let $6b17f08f738443dc$var$lastTotalTimeSpan = 0;
// Audio buffer based timing tracking
let $6b17f08f738443dc$var$audioBuffersProcessed = 0;
let $6b17f08f738443dc$var$audioTimingStartTime = null;
// Helper function to convert webfft interleaved output to fft-js format
function $6b17f08f738443dc$var$convertWebfftOutput(interleavedArray) {
    const result = [];
    // For real FFT, we only use the first half (positive frequencies)
    // webfft.fftr() already returns only positive frequencies
    // Reverse the order to match the original frequency scale
    for(let i = interleavedArray.length - 2; i >= 0; i -= 2)result.push([
        interleavedArray[i],
        interleavedArray[i + 1]
    ]);
    return result;
}
function $6b17f08f738443dc$var$logToLinear(logValue) {
    return (logValue - $6b17f08f738443dc$var$MIN_LOG_FREQ) / $6b17f08f738443dc$var$LOG_RANGE;
}
function $6b17f08f738443dc$var$linearToLog(linearValue) {
    return $6b17f08f738443dc$var$MIN_LOG_FREQ + linearValue * $6b17f08f738443dc$var$LOG_RANGE;
}
function $6b17f08f738443dc$var$logToFrequency(logValue) {
    return Math.exp(logValue);
}
function $6b17f08f738443dc$var$frequencyToLog(frequency) {
    return Math.log(frequency);
}
// Window functions
const $6b17f08f738443dc$var$windowFunctions = {
    rectangular: (buffer)=>{
        return buffer;
    },
    hann: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * 0.5 * (1 - Math.cos(2 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    },
    hamming: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * (0.54 - 0.46 * Math.cos(2 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    },
    blackman: (buffer)=>{
        const N = buffer.length;
        const windowedBuffer = new Float32Array(N);
        const alpha = 0.16;
        const a0 = (1 - alpha) / 2;
        const a1 = 0.5;
        const a2 = alpha / 2;
        for(let i = 0; i < N; i++)windowedBuffer[i] = buffer[i] * (a0 - a1 * Math.cos(2 * Math.PI * i / (N - 1)) + a2 * Math.cos(4 * Math.PI * i / (N - 1)));
        return windowedBuffer;
    }
};
// Color scheme functions
const $6b17f08f738443dc$var$colorSchemes = {
    rainbow: (value)=>{
        const hue = 240 - value / 255 * 240;
        return `hsl(${hue}, 100%, 50%)`;
    },
    'green-orange-red': (value)=>{
        let r = 0, g = 0, b = 0;
        const n = value / 255; // Normalized value from 0 to 1
        if (n < 0.33) {
            // Interpolate R, G, B from (0,0,0) to (34,139,34)
            r = Math.floor(n / 0.33 * 34);
            g = Math.floor(n / 0.33 * 139);
            b = Math.floor(n / 0.33 * 34);
        } else if (n < 0.66) {
            const n_phase = (n - 0.33) / 0.33;
            // Interpolate R from 34 to 255
            r = Math.floor(34 + n_phase * 221);
            // Interpolate G from 139 to 165
            g = Math.floor(139 + n_phase * 26);
            // Interpolate B from 34 to 0
            b = Math.floor(34 + n_phase * -34);
        } else {
            const n_phase = (n - 0.66) / 0.34;
            // Interpolate R from 255 to 255 (stays 255)
            r = 255;
            // Interpolate G from 165 to 0
            g = Math.floor(165 + n_phase * -165);
            // Interpolate B from 0 to 0 (stays 0)
            b = 0;
        }
        return `rgb(${r}, ${g}, ${b})`;
    },
    grayscale: (value)=>{
        const gray = Math.floor(value);
        return `rgb(${gray}, ${gray}, ${gray})`;
    }
};
let $6b17f08f738443dc$var$currentColorScheme = 'green-orange-red'; // Default color scheme
let $6b17f08f738443dc$var$isLogScale = true; // Default to logarithmic scale
let $6b17f08f738443dc$var$currentFftSize = 4096; // Default to 4096 FFT size
let $6b17f08f738443dc$var$currentWindowFunction = 'blackman'; // Default to Blackman window
let $6b17f08f738443dc$var$fftInstance; // WebFFT instance
// Optimization: Pre-computed frequency mappings
let $6b17f08f738443dc$var$frequencyMappings = [];
let $6b17f08f738443dc$var$frequencyBinMappings = [];
let $6b17f08f738443dc$var$colorCache = new Map();
let $6b17f08f738443dc$var$minFreqSlider;
let $6b17f08f738443dc$var$maxFreqSlider;
let $6b17f08f738443dc$var$minFreqDisplay;
let $6b17f08f738443dc$var$maxFreqDisplay;
let $6b17f08f738443dc$var$logScaleCheckbox;
let $6b17f08f738443dc$var$fftSizeSelect;
let $6b17f08f738443dc$var$sampleRateSelect;
let $6b17f08f738443dc$var$pauseResumeBtn;
let $6b17f08f738443dc$var$toggleControlsBtn;
function $6b17f08f738443dc$var$resizeCanvas() {
    $6b17f08f738443dc$var$canvas.width = $6b17f08f738443dc$var$canvas.clientWidth;
    $6b17f08f738443dc$var$canvas.height = $6b17f08f738443dc$var$canvas.clientHeight;
    $6b17f08f738443dc$var$labelsCanvas.width = 40; // Fixed width for labels canvas
    $6b17f08f738443dc$var$labelsCanvas.height = $6b17f08f738443dc$var$labelsCanvas.clientHeight;
    $6b17f08f738443dc$var$cursorLineCanvas.width = $6b17f08f738443dc$var$canvas.clientWidth;
    $6b17f08f738443dc$var$cursorLineCanvas.height = $6b17f08f738443dc$var$canvas.clientHeight;
    // Resize time scale canvas
    if ($6b17f08f738443dc$var$timeScaleCanvas) {
        $6b17f08f738443dc$var$timeScaleCanvas.width = $6b17f08f738443dc$var$canvas.clientWidth;
        $6b17f08f738443dc$var$timeScaleCanvas.height = 40; // Fixed height for time scale
    }
    // Resize waveform canvas
    if ($6b17f08f738443dc$var$waveformCanvas && $6b17f08f738443dc$var$waveformArea) {
        $6b17f08f738443dc$var$waveformCanvas.width = $6b17f08f738443dc$var$canvas.clientWidth;
        // Use actual rendered height of waveform area
        $6b17f08f738443dc$var$waveformCanvas.height = $6b17f08f738443dc$var$waveformArea.clientHeight || $6b17f08f738443dc$var$waveformHeight;
    }
    // Update buffer size to match canvas width
    const newBufferSize = Math.max($6b17f08f738443dc$var$canvas.width, 1000); // At least 1000 frames
    if (newBufferSize !== $6b17f08f738443dc$var$audioBufferSize) {
        console.log('Updating buffer size:', {
            old: $6b17f08f738443dc$var$audioBufferSize,
            new: newBufferSize
        });
        $6b17f08f738443dc$var$audioBufferSize = newBufferSize;
    }
    const displayWidth = $6b17f08f738443dc$var$canvas.clientWidth || $6b17f08f738443dc$var$canvas.width;
    $6b17f08f738443dc$var$lastTotalTimeSpan = displayWidth * $6b17f08f738443dc$var$getTimePerPixel();
    $6b17f08f738443dc$var$drawLabels(); // Redraw labels on resize
    $6b17f08f738443dc$var$drawTimeScale(); // Redraw time scale on resize
    $6b17f08f738443dc$var$updateFrequencyMappings(); // Recompute frequency mappings
}
function $6b17f08f738443dc$var$updateFrequencyMappings() {
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    $6b17f08f738443dc$var$frequencyMappings = new Array(canvasHeight);
    $6b17f08f738443dc$var$frequencyBinMappings = new Array(canvasHeight);
    for(let i = 0; i < canvasHeight; i++){
        let freq;
        if ($6b17f08f738443dc$var$isLogScale) {
            const logFreq = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency) + (canvasHeight - 1 - i) / (canvasHeight - 1) * ($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency) - $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency));
            freq = $6b17f08f738443dc$var$logToFrequency(logFreq);
        } else freq = $6b17f08f738443dc$var$minFrequency + (canvasHeight - 1 - i) / (canvasHeight - 1) * ($6b17f08f738443dc$var$maxFrequency - $6b17f08f738443dc$var$minFrequency);
        $6b17f08f738443dc$var$frequencyMappings[i] = freq;
        // Pre-compute frequency bin index - will be updated in draw() with actual FFT size
        $6b17f08f738443dc$var$frequencyBinMappings[i] = 0; // Placeholder, will be computed in draw()
    }
}
var $3b7a9aa98a72879c$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $3b7a9aa98a72879c$var$url = new URL(import.meta.resolve("gk9Bg"));
$3b7a9aa98a72879c$exports = $56b621a6dd25b2cb$exports($3b7a9aa98a72879c$var$url.toString(), $3b7a9aa98a72879c$var$url.origin, true);


function $6b17f08f738443dc$var$initFftWorker() {
    try {
        $6b17f08f738443dc$var$fftWorker = new Worker($3b7a9aa98a72879c$exports);
        $6b17f08f738443dc$var$fftWorker.onmessage = function(e) {
            const { id: id, phasors: phasors, success: success, error: error } = e.data;
            if (success && $6b17f08f738443dc$var$pendingFftRequest && $6b17f08f738443dc$var$pendingFftRequest.id === id) {
                // Process the FFT result
                if ($6b17f08f738443dc$var$pendingFftRequest.isReprocessing) {
                    // Get the current index and calculate the X position
                    const currentIndex = $6b17f08f738443dc$var$pendingFftRequest.currentIndex || 0;
                    const xPosition = window.framePositions ? window.framePositions[currentIndex] : undefined;
                    // console.log('Web Worker completion - index:', currentIndex, 'xPosition:', xPosition, 'framePositions length:', window.framePositions ? window.framePositions.length : 'undefined');
                    $6b17f08f738443dc$var$processReprocessedFftResult(phasors, $6b17f08f738443dc$var$pendingFftRequest.fftSize, xPosition);
                    $6b17f08f738443dc$var$pendingFftRequest = null;
                    // Continue with next frame in reprocessing
                    setTimeout(()=>{
                        if ($6b17f08f738443dc$var$isReprocessing) {
                            // Continue reprocessing using the main processNextFrame function
                            if (currentIndex - 1 >= 0) window.processNextFrame(currentIndex - 1);
                            else {
                                console.log('Reprocessing completed via Web Worker - processed', window.framePositions.length, 'frames');
                                if (window.reprocessingTimeout) {
                                    clearTimeout(window.reprocessingTimeout);
                                    window.reprocessingTimeout = null;
                                }
                                $6b17f08f738443dc$var$isReprocessing = false;
                                window.reprocessingColumn = undefined; // Reset column counter
                                window.reprocessingInProgress = false; // Clear the guard
                                window.reprocessingRetryCount = 0; // Reset retry counter
                                // Clear any remaining worker timeout
                                if (window.workerTimeout) {
                                    clearTimeout(window.workerTimeout);
                                    window.workerTimeout = null;
                                }
                            }
                        }
                    }, 0);
                } else {
                    $6b17f08f738443dc$var$processFftResult(phasors, $6b17f08f738443dc$var$pendingFftRequest.fftSize);
                    $6b17f08f738443dc$var$pendingFftRequest = null;
                }
            } else if (!success) {
                console.error('FFT Worker error:', error);
                $6b17f08f738443dc$var$pendingFftRequest = null;
            }
        };
        $6b17f08f738443dc$var$fftWorker.onerror = function(error) {
            console.error('FFT Worker error:', error);
            $6b17f08f738443dc$var$pendingFftRequest = null;
        };
    } catch (error) {
        console.error('Failed to initialize FFT Worker:', error);
        $6b17f08f738443dc$var$fftWorker = null;
    }
}
// Tear down the live audio graph so both the mic (OS-level recording indicator)
// and the AudioContext are released. Suspending the context alone does NOT turn
// off the mic indicator — the MediaStreamTrack has to be stop()ped.
function $6b17f08f738443dc$var$releaseAudioResources() {
    if ($6b17f08f738443dc$var$animationFrameId) {
        cancelAnimationFrame($6b17f08f738443dc$var$animationFrameId);
        $6b17f08f738443dc$var$animationFrameId = null;
    }
    if ($6b17f08f738443dc$var$mediaStream) {
        $6b17f08f738443dc$var$mediaStream.getTracks().forEach((track)=>{
            try {
                track.stop();
            } catch (_) {}
        });
        $6b17f08f738443dc$var$mediaStream = null;
    }
    if ($6b17f08f738443dc$var$audioContext) {
        $6b17f08f738443dc$var$audioContext.close().catch(()=>{});
        $6b17f08f738443dc$var$audioContext = null;
    }
    $6b17f08f738443dc$var$source = null;
    // Drop any pixels we'd accumulated while the old context was alive so we
    // don't paint a huge interpolated block across fresh content on resume.
    $6b17f08f738443dc$var$pendingShiftAmount = 0;
    $6b17f08f738443dc$var$previousFrameData = null;
}
async function $6b17f08f738443dc$var$restartAudioContext(sampleRate) {
    $6b17f08f738443dc$var$releaseAudioResources();
    await $6b17f08f738443dc$var$startAudio(sampleRate);
    $6b17f08f738443dc$var$drawTimeScale();
}
var $a12559e65a6d61fd$exports = {};
$a12559e65a6d61fd$exports = import.meta.resolve("8zOT0");


async function $6b17f08f738443dc$var$startAudio(sampleRate) {
    try {
        $6b17f08f738443dc$var$audioContext = new (window.AudioContext || window.webkitAudioContext)({
            sampleRate: sampleRate
        });
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        // If the tab was hidden (or the user paused) while getUserMedia was
        // awaiting, drop the stream and bail so the mic indicator doesn't
        // light up for a background tab.
        if ($6b17f08f738443dc$var$isVisibilityHidden || $6b17f08f738443dc$var$isPaused) {
            stream.getTracks().forEach((t)=>{
                try {
                    t.stop();
                } catch (_) {}
            });
            try {
                await $6b17f08f738443dc$var$audioContext.close();
            } catch (_) {}
            $6b17f08f738443dc$var$audioContext = null;
            return;
        }
        $6b17f08f738443dc$var$mediaStream = stream;
        $6b17f08f738443dc$var$source = $6b17f08f738443dc$var$audioContext.createMediaStreamSource(stream);
        await $6b17f08f738443dc$var$audioContext.audioWorklet.addModule(new URL($a12559e65a6d61fd$exports));
        const audioWorkletNode = new AudioWorkletNode($6b17f08f738443dc$var$audioContext, 'audio-processor');
        // One-second flatline threshold: if the mic feeds exact zeros for a
        // full second the OS has almost certainly routed us away, so we
        // restart the audio context to reacquire the stream.
        $6b17f08f738443dc$var$flatlineDetector = (0, $9423fef94170f602$export$c95abc0728c40af5)({
            thresholdSamples: sampleRate
        });
        audioWorkletNode.port.onmessage = (event)=>{
            if ($6b17f08f738443dc$var$isPaused) return;
            const { buffer: buffer, timestamp: timestamp } = event.data || {};
            if (!buffer || !buffer.length) return;
            // Append every incoming audio frame to the continuous buffer
            // here, on the audio callback, NOT inside draw(). draw() is
            // throttled by the FPS-limit slider, so doing the buffer write
            // there would drop intermediate audio frames (a 30 FPS draw
            // sees only every other ~11 ms audio buffer), leaving sample
            // discontinuities that produced wideband FFT smearing on loud
            // hits and visible jumps in the waveform trace.
            $6b17f08f738443dc$var$addToContinuousBuffer(buffer);
            // Surface the latest frame to draw() so it knows when to run
            // an FFT and what timestamp to attach. The continuous buffer is
            // already up to date even if draw() drops this signal.
            $6b17f08f738443dc$var$latestTimeDomainData = {
                buffer: buffer,
                timestamp: timestamp || Date.now()
            };
            if ($6b17f08f738443dc$var$flatlineDetector && $6b17f08f738443dc$var$flatlineDetector.observe(buffer)) {
                const now = Date.now();
                if (!$6b17f08f738443dc$var$autoRestartInProgress && now - $6b17f08f738443dc$var$lastAutoRestartAt > $6b17f08f738443dc$var$AUTO_RESTART_COOLDOWN_MS) {
                    $6b17f08f738443dc$var$autoRestartInProgress = true;
                    $6b17f08f738443dc$var$lastAutoRestartAt = now;
                    console.warn("Audio stream flatlined for 1s \u2014 restarting audio context");
                    const rate = $6b17f08f738443dc$var$sampleRateSelect ? parseInt($6b17f08f738443dc$var$sampleRateSelect.value) : sampleRate;
                    $6b17f08f738443dc$var$restartAudioContext(rate).finally(()=>{
                        $6b17f08f738443dc$var$autoRestartInProgress = false;
                    });
                }
            }
        };
        $6b17f08f738443dc$var$source.connect(audioWorkletNode).connect($6b17f08f738443dc$var$audioContext.destination);
        await $6b17f08f738443dc$var$audioContext.resume(); // Explicitly resume the audio context
        // Initialize last processed frame data for frame skipping
        window.lastProcessedFrameData = null;
        $6b17f08f738443dc$var$smoothedTimePerPixel = 1 / $6b17f08f738443dc$var$BASE_ANIMATION_FPS;
        $6b17f08f738443dc$var$lastFrameTimestamp = null;
        $6b17f08f738443dc$var$lastDrawnTimePerPixel = $6b17f08f738443dc$var$smoothedTimePerPixel;
        $6b17f08f738443dc$var$lastTimeScaleUpdate = typeof performance !== 'undefined' ? performance.now() : Date.now();
        const displayWidth = $6b17f08f738443dc$var$canvas ? $6b17f08f738443dc$var$canvas.clientWidth || $6b17f08f738443dc$var$canvas.width : 0;
        $6b17f08f738443dc$var$lastTotalTimeSpan = displayWidth * $6b17f08f738443dc$var$lastDrawnTimePerPixel;
        // Reset audio timing tracking
        $6b17f08f738443dc$var$audioBuffersProcessed = 0;
        $6b17f08f738443dc$var$audioTimingStartTime = null;
        // Reset FFT buffer tracking to avoid discontinuities during initialization
        window.lastFftBufferIndex = null;
        window.bufferStuckCounter = 0;
        // Initialize WebFFT instance
        try {
            $6b17f08f738443dc$var$fftInstance = new (0, $304b9fcf638b77cf$export$2e2bcd8739ae039)($6b17f08f738443dc$var$currentFftSize);
        } catch (error) {
            console.error('Failed to initialize WebFFT with size', $6b17f08f738443dc$var$currentFftSize, ':', error);
            throw error;
        }
        // Cancel any existing animation frame before starting a new one
        if ($6b17f08f738443dc$var$animationFrameId) cancelAnimationFrame($6b17f08f738443dc$var$animationFrameId);
        $6b17f08f738443dc$var$draw();
    } catch (err) {
        console.error('Error accessing microphone:', err);
        alert('Error accessing microphone. Please allow microphone access and refresh the page.');
    }
}
function $6b17f08f738443dc$var$addToAudioBuffer(timeDomainData, windowFunction, timestamp) {
    // Add audio data to circular buffer
    const bufferEntry = {
        data: Array.from(timeDomainData),
        windowFunction: windowFunction,
        timestamp: timestamp || Date.now()
    };
    if ($6b17f08f738443dc$var$audioBuffer.length < $6b17f08f738443dc$var$audioBufferSize) $6b17f08f738443dc$var$audioBuffer.push(bufferEntry);
    else {
        $6b17f08f738443dc$var$audioBuffer[$6b17f08f738443dc$var$audioBufferIndex] = bufferEntry;
        $6b17f08f738443dc$var$audioBufferIndex = ($6b17f08f738443dc$var$audioBufferIndex + 1) % $6b17f08f738443dc$var$audioBufferSize;
    }
}
// Continuous buffer functions for temporal continuity
function $6b17f08f738443dc$var$initializeContinuousBuffer() {
    // Create a 15-second buffer at the current sample rate
    const sampleRate = $6b17f08f738443dc$var$audioContext ? $6b17f08f738443dc$var$audioContext.sampleRate : 44100;
    const bufferDurationSeconds = 15;
    $6b17f08f738443dc$var$continuousBufferSize = sampleRate * bufferDurationSeconds;
    $6b17f08f738443dc$var$continuousAudioBuffer = new Float32Array($6b17f08f738443dc$var$continuousBufferSize);
    $6b17f08f738443dc$var$continuousBufferIndex = 0;
    $6b17f08f738443dc$var$continuousBufferFilled = false; // Reset filled flag
}
function $6b17f08f738443dc$var$addToContinuousBuffer(timeDomainData) {
    // Initialize buffer if not already done
    if (!$6b17f08f738443dc$var$continuousAudioBuffer) $6b17f08f738443dc$var$initializeContinuousBuffer();
    // Validate that we're actually receiving new data
    if (!timeDomainData || timeDomainData.length === 0) {
        console.warn('No audio data received in addToContinuousBuffer');
        return;
    }
    // Check for potentially stuck data (all zeros or constant values)
    let isConstant = true;
    const firstValue = timeDomainData[0];
    for(let i = 1; i < Math.min(10, timeDomainData.length); i++)if (Math.abs(timeDomainData[i] - firstValue) > 1e-6) {
        isConstant = false;
        break;
    }
    if (isConstant && Math.random() < 0.01) console.warn('Potentially constant audio data detected:', firstValue);
    // Add samples to the continuous circular buffer
    for(let i = 0; i < timeDomainData.length; i++){
        const prevIndex = $6b17f08f738443dc$var$continuousBufferIndex;
        $6b17f08f738443dc$var$continuousAudioBuffer[$6b17f08f738443dc$var$continuousBufferIndex] = timeDomainData[i];
        $6b17f08f738443dc$var$continuousBufferIndex = ($6b17f08f738443dc$var$continuousBufferIndex + 1) % $6b17f08f738443dc$var$continuousBufferSize;
        // Detect when buffer has wrapped around (filled at least once)
        if (!$6b17f08f738443dc$var$continuousBufferFilled && $6b17f08f738443dc$var$continuousBufferIndex < prevIndex) $6b17f08f738443dc$var$continuousBufferFilled = true;
    }
}
function $6b17f08f738443dc$var$populateBuildInfo() {
    const commitEl = document.getElementById('build-commit');
    const dateEl = document.getElementById('build-date');
    const reloadBtn = document.getElementById('reload-btn');
    if (commitEl) {
        const short = /^[0-9a-f]{40}$/.test((0, $3d71ce0911a911e8$export$69f848a15ca55ba2)) ? (0, $3d71ce0911a911e8$export$69f848a15ca55ba2).slice(0, 7) : (0, $3d71ce0911a911e8$export$69f848a15ca55ba2);
        commitEl.textContent = short;
        if (/^[0-9a-f]{40}$/.test((0, $3d71ce0911a911e8$export$69f848a15ca55ba2))) commitEl.href = `https://github.com/jukkalaurila/spectroscope/commit/${0, $3d71ce0911a911e8$export$69f848a15ca55ba2}`;
        else commitEl.removeAttribute('href');
    }
    if (dateEl && (0, $3d71ce0911a911e8$export$17b81730949de002)) {
        const d = new Date((0, $3d71ce0911a911e8$export$17b81730949de002));
        if (!isNaN(d.getTime())) dateEl.textContent = " \xb7 " + d.toLocaleString();
    }
    // Only expose a reload button on the dev preview — bypasses Cloudflare's
    // edge cache so fresh deploys show up without manual hard-refresh.
    if (reloadBtn && location.hostname.startsWith('dev.')) {
        reloadBtn.hidden = false;
        reloadBtn.addEventListener('click', ()=>location.reload());
    }
    if (location.hostname.startsWith('dev.')) $6b17f08f738443dc$var$startDevAutoReloadPoller();
}
function $6b17f08f738443dc$var$startDevAutoReloadPoller() {
    // Poll the static build-info.json emitted next to the bundle. When its
    // commit differs from the one we booted with, a newer deploy has landed
    // and we reload so the dev preview always shows the latest push. The
    // cache-busting query and no-store fetch defeat Cloudflare's edge cache
    // for this path. 1s interval balances a snappy refresh with minimal
    // background network chatter.
    setInterval(async ()=>{
        try {
            const resp = await fetch('/build-info.json?t=' + Date.now(), {
                cache: 'no-store'
            });
            if (!resp.ok) return;
            const { commit: commit } = await resp.json();
            if (commit && commit !== (0, $3d71ce0911a911e8$export$69f848a15ca55ba2)) {
                console.info('New build detected, reloading:', commit.slice(0, 7));
                location.reload();
            }
        } catch (_) {
        // Network blip — try again on the next tick.
        }
    }, 1000);
}
function $6b17f08f738443dc$var$drawWaveform() {
    if (!$6b17f08f738443dc$var$waveformCanvas || !$6b17f08f738443dc$var$waveformCtx || !$6b17f08f738443dc$var$continuousAudioBuffer) return;
    if (!$6b17f08f738443dc$var$continuousBufferFilled && $6b17f08f738443dc$var$continuousBufferIndex === 0) return;
    const width = $6b17f08f738443dc$var$waveformCanvas.width;
    const height = $6b17f08f738443dc$var$waveformCanvas.height;
    const padding = 10;
    const drawableHeight = height - padding * 2;
    const centerY = height / 2;
    // samplesInWindow is the number of audio samples the user has chosen to
    // see; width is the pixel width of the canvas. At zoom=1 they match
    // (one sample per pixel, original behaviour). Zooming in shows fewer
    // samples stretched across the same pixel width; zooming out shows more.
    const samplesInWindow = Math.max($6b17f08f738443dc$var$MIN_WAVEFORM_SAMPLES, Math.min($6b17f08f738443dc$var$MAX_WAVEFORM_SAMPLES, Math.round(width * $6b17f08f738443dc$var$waveformTimeZoom)));
    const samplesNeeded = samplesInWindow * 2;
    const available = $6b17f08f738443dc$var$continuousBufferFilled ? $6b17f08f738443dc$var$continuousBufferSize : $6b17f08f738443dc$var$continuousBufferIndex;
    if (available < samplesNeeded) return;
    // Read the most recent samples from the circular buffer
    const samples = new Float32Array(samplesNeeded);
    for(let i = 0; i < samplesNeeded; i++){
        let idx = $6b17f08f738443dc$var$continuousBufferIndex - samplesNeeded + i;
        if (idx < 0) idx += $6b17f08f738443dc$var$continuousBufferSize;
        samples[i] = $6b17f08f738443dc$var$continuousAudioBuffer[idx];
    }
    // Find optimal trigger point using cross-correlation with previous waveform
    let triggerIndex = 0;
    const searchLimit = samplesNeeded - samplesInWindow;
    const hasPrevious = $6b17f08f738443dc$var$previousWaveform && $6b17f08f738443dc$var$previousWaveform.length === samplesInWindow;
    const windowMid = Math.floor(samplesInWindow / 2);
    const crossingSearchRadius = Math.max(1, Math.floor(samplesInWindow / 4));
    const crossingAlpha = $6b17f08f738443dc$var$waveformAnchorWeight;
    // Pitch-locked anchor: estimate the fundamental period of the buffered
    // audio, fit a single sine at that frequency, and use that sine's
    // upward zero-crossings as the alignment target. Unlike raw-sample
    // crossings these are evenly spaced at exactly `period` samples, so
    // a harmonic-rich or noisy signal still has one clear centering point
    // per period instead of several near-misses.
    let anchorPeriod = null;
    let anchorFirst = 0;
    if ($6b17f08f738443dc$var$audioContext && $6b17f08f738443dc$var$audioContext.sampleRate) {
        const pitchHz = (0, $9423fef94170f602$export$ce4db8ba7c962cd5)(samples, {
            sampleRate: $6b17f08f738443dc$var$audioContext.sampleRate
        });
        if (pitchHz) {
            const period = $6b17f08f738443dc$var$audioContext.sampleRate / pitchHz;
            const omega = 2 * Math.PI / period;
            const phase = (0, $9423fef94170f602$export$394c3d4ca7c2dc88)(samples, omega);
            if (phase !== null) {
                // Upward zero of sin(ω·i + φ) is at i = -φ/ω (mod period).
                let first = -phase / omega;
                first = (first % period + period) % period;
                anchorPeriod = period;
                anchorFirst = first;
            }
        }
    }
    // Since the fitted-sine crossings form an arithmetic progression
    // (first + k·period), the nearest crossing to any index c is a single
    // Math.round computation — O(1) per candidate offset.
    const alignmentBonusFor = (centre)=>{
        if (!anchorPeriod) return 0;
        const nearest = anchorFirst + anchorPeriod * Math.round((centre - anchorFirst) / anchorPeriod);
        const dist = Math.abs(centre - nearest);
        return Math.max(0, 1 - dist / (crossingSearchRadius + 1));
    };
    if (hasPrevious) {
        let bestScore = -Infinity;
        const step = Math.max(1, Math.floor(samplesInWindow / 128));
        for(let offset = 0; offset < searchLimit; offset++){
            let correlation = 0;
            for(let i = 0; i < samplesInWindow; i += step)correlation += samples[offset + i] * $6b17f08f738443dc$var$previousWaveform[i];
            const score = correlation * (1 + crossingAlpha * alignmentBonusFor(offset + windowMid));
            if (score > bestScore) {
                bestScore = score;
                triggerIndex = offset;
            }
        }
    } else if (anchorPeriod) {
        // First frame with a confident pitch: place the fitted-sine upward
        // zero-crossing closest to the middle of the search range at the
        // displayed centre.
        const targetCentre = Math.floor(searchLimit / 2) + windowMid;
        const nearest = anchorFirst + anchorPeriod * Math.round((targetCentre - anchorFirst) / anchorPeriod);
        triggerIndex = Math.max(0, Math.min(searchLimit - 1, Math.round(nearest) - windowMid));
    } else {
        // No previous frame, no confident pitch: fall back to the first raw
        // upward zero-crossing.
        for(let i = 1; i < searchLimit; i++)if (samples[i - 1] < 0 && samples[i] >= 0) {
            triggerIndex = i;
            break;
        }
    }
    // Pick the gain for this frame. See chooseWaveformGain in utils.js
    // for the reasoning behind the peak + √2·RMS target.
    const windowSamples = samples.subarray(triggerIndex, triggerIndex + samplesInWindow);
    const gainResult = (0, $9423fef94170f602$export$614f6e4eaa372dc2)(windowSamples, hasPrevious ? $6b17f08f738443dc$var$previousWaveform : null, $6b17f08f738443dc$var$previousGainLevel, $6b17f08f738443dc$var$waveformGainLevel);
    $6b17f08f738443dc$var$waveformGainLevel = gainResult.gain;
    const maxAmplitude = Math.max($6b17f08f738443dc$var$waveformGainLevel, 0.001);
    // Phosphor fade or clear
    const now = performance.now();
    const elapsed = now - $6b17f08f738443dc$var$lastWaveformDrawTime;
    $6b17f08f738443dc$var$lastWaveformDrawTime = now;
    if ($6b17f08f738443dc$var$phosphorDecayMs > 0 && elapsed > 0) {
        // Fade previous content: overlay black with opacity based on elapsed time and decay
        const fadeAlpha = Math.min(1, elapsed / $6b17f08f738443dc$var$phosphorDecayMs);
        $6b17f08f738443dc$var$waveformCtx.fillStyle = `rgba(0, 0, 0, ${fadeAlpha})`;
        $6b17f08f738443dc$var$waveformCtx.fillRect(0, 0, width, height);
    } else {
        $6b17f08f738443dc$var$waveformCtx.fillStyle = '#000';
        $6b17f08f738443dc$var$waveformCtx.fillRect(0, 0, width, height);
    }
    $6b17f08f738443dc$var$waveformCtx.strokeStyle = '#00ff00';
    $6b17f08f738443dc$var$waveformCtx.lineWidth = 1;
    $6b17f08f738443dc$var$waveformCtx.beginPath();
    // Map each canvas pixel to a (fractional) sample within the zoomed
    // window and linearly interpolate between neighbouring samples so the
    // trace is a smooth ramp rather than a staircase when zoomed in.
    const sampleStep = samplesInWindow / width;
    const lastIdx = samplesInWindow - 1;
    for(let x = 0; x < width; x++){
        const fIdx = x * sampleStep;
        const i0 = Math.floor(fIdx);
        const i1 = i0 < lastIdx ? i0 + 1 : lastIdx;
        const frac = fIdx - i0;
        const sample = windowSamples[i0] * (1 - frac) + windowSamples[i1] * frac;
        const y = centerY - sample / maxAmplitude * (drawableHeight / 2);
        if (x === 0) $6b17f08f738443dc$var$waveformCtx.moveTo(x, y);
        else $6b17f08f738443dc$var$waveformCtx.lineTo(x, y);
    }
    $6b17f08f738443dc$var$waveformCtx.stroke();
    // Store this waveform and the gain it was drawn with for next frame's
    // correlation trigger and overlap-based scale selection.
    $6b17f08f738443dc$var$previousWaveform = samples.slice(triggerIndex, triggerIndex + samplesInWindow);
    $6b17f08f738443dc$var$previousGainLevel = maxAmplitude;
    // Draw center line
    $6b17f08f738443dc$var$waveformCtx.strokeStyle = '#333';
    $6b17f08f738443dc$var$waveformCtx.lineWidth = 1;
    $6b17f08f738443dc$var$waveformCtx.globalAlpha = 0.5;
    $6b17f08f738443dc$var$waveformCtx.beginPath();
    $6b17f08f738443dc$var$waveformCtx.moveTo(0, centerY);
    $6b17f08f738443dc$var$waveformCtx.lineTo(width, centerY);
    $6b17f08f738443dc$var$waveformCtx.stroke();
    $6b17f08f738443dc$var$waveformCtx.globalAlpha = 1;
    // Label the window duration with a ruler-style scale spanning the full
    // width: tick marks at both ends, a horizontal line, and the label
    // centred in the middle.
    if ($6b17f08f738443dc$var$audioContext && $6b17f08f738443dc$var$audioContext.sampleRate) {
        const durationMs = samplesInWindow / $6b17f08f738443dc$var$audioContext.sampleRate * 1000;
        const label = durationMs >= 100 ? `${durationMs.toFixed(0)} ms` : `${durationMs.toFixed(1)} ms`;
        const yLine = 10;
        const tickHalf = 4;
        const padding = 6;
        const midX = width / 2;
        $6b17f08f738443dc$var$waveformCtx.strokeStyle = '#888';
        $6b17f08f738443dc$var$waveformCtx.fillStyle = '#888';
        $6b17f08f738443dc$var$waveformCtx.lineWidth = 1;
        $6b17f08f738443dc$var$waveformCtx.font = '12px monospace';
        $6b17f08f738443dc$var$waveformCtx.textAlign = 'center';
        $6b17f08f738443dc$var$waveformCtx.textBaseline = 'middle';
        const textWidth = $6b17f08f738443dc$var$waveformCtx.measureText(label).width;
        const leftGap = midX - textWidth / 2 - padding;
        const rightGap = midX + textWidth / 2 + padding;
        $6b17f08f738443dc$var$waveformCtx.beginPath();
        // Left segment
        $6b17f08f738443dc$var$waveformCtx.moveTo(0, yLine);
        $6b17f08f738443dc$var$waveformCtx.lineTo(Math.max(0, leftGap), yLine);
        // Right segment
        $6b17f08f738443dc$var$waveformCtx.moveTo(Math.min(width, rightGap), yLine);
        $6b17f08f738443dc$var$waveformCtx.lineTo(width - 1, yLine);
        // End tick marks (0.5 offsets keep 1px strokes crisp)
        $6b17f08f738443dc$var$waveformCtx.moveTo(0.5, yLine - tickHalf);
        $6b17f08f738443dc$var$waveformCtx.lineTo(0.5, yLine + tickHalf);
        $6b17f08f738443dc$var$waveformCtx.moveTo(width - 0.5, yLine - tickHalf);
        $6b17f08f738443dc$var$waveformCtx.lineTo(width - 0.5, yLine + tickHalf);
        $6b17f08f738443dc$var$waveformCtx.stroke();
        $6b17f08f738443dc$var$waveformCtx.fillText(label, midX, yLine);
    }
}
function $6b17f08f738443dc$var$detectPitch() {
    if (!$6b17f08f738443dc$var$continuousAudioBuffer || !$6b17f08f738443dc$var$audioContext || !$6b17f08f738443dc$var$audioContext.sampleRate) {
        $6b17f08f738443dc$var$currentFundamentalHz = null;
        return;
    }
    const available = $6b17f08f738443dc$var$continuousBufferFilled ? $6b17f08f738443dc$var$continuousBufferSize : $6b17f08f738443dc$var$continuousBufferIndex;
    const analysisLen = Math.min($6b17f08f738443dc$var$PITCH_ANALYSIS_SAMPLES, available);
    if (analysisLen < 512) {
        $6b17f08f738443dc$var$currentFundamentalHz = null;
        return;
    }
    const buf = new Float32Array(analysisLen);
    for(let i = 0; i < analysisLen; i++){
        let idx = $6b17f08f738443dc$var$continuousBufferIndex - analysisLen + i;
        if (idx < 0) idx += $6b17f08f738443dc$var$continuousBufferSize;
        buf[i] = $6b17f08f738443dc$var$continuousAudioBuffer[idx];
    }
    $6b17f08f738443dc$var$currentFundamentalHz = (0, $9423fef94170f602$export$ce4db8ba7c962cd5)(buf, {
        sampleRate: $6b17f08f738443dc$var$audioContext.sampleRate
    });
}
// Measure the full-size label width for `noteName`, including the backdrop
// padding. Mutates ctx.font; callers should reset afterwards if needed.
function $6b17f08f738443dc$var$fullSizeLabelWidth(noteName) {
    $6b17f08f738443dc$var$ctx.font = `bold ${$6b17f08f738443dc$var$NOTE_LABEL_SIZES[0]}px monospace`;
    return $6b17f08f738443dc$var$ctx.measureText(noteName).width + $6b17f08f738443dc$var$NOTE_LABEL_PAD_X + 1;
}
// Write the pending note label to the canvas, sized to the largest font that
// fits inside `availableWidth` (pass Infinity to force the largest size).
function $6b17f08f738443dc$var$commitPendingNoteLabel(availableWidth) {
    if (!$6b17f08f738443dc$var$pendingNoteLabel || !$6b17f08f738443dc$var$canvas || !$6b17f08f738443dc$var$ctx) {
        $6b17f08f738443dc$var$pendingNoteLabel = null;
        return;
    }
    const { noteName: noteName, anchorX: anchorX, lineY: lineY } = $6b17f08f738443dc$var$pendingNoteLabel;
    const size = (0, $9423fef94170f602$export$a9d8a688afde7617)(availableWidth, $6b17f08f738443dc$var$NOTE_LABEL_SIZES, (s)=>{
        $6b17f08f738443dc$var$ctx.font = `bold ${s}px monospace`;
        return $6b17f08f738443dc$var$ctx.measureText(noteName).width;
    }, $6b17f08f738443dc$var$NOTE_LABEL_PAD_X + 1);
    $6b17f08f738443dc$var$ctx.font = `bold ${size}px monospace`;
    const textWidth = $6b17f08f738443dc$var$ctx.measureText(noteName).width;
    const bgHeight = size + 2;
    const bgWidth = textWidth + $6b17f08f738443dc$var$NOTE_LABEL_PAD_X + 1;
    // Anchor the label at the onset column, flowing rightward across the
    // duration of the note. Clamp to the canvas so an onset that has
    // nearly scrolled off the left still renders something legible.
    const bgX = Math.max(0, Math.min($6b17f08f738443dc$var$canvas.width - bgWidth, Math.round(anchorX)));
    const bgY = Math.max(0, Math.min($6b17f08f738443dc$var$canvas.height - bgHeight, lineY + 3));
    $6b17f08f738443dc$var$ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
    $6b17f08f738443dc$var$ctx.fillRect(bgX, bgY, bgWidth, bgHeight);
    $6b17f08f738443dc$var$ctx.fillStyle = '#00ffff';
    $6b17f08f738443dc$var$ctx.textAlign = 'left';
    $6b17f08f738443dc$var$ctx.textBaseline = 'top';
    $6b17f08f738443dc$var$ctx.fillText(noteName, bgX + 1, bgY + 1);
    $6b17f08f738443dc$var$pendingNoteLabel = null;
}
// Paint the cyan fundamental-frequency marker onto the spectrogram's newly
// drawn columns, and maintain a deferred note-onset label. Labels are held
// back until we know how long the note lasts: a note that persists long
// enough to fit a full-size label gets one; a note cut short by the next
// onset gets the largest size that fits in the gap. The marker and label
// are painted directly to the spectrogram canvas so the scroll on the next
// frame carries them left, producing a pitch trace and a timeline of
// detected notes.
function $6b17f08f738443dc$var$paintPitchOverlay(xStart, xWidth) {
    if (!$6b17f08f738443dc$var$canvas || !$6b17f08f738443dc$var$ctx) return;
    const h = $6b17f08f738443dc$var$canvas.height;
    // Age the pending onset by the pixels the canvas just scrolled. This
    // must run every call (including ones with no detected pitch) so the
    // anchor x and elapsed width stay in sync with on-canvas pixels.
    if ($6b17f08f738443dc$var$pendingNoteLabel) {
        $6b17f08f738443dc$var$pendingNoteLabel.anchorX -= xWidth;
        $6b17f08f738443dc$var$pendingNoteLabel.elapsedWidth += xWidth;
        // If the onset has scrolled fully off the left edge without ever
        // being committed (e.g. pitch dropped out immediately after), drop it.
        if ($6b17f08f738443dc$var$pendingNoteLabel.anchorX + $6b17f08f738443dc$var$fullSizeLabelWidth($6b17f08f738443dc$var$pendingNoteLabel.noteName) < 0) $6b17f08f738443dc$var$pendingNoteLabel = null;
    }
    if ($6b17f08f738443dc$var$currentFundamentalHz === null || $6b17f08f738443dc$var$currentFundamentalHz < $6b17f08f738443dc$var$minFrequency || $6b17f08f738443dc$var$currentFundamentalHz > $6b17f08f738443dc$var$maxFrequency) return;
    const rawY = (0, $9423fef94170f602$export$103a811ebcfb1cd8)($6b17f08f738443dc$var$currentFundamentalHz, h, $6b17f08f738443dc$var$minFrequency, $6b17f08f738443dc$var$maxFrequency, $6b17f08f738443dc$var$isLogScale);
    if (rawY < 0 || rawY > h) return;
    const lineY = Math.round(rawY);
    $6b17f08f738443dc$var$ctx.fillStyle = '#00ffff';
    // 2px tall; clamp so we don't draw past the bottom edge of the canvas.
    const lineHeight = 2;
    const lineTop = Math.min(lineY, h - lineHeight);
    $6b17f08f738443dc$var$ctx.fillRect(xStart, lineTop, xWidth, lineHeight);
    const noteName = (0, $9423fef94170f602$export$5f7ad25582a6704)($6b17f08f738443dc$var$currentFundamentalHz)?.name;
    if (!noteName) return;
    if (noteName !== $6b17f08f738443dc$var$lastDetectedNoteName) {
        // New onset. Commit whatever was pending with the elapsed width as
        // its budget (short notes → small labels), then start tracking the
        // new note. The new pending label is drawn only once its duration
        // is known.
        if ($6b17f08f738443dc$var$pendingNoteLabel) $6b17f08f738443dc$var$commitPendingNoteLabel($6b17f08f738443dc$var$pendingNoteLabel.elapsedWidth);
        $6b17f08f738443dc$var$pendingNoteLabel = {
            noteName: noteName,
            anchorX: xStart,
            lineY: lineY,
            elapsedWidth: 0
        };
        $6b17f08f738443dc$var$lastDetectedNoteName = noteName;
        return;
    }
    // Same note as before. Commit at full size the moment enough elapsed
    // width has accumulated to fit one. Long, sustained notes all go through
    // here once; further paints are no-ops for the label logic.
    if ($6b17f08f738443dc$var$pendingNoteLabel && $6b17f08f738443dc$var$pendingNoteLabel.elapsedWidth >= $6b17f08f738443dc$var$fullSizeLabelWidth($6b17f08f738443dc$var$pendingNoteLabel.noteName)) $6b17f08f738443dc$var$commitPendingNoteLabel(Infinity);
// Deliberately keep lastDetectedNoteName when the pitch drops out for a
// frame or two — brief gaps in pitch detection shouldn't re-trigger the
// same note label when the sound returns.
}
function $6b17f08f738443dc$var$processFftResult(phasors, fftSize) {
    // Update frequency bin mappings with actual FFT size
    const freqBinWidth = $6b17f08f738443dc$var$audioContext.sampleRate / fftSize;
    for(let i = 0; i < $6b17f08f738443dc$var$frequencyMappings.length; i++)$6b17f08f738443dc$var$frequencyBinMappings[i] = Math.floor($6b17f08f738443dc$var$frequencyMappings[i] / freqBinWidth);
    // Process the FFT data and store it for potential reuse
    const frameData = $6b17f08f738443dc$var$processFftData(phasors, fftSize);
    window.lastProcessedFrameData = frameData;
    // Paint the pending gap by interpolating from the previous column to this
    // new one — closes over all the pixels the canvas has scrolled since the
    // last FFT response without leaving stripes of old data between columns.
    const width = Math.max(1, $6b17f08f738443dc$var$pendingShiftAmount);
    const left = $6b17f08f738443dc$var$previousFrameData || frameData;
    $6b17f08f738443dc$var$paintRightEdgeInterpolated(left, frameData, width);
    $6b17f08f738443dc$var$previousFrameData = frameData;
    $6b17f08f738443dc$var$pendingShiftAmount = 0;
}
// Paint `width` columns at the right edge of the spectrogram, linearly
// interpolating from `left` to `right` in 0-255 magnitude space. The rightmost
// column is `right` (t = 1); the column nearest the existing content is closer
// to `left`, so the gap blends into the new data rather than showing a stripe.
function $6b17f08f738443dc$var$paintRightEdgeInterpolated(left, right, width) {
    if (!$6b17f08f738443dc$var$canvas || width < 1) return;
    const canvasWidth = $6b17f08f738443dc$var$canvas.width;
    if (left === right || !left) for(let i = 0; i < width; i++)$6b17f08f738443dc$var$drawFrameData(right, canvasWidth - width + i);
    else {
        const canvasHeight = $6b17f08f738443dc$var$canvas.height;
        const blended = new Array(canvasHeight);
        for(let i = 0; i < width; i++){
            const t = (i + 1) / width;
            for(let j = 0; j < canvasHeight; j++)blended[j] = Math.round(left[j] * (1 - t) + right[j] * t);
            $6b17f08f738443dc$var$drawFrameData(blended, canvasWidth - width + i);
        }
    }
    $6b17f08f738443dc$var$paintPitchOverlay(canvasWidth - width, width);
}
function $6b17f08f738443dc$var$processFftData(phasors, fftSize) {
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    const minDb = document.getElementById('min-db') ? parseInt(document.getElementById('min-db').value) : -100;
    const maxDb = document.getElementById('max-db') ? parseInt(document.getElementById('max-db').value) : -20;
    const frameData = new Array(canvasHeight);
    for(let i = 0; i < canvasHeight; i++){
        const freqIndex = $6b17f08f738443dc$var$frequencyBinMappings[i];
        // Ensure freqIndex is within bounds of the FFT output
        let value = 0; // Initialize value outside the if block
        if (freqIndex >= 0 && freqIndex < phasors.length) {
            // Calculate magnitude from complex FFT output
            const real = phasors[freqIndex][0];
            const imag = phasors[freqIndex][1];
            const magnitude = Math.sqrt(real * real + imag * imag);
            // Normalize by FFT size to get proper scaling
            const normalizedMagnitude = magnitude / fftSize;
            // Convert magnitude to decibels with proper reference
            value = 20 * Math.log10(normalizedMagnitude + 1e-10); // Add small epsilon to avoid log(0)
            // Normalize decibel value to 0-255 range for coloring
            value = Math.max(minDb, Math.min(maxDb, value)); // Clamp value within min/max dB
            value = Math.floor((value - minDb) / (maxDb - minDb) * 255); // Normalize to 0-255
        } else // Out of bounds - set to minimum value
        value = 0;
        frameData[i] = value;
    }
    return frameData;
}
function $6b17f08f738443dc$var$drawFrameData(frameData, xPosition) {
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    // Batch canvas operations for better performance
    $6b17f08f738443dc$var$ctx.beginPath();
    for(let i = 0; i < canvasHeight; i++){
        const value = frameData[i];
        // Cache color lookups for better performance
        let color = $6b17f08f738443dc$var$colorCache.get(value);
        if (color === undefined) {
            color = $6b17f08f738443dc$var$colorSchemes[$6b17f08f738443dc$var$currentColorScheme](value);
            $6b17f08f738443dc$var$colorCache.set(value, color);
        }
        // Use the selected color scheme
        $6b17f08f738443dc$var$ctx.fillStyle = color;
        // Draw a 1px-wide rectangle at the specified position
        $6b17f08f738443dc$var$ctx.fillRect(xPosition, i, 1, 1);
    }
}
function $6b17f08f738443dc$var$reprocessAudioBuffer() {
    console.log('Reprocessing audio buffer...', {
        isReprocessing: $6b17f08f738443dc$var$isReprocessing,
        bufferLength: $6b17f08f738443dc$var$audioBuffer.length,
        currentFftSize: $6b17f08f738443dc$var$currentFftSize,
        currentWindowFunction: $6b17f08f738443dc$var$currentWindowFunction
    });
    if ($6b17f08f738443dc$var$audioBuffer.length === 0) {
        console.log('Skipping reprocessing: buffer is empty');
        return;
    }
    // If already reprocessing, cancel it and start fresh
    if ($6b17f08f738443dc$var$isReprocessing || window.reprocessingInProgress) {
        console.log('Cancelling ongoing reprocessing and starting fresh');
        // Cancel any ongoing reprocessing
        $6b17f08f738443dc$var$isReprocessing = false;
        window.reprocessingInProgress = false;
        window.reprocessingRetryCount = 0;
        $6b17f08f738443dc$var$pendingFftRequest = null;
        // Clear any timeouts
        if (window.workerTimeout) {
            clearTimeout(window.workerTimeout);
            window.workerTimeout = null;
        }
        // Clear any main reprocessing timeout
        if (window.reprocessingTimeout) {
            clearTimeout(window.reprocessingTimeout);
            window.reprocessingTimeout = null;
        }
        // Reset column counter
        window.reprocessingColumn = undefined;
        // Small delay to ensure cleanup is complete
        setTimeout(()=>{
            $6b17f08f738443dc$var$reprocessAudioBuffer();
        }, 10);
        return;
    }
    window.reprocessingInProgress = true;
    window.reprocessingRetryCount = 0; // Reset retry counter
    $6b17f08f738443dc$var$isReprocessing = true;
    // Always process from right to left, but calculate exact X positions for each frame
    window.reprocessingColumn = $6b17f08f738443dc$var$canvas.width - 1;
    // Calculate the original X positions for each buffer entry
    // Each frame shifts the canvas left by 1 pixel, so older frames are further left
    const bufferToProcess = [
        ...$6b17f08f738443dc$var$audioBuffer
    ];
    window.framePositions = []; // Make globally accessible
    window.frameIndices = []; // Store the corresponding buffer indices
    // When paused, we only process frames that actually have data
    // When live, we only process the frames that are actually in the buffer
    const maxFrames = bufferToProcess.length;
    // Build arrays in screen order (left to right, oldest to newest)
    for(let i = 0; i < maxFrames; i++){
        // Calculate the position - frames go from left to right
        // Account for scrolling speed: each frame shifts by scrollingSpeed pixels
        const shiftAmount = Math.max(1, Math.round($6b17f08f738443dc$var$scrollingSpeed));
        const xPos = Math.max(0, $6b17f08f738443dc$var$canvas.width - maxFrames * shiftAmount + i * shiftAmount);
        // Calculate the buffer index based on how the frames appear on screen
        let bufferIndex;
        if ($6b17f08f738443dc$var$audioBuffer.length < $6b17f08f738443dc$var$audioBufferSize) // Buffer not full yet - frames are in chronological order
        bufferIndex = i;
        else // Buffer is full - use circular buffer logic
        // The oldest frame (left edge) is at audioBufferIndex
        // The newest frame (right edge) is at audioBufferIndex - 1
        bufferIndex = ($6b17f08f738443dc$var$audioBufferIndex + i) % $6b17f08f738443dc$var$audioBufferSize;
        window.framePositions.push(xPos);
        window.frameIndices.push(bufferIndex); // Store the actual buffer index
    }
    console.log('Reprocessing with calculated frame positions:', window.framePositions.slice(0, 10), '...');
    console.log('Canvas width:', $6b17f08f738443dc$var$canvas.width, 'Buffer length:', bufferToProcess.length);
    console.log('First few positions:', window.framePositions.slice(0, 5));
    console.log('Last few positions:', window.framePositions.slice(-5));
    console.log('Processing order - will start from index:', window.framePositions.length - 1, 'and go to 0');
    console.log('This means starting from position:', window.framePositions[window.framePositions.length - 1], 'and ending at position:', window.framePositions[0]);
    // Set a timeout to ensure reprocessing flag doesn't get stuck
    // Longer timeout for large FFTs - use the actual current FFT size
    const actualFftSize = $6b17f08f738443dc$var$currentFftSize;
    const timeoutMs = actualFftSize >= 8192 ? 60000 : 20000; // Increased timeouts
    console.log('Setting reprocessing timeout:', timeoutMs, 'ms for FFT size:', actualFftSize);
    window.reprocessingTimeout = setTimeout(()=>{
        if ($6b17f08f738443dc$var$isReprocessing) {
            console.log('Reprocessing timeout - resetting flag after', timeoutMs, 'ms for FFT size:', actualFftSize);
            $6b17f08f738443dc$var$isReprocessing = false;
            window.reprocessingInProgress = false; // Clear the guard
            $6b17f08f738443dc$var$pendingFftRequest = null; // Clear any stuck Web Worker request
            // Clear any worker timeout
            if (window.workerTimeout) {
                clearTimeout(window.workerTimeout);
                window.workerTimeout = null;
            }
        }
    }, timeoutMs);
    console.log('Reprocessing buffer:', {
        bufferFrames: bufferToProcess.length,
        canvasWidth: $6b17f08f738443dc$var$canvas.width,
        bufferSize: $6b17f08f738443dc$var$audioBufferSize,
        bufferIndex: $6b17f08f738443dc$var$audioBufferIndex
    });
    // Start processing from the last frame (right edge) and work backwards
    window.processNextFrame(window.framePositions.length - 1);
}
// Move processNextFrame outside to make it globally accessible
window.processNextFrame = function(index) {
    // Process all frames needed to fill the canvas
    const framesToProcess = window.framePositions.length;
    // Log progress every 100 frames
    if (index % 100 === 0) console.log('Reprocessing progress:', index, '/', framesToProcess, 'frames');
    if (index < 0) {
        if (window.reprocessingTimeout) {
            clearTimeout(window.reprocessingTimeout);
            window.reprocessingTimeout = null;
        }
        $6b17f08f738443dc$var$isReprocessing = false;
        window.reprocessingColumn = undefined; // Reset column counter
        window.reprocessingInProgress = false; // Clear the guard
        window.reprocessingRetryCount = 0; // Reset retry counter
        // Clear any worker timeout
        if (window.workerTimeout) {
            clearTimeout(window.workerTimeout);
            window.workerTimeout = null;
        }
        console.log('Reprocessing completed - processed', framesToProcess, 'frames out of', $6b17f08f738443dc$var$audioBuffer.length, 'available');
        return;
    }
    // Log the first frame to see if processing starts
    if (index === framesToProcess - 1) console.log('Starting reprocessing of first frame (right edge)');
    // Use the frame index from our mapping (processes from right to left)
    const frameIndex = window.frameIndices[index];
    const frame = $6b17f08f738443dc$var$audioBuffer[frameIndex];
    // Use the current FFT size setting, not the stored one
    const fftSize = Math.pow(2, Math.floor(Math.log2($6b17f08f738443dc$var$currentFftSize)));
    // Copy data and pad/truncate as needed
    const fftInput = new Array(fftSize);
    for(let i = 0; i < fftSize; i++)fftInput[i] = frame.data[i] || 0;
    // Use Web Worker for FFT computation
    if ($6b17f08f738443dc$var$fftWorker && !$6b17f08f738443dc$var$pendingFftRequest) {
        if (index === 0) console.log('Using Web Worker for reprocessing');
        const requestId = ++$6b17f08f738443dc$var$fftRequestId;
        $6b17f08f738443dc$var$pendingFftRequest = {
            id: requestId,
            fftSize: fftSize,
            isReprocessing: true,
            currentIndex: index
        };
        // Set a timeout for individual Web Worker requests
        window.workerTimeout = setTimeout(()=>{
            if ($6b17f08f738443dc$var$pendingFftRequest && $6b17f08f738443dc$var$pendingFftRequest.id === requestId) {
                console.log('Web Worker request timeout, falling back to synchronous FFT');
                $6b17f08f738443dc$var$pendingFftRequest = null;
                // Fall back to synchronous processing
                try {
                    const interleavedResult = $6b17f08f738443dc$var$fftInstance.fftr(fftInput);
                    const phasors = $6b17f08f738443dc$var$convertWebfftOutput(interleavedResult);
                    $6b17f08f738443dc$var$processReprocessedFftResult(phasors, fftSize, window.framePositions[index]);
                    setTimeout(()=>window.processNextFrame(index - 1), 0);
                } catch (error) {
                    console.error('Error in fallback FFT processing:', error);
                    setTimeout(()=>window.processNextFrame(index - 1), 0);
                }
            }
        }, 10000); // Increased to 10 second timeout for individual requests
        $6b17f08f738443dc$var$fftWorker.postMessage({
            id: requestId,
            data: fftInput,
            windowFunction: $6b17f08f738443dc$var$currentWindowFunction
        });
    } else {
        // Fallback to synchronous FFT
        if (index === 0) console.log('Using synchronous FFT fallback for reprocessing - fftWorker:', !!$6b17f08f738443dc$var$fftWorker, 'pendingFftRequest:', !!$6b17f08f738443dc$var$pendingFftRequest);
        try {
            const interleavedResult = $6b17f08f738443dc$var$fftInstance.fftr(fftInput);
            const phasors = $6b17f08f738443dc$var$convertWebfftOutput(interleavedResult);
            $6b17f08f738443dc$var$processReprocessedFftResult(phasors, fftSize, window.framePositions[index]);
            // Use shorter delay for large FFTs to avoid timeout
            const delay = $6b17f08f738443dc$var$currentFftSize >= 8192 ? 1 : 1; // Small delay to prevent overwhelming
            setTimeout(()=>window.processNextFrame(index - 1), delay);
        } catch (error) {
            console.error('Error in synchronous FFT processing:', error);
            // Continue to next frame even if this one fails
            setTimeout(()=>window.processNextFrame(index - 1), 0);
        }
    }
};
function $6b17f08f738443dc$var$processNextReprocessingFrame(index, bufferToProcess, framePositions) {
    const framesToProcess = framePositions.length;
    if (index >= framesToProcess) {
        console.log('Reprocessing completed via synchronous FFT - processed', framesToProcess, 'frames');
        if (window.reprocessingTimeout) {
            clearTimeout(window.reprocessingTimeout);
            window.reprocessingTimeout = null;
        }
        $6b17f08f738443dc$var$isReprocessing = false;
        window.reprocessingColumn = undefined; // Reset column counter
        window.reprocessingInProgress = false; // Clear the guard
        window.reprocessingRetryCount = 0; // Reset retry counter
        // Clear any worker timeout
        if (window.workerTimeout) {
            clearTimeout(window.workerTimeout);
            window.workerTimeout = null;
        }
        return;
    }
    // Use the frame index from our mapping (processes from right to left)
    const frameIndex = window.frameIndices[index];
    const frame = bufferToProcess[frameIndex];
    // Use the current FFT size setting, not the stored one
    const fftSize = Math.pow(2, Math.floor(Math.log2($6b17f08f738443dc$var$currentFftSize)));
    // Copy data and pad/truncate as needed
    const fftInput = new Array(fftSize);
    for(let i = 0; i < fftSize; i++)fftInput[i] = frame.data[i] || 0;
    // Use Web Worker for FFT computation
    if ($6b17f08f738443dc$var$fftWorker && !$6b17f08f738443dc$var$pendingFftRequest) {
        const requestId = ++$6b17f08f738443dc$var$fftRequestId;
        $6b17f08f738443dc$var$pendingFftRequest = {
            id: requestId,
            fftSize: fftSize,
            isReprocessing: true,
            currentIndex: index
        };
        // Set a timeout for this individual Web Worker request
        window.workerTimeout = setTimeout(()=>{
            if ($6b17f08f738443dc$var$pendingFftRequest && $6b17f08f738443dc$var$pendingFftRequest.id === requestId) {
                console.log('Web Worker request timeout in reprocessing, falling back to synchronous FFT');
                $6b17f08f738443dc$var$pendingFftRequest = null;
                // Fall back to synchronous processing
                try {
                    const interleavedResult = $6b17f08f738443dc$var$fftInstance.fftr(fftInput);
                    const phasors = $6b17f08f738443dc$var$convertWebfftOutput(interleavedResult);
                    $6b17f08f738443dc$var$processReprocessedFftResult(phasors, fftSize, window.framePositions[index]);
                    setTimeout(()=>$6b17f08f738443dc$var$processNextReprocessingFrame(index + 1, bufferToProcess, window.framePositions), 0);
                } catch (error) {
                    console.error('Error in fallback FFT processing during reprocessing:', error);
                    setTimeout(()=>$6b17f08f738443dc$var$processNextReprocessingFrame(index + 1, bufferToProcess, window.framePositions), 0);
                }
            }
        }, 10000); // 10 second timeout for individual requests
        $6b17f08f738443dc$var$fftWorker.postMessage({
            id: requestId,
            data: fftInput,
            windowFunction: $6b17f08f738443dc$var$currentWindowFunction
        });
    } else {
        // Fallback to synchronous FFT
        const interleavedResult = $6b17f08f738443dc$var$fftInstance.fftr(fftInput);
        const phasors = $6b17f08f738443dc$var$convertWebfftOutput(interleavedResult);
        $6b17f08f738443dc$var$processReprocessedFftResult(phasors, fftSize, window.framePositions[index]);
        // Use shorter delay for large FFTs to avoid timeout
        const delay = $6b17f08f738443dc$var$currentFftSize >= 8192 ? 1 : 1; // Small delay to prevent overwhelming
        setTimeout(()=>$6b17f08f738443dc$var$processNextReprocessingFrame(index + 1, bufferToProcess, window.framePositions), delay);
    }
}
function $6b17f08f738443dc$var$processReprocessedFftResult(phasors, fftSize, xPosition) {
    const canvasWidth = $6b17f08f738443dc$var$canvas.width;
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    // Update frequency bin mappings with actual FFT size
    const freqBinWidth = $6b17f08f738443dc$var$audioContext.sampleRate / fftSize;
    for(let i = 0; i < $6b17f08f738443dc$var$frequencyMappings.length; i++)$6b17f08f738443dc$var$frequencyBinMappings[i] = Math.floor($6b17f08f738443dc$var$frequencyMappings[i] / freqBinWidth);
    // Use the provided X position for drawing
    const drawX = xPosition;
    // Debug logging (commented out since it's working)
    // console.log('Drawing reprocessed frame at X position:', drawX, 'FFT size:', fftSize);
    // Draw the spectrogram slice at the current column position
    const minDb = document.getElementById('min-db') ? parseInt(document.getElementById('min-db').value) : -100;
    const maxDb = document.getElementById('max-db') ? parseInt(document.getElementById('max-db').value) : -20;
    // Batch canvas operations for better performance
    $6b17f08f738443dc$var$ctx.beginPath();
    // Set global alpha for reprocessing to make it slightly transparent
    $6b17f08f738443dc$var$ctx.globalAlpha = 0.9; // Slightly transparent to distinguish from original
    // Account for scrolling speed when drawing reprocessed frames
    const shiftAmount = Math.max(1, Math.round($6b17f08f738443dc$var$scrollingSpeed));
    for(let i = 0; i < canvasHeight; i++){
        const freqIndex = $6b17f08f738443dc$var$frequencyBinMappings[i];
        // Ensure freqIndex is within bounds of the FFT output
        let value = 0; // Initialize value outside the if block
        if (freqIndex >= 0 && freqIndex < phasors.length) {
            // Calculate magnitude from complex FFT output
            const real = phasors[freqIndex][0];
            const imag = phasors[freqIndex][1];
            const magnitude = Math.sqrt(real * real + imag * imag);
            // Normalize by FFT size to get proper scaling
            const normalizedMagnitude = magnitude / fftSize;
            // Convert magnitude to decibels with proper reference
            value = 20 * Math.log10(normalizedMagnitude + 1e-10); // Add small epsilon to avoid log(0)
            // Normalize decibel value to 0-255 range for coloring
            value = Math.max(minDb, Math.min(maxDb, value)); // Clamp value within min/max dB
            value = Math.floor((value - minDb) / (maxDb - minDb) * 255); // Normalize to 0-255
        } else // Out of bounds - set to minimum value
        value = 0;
        // Cache color lookups for better performance
        let color = $6b17f08f738443dc$var$colorCache.get(value);
        if (color === undefined) {
            color = $6b17f08f738443dc$var$colorSchemes[$6b17f08f738443dc$var$currentColorScheme](value);
            $6b17f08f738443dc$var$colorCache.set(value, color);
        }
        // Use the selected color scheme
        $6b17f08f738443dc$var$ctx.fillStyle = color;
        // Draw across multiple pixels based on scrolling speed
        for(let j = 0; j < shiftAmount; j++)$6b17f08f738443dc$var$ctx.fillRect(drawX + j, i, 1, 1);
    }
    // Reset global alpha
    $6b17f08f738443dc$var$ctx.globalAlpha = 1.0;
}
function $6b17f08f738443dc$var$draw() {
    const timeDomainFrame = $6b17f08f738443dc$var$latestTimeDomainData;
    if ($6b17f08f738443dc$var$isPaused || $6b17f08f738443dc$var$isVisibilityHidden) return;
    // Skip live updates if reprocessing is in progress
    if ($6b17f08f738443dc$var$isReprocessing || window.reprocessingInProgress) {
        // Still continue the animation loop but don't process new frames
        $6b17f08f738443dc$var$animationFrameId = requestAnimationFrame($6b17f08f738443dc$var$draw);
        return;
    }
    const currentTime = performance.now();
    if (currentTime - $6b17f08f738443dc$var$lastDrawBodyTime < $6b17f08f738443dc$var$targetDrawIntervalMs - $6b17f08f738443dc$var$DRAW_INTERVAL_CUSHION_MS) {
        $6b17f08f738443dc$var$animationFrameId = requestAnimationFrame($6b17f08f738443dc$var$draw);
        return;
    }
    $6b17f08f738443dc$var$lastDrawBodyTime = currentTime;
    $6b17f08f738443dc$var$animationFrameId = requestAnimationFrame($6b17f08f738443dc$var$draw);
    // Refresh pitch from the continuous buffer before any spectrogram
    // painting, so paintPitchOverlay() writes an up-to-date marker and
    // note-onset label onto the new column.
    $6b17f08f738443dc$var$detectPitch();
    // FPS calculation
    $6b17f08f738443dc$var$fpsCounter++;
    if (currentTime - $6b17f08f738443dc$var$fpsLastTime >= 1000) {
        if ($6b17f08f738443dc$var$fpsDisplay) $6b17f08f738443dc$var$fpsDisplay.textContent = $6b17f08f738443dc$var$fpsCounter;
        $6b17f08f738443dc$var$fpsCounter = 0;
        $6b17f08f738443dc$var$fpsLastTime = currentTime;
    }
    // Advance the scroll accumulator by real elapsed time. scrollingSpeed is
    // pixels per second (scaled so 1.0 == SCROLL_REFERENCE_FPS px/s) regardless
    // of how often draw() actually runs, so the spectrogram scrolls at the
    // same wall-clock rate whether the FPS cap is 20 or 120.
    const canvasWidth = $6b17f08f738443dc$var$canvas.width;
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    let deltaSeconds = 0;
    if ($6b17f08f738443dc$var$lastFrameTimestamp !== null) deltaSeconds = (currentTime - $6b17f08f738443dc$var$lastFrameTimestamp) / 1000;
    if (deltaSeconds > 0 && deltaSeconds < 1) $6b17f08f738443dc$var$scrollAccumulator += $6b17f08f738443dc$var$scrollingSpeed * $6b17f08f738443dc$var$SCROLL_REFERENCE_FPS * deltaSeconds;
    const shiftAmount = Math.floor($6b17f08f738443dc$var$scrollAccumulator);
    if (shiftAmount < 1) {
        // Not enough elapsed time for a full pixel yet — keep the loop running
        // but don't paint, process audio, or advance the time-per-pixel estimate.
        $6b17f08f738443dc$var$lastFrameTimestamp = currentTime;
        return;
    }
    $6b17f08f738443dc$var$scrollAccumulator -= shiftAmount;
    if (deltaSeconds > 0 && deltaSeconds < 1) {
        const instantaneousTimePerPixel = Math.max(deltaSeconds / shiftAmount, $6b17f08f738443dc$var$MIN_TIME_PER_PIXEL);
        // Apply compound correction factor: (9/9.17) * (10/10.97) * (10/10.22)
        const correctedTimePerPixel = instantaneousTimePerPixel * (9.0 / 9.17) * (10.0 / 10.97) * (10.0 / 10.22);
        const alpha = $6b17f08f738443dc$var$TIME_PER_PIXEL_SMOOTHING;
        $6b17f08f738443dc$var$smoothedTimePerPixel = $6b17f08f738443dc$var$smoothedTimePerPixel * (1 - alpha) + correctedTimePerPixel * alpha;
    }
    if (Math.abs($6b17f08f738443dc$var$smoothedTimePerPixel - $6b17f08f738443dc$var$lastDrawnTimePerPixel) > 0.001 && $6b17f08f738443dc$var$timeScaleCtx) {
        const nowMs = currentTime;
        if (nowMs - $6b17f08f738443dc$var$lastTimeScaleUpdate >= $6b17f08f738443dc$var$TIME_SCALE_UPDATE_INTERVAL_MS) $6b17f08f738443dc$var$drawTimeScale();
    }
    $6b17f08f738443dc$var$lastFrameTimestamp = currentTime;
    $6b17f08f738443dc$var$ctx.drawImage($6b17f08f738443dc$var$canvas, shiftAmount, 0, canvasWidth - shiftAmount, canvasHeight, 0, 0, canvasWidth - shiftAmount, canvasHeight);
    $6b17f08f738443dc$var$pendingShiftAmount += shiftAmount;
    // Adaptive frame skipping for large FFTs - only affects audio processing
    $6b17f08f738443dc$var$frameSkipCounter++;
    if ($6b17f08f738443dc$var$frameSkipCounter < $6b17f08f738443dc$var$frameSkipThreshold) {
        // Skip audio processing but duplicate the last frame data for visual continuity
        if (window.lastProcessedFrameData) {
            $6b17f08f738443dc$var$paintRightEdgeInterpolated($6b17f08f738443dc$var$previousFrameData || window.lastProcessedFrameData, window.lastProcessedFrameData, $6b17f08f738443dc$var$pendingShiftAmount);
            $6b17f08f738443dc$var$previousFrameData = window.lastProcessedFrameData;
            $6b17f08f738443dc$var$pendingShiftAmount = 0;
        }
        return;
    }
    $6b17f08f738443dc$var$frameSkipCounter = 0;
    if (!timeDomainFrame || !timeDomainFrame.buffer) {
        if (window.lastProcessedFrameData) {
            $6b17f08f738443dc$var$paintRightEdgeInterpolated($6b17f08f738443dc$var$previousFrameData || window.lastProcessedFrameData, window.lastProcessedFrameData, $6b17f08f738443dc$var$pendingShiftAmount);
            $6b17f08f738443dc$var$previousFrameData = window.lastProcessedFrameData;
            $6b17f08f738443dc$var$pendingShiftAmount = 0;
        }
        return;
    }
    const timeDomainData = timeDomainFrame.buffer;
    $6b17f08f738443dc$var$latestTimeDomainData = null; // Consume this frame so we only process it once
    // Add to audio buffer for reprocessing.
    // The continuous buffer is appended on the audio callback (see
    // audioWorkletNode.port.onmessage), not here, so a throttled draw
    // rate doesn't lose audio frames.
    $6b17f08f738443dc$var$addToAudioBuffer(timeDomainData, $6b17f08f738443dc$var$currentWindowFunction, timeDomainFrame.timestamp);
    // Process FFT using the continuous buffer with overlap to minimize frame artifacts
    // Only process if we have enough data in the continuous buffer
    // Use hop size that balances time resolution with proper windowing overlap
    const hopSize = Math.max(128, $6b17f08f738443dc$var$currentFftSize / 64); // Better overlap for windowing, reduces sidebands
    // Check if buffer has enough data: either buffer has been filled once (after wraparound),
    // or current index is past the FFT size (initial fill)
    if ($6b17f08f738443dc$var$continuousAudioBuffer && ($6b17f08f738443dc$var$continuousBufferFilled || $6b17f08f738443dc$var$continuousBufferIndex >= $6b17f08f738443dc$var$currentFftSize)) {
        // Calculate hop size with proper circular buffer wraparound handling
        let actualHopSize = hopSize;
        if (window.lastFftBufferIndex !== undefined && window.lastFftBufferIndex !== null) {
            // Handle circular buffer wraparound
            if ($6b17f08f738443dc$var$continuousBufferIndex >= window.lastFftBufferIndex) // Normal case - no wraparound
            actualHopSize = $6b17f08f738443dc$var$continuousBufferIndex - window.lastFftBufferIndex;
            else // Buffer has wrapped around
            actualHopSize = $6b17f08f738443dc$var$continuousBufferSize - window.lastFftBufferIndex + $6b17f08f738443dc$var$continuousBufferIndex;
        }
        // Debug logging every 100 frames to avoid spam
        if (Math.random() < 0.01) console.log('Buffer state:', {
            continuousBufferIndex: $6b17f08f738443dc$var$continuousBufferIndex,
            lastFftBufferIndex: window.lastFftBufferIndex,
            actualHopSize: actualHopSize,
            hopSize: hopSize,
            bufferSize: $6b17f08f738443dc$var$continuousBufferSize,
            wrapped: $6b17f08f738443dc$var$continuousBufferIndex < window.lastFftBufferIndex
        });
        // Only process if we've actually advanced enough
        if (actualHopSize >= hopSize) // Update the last FFT processing position
        window.lastFftBufferIndex = $6b17f08f738443dc$var$continuousBufferIndex;
        else {
            // If we're not advancing enough, don't process yet
            if (actualHopSize === 0) {
                window.bufferStuckCounter = (window.bufferStuckCounter || 0) + 1;
                if (window.bufferStuckCounter > 100) {
                    console.warn('Buffer appears stuck, resetting lastFftBufferIndex');
                    window.lastFftBufferIndex = null;
                    window.bufferStuckCounter = 0;
                }
            } else window.bufferStuckCounter = 0; // Reset counter if we're advancing, just not enough
            return; // Don't process if we haven't advanced enough
        }
        // Extract FFT samples directly from the continuous buffer (no frame boundaries)
        const fftSamples = new Float32Array($6b17f08f738443dc$var$currentFftSize);
        const startBufferPos = $6b17f08f738443dc$var$continuousBufferIndex - $6b17f08f738443dc$var$currentFftSize;
        // Debug info for first few samples
        const debugSamples = [];
        for(let i = 0; i < $6b17f08f738443dc$var$currentFftSize; i++){
            // Get samples going backwards from current position
            let bufferPos = $6b17f08f738443dc$var$continuousBufferIndex - $6b17f08f738443dc$var$currentFftSize + i;
            // Handle circular buffer wraparound
            // Note: We only reach this code when continuousBufferIndex >= currentFftSize (line 554),
            // so we always have enough data and never need to pad with zeros
            if (bufferPos < 0) bufferPos = (bufferPos + $6b17f08f738443dc$var$continuousBufferSize) % $6b17f08f738443dc$var$continuousBufferSize;
            else bufferPos = bufferPos % $6b17f08f738443dc$var$continuousBufferSize;
            fftSamples[i] = $6b17f08f738443dc$var$continuousAudioBuffer[bufferPos];
            // Store debug info for first few and last few samples
            if (i < 5 || i >= $6b17f08f738443dc$var$currentFftSize - 5) debugSamples.push({
                i: i,
                bufferPos: bufferPos,
                value: fftSamples[i].toFixed(4)
            });
        }
        // Log debug info occasionally
        if (Math.random() < 0.005) console.log('FFT extraction debug:', {
            fftSize: $6b17f08f738443dc$var$currentFftSize,
            continuousBufferIndex: $6b17f08f738443dc$var$continuousBufferIndex,
            startBufferPos: startBufferPos,
            samples: debugSamples
        });
        // Convert to array for FFT library - let web worker handle windowing
        const fftInput = new Array($6b17f08f738443dc$var$currentFftSize);
        for(let i = 0; i < $6b17f08f738443dc$var$currentFftSize; i++)fftInput[i] = fftSamples[i] || 0;
        // Check for discontinuities in the raw FFT samples
        let maxJump = 0;
        let jumpLocation = -1;
        let isAllZeros = true;
        let sampleVariance = 0;
        for(let i = 1; i < fftSamples.length; i++){
            const jump = Math.abs(fftSamples[i] - fftSamples[i - 1]);
            if (jump > maxJump) {
                maxJump = jump;
                jumpLocation = i;
            }
            if (Math.abs(fftSamples[i]) > 1e-6) isAllZeros = false;
            sampleVariance += fftSamples[i] * fftSamples[i];
        }
        sampleVariance /= fftSamples.length;
        // Detect potentially problematic data
        if (isAllZeros && Math.random() < 0.01) console.warn('All-zero FFT input detected');
        if (sampleVariance < 1e-10 && Math.random() < 0.01) console.warn('Very low variance FFT input detected:', sampleVariance);
        // Store the actual FFT input data for waveform visualization
        $6b17f08f738443dc$var$lastFftInputData = {
            data: [
                ...fftInput
            ],
            timestamp: Date.now(),
            fftSize: $6b17f08f738443dc$var$currentFftSize,
            bufferIndex: $6b17f08f738443dc$var$continuousBufferIndex,
            rawSamples: [
                ...fftSamples
            ],
            maxJump: maxJump,
            jumpLocation: jumpLocation
        };
        // Always use Web Worker for FFT computation to keep main thread free
        if ($6b17f08f738443dc$var$fftWorker && !$6b17f08f738443dc$var$pendingFftRequest) {
            const requestId = ++$6b17f08f738443dc$var$fftRequestId;
            $6b17f08f738443dc$var$pendingFftRequest = {
                id: requestId,
                fftSize: $6b17f08f738443dc$var$currentFftSize
            };
            $6b17f08f738443dc$var$fftWorker.postMessage({
                id: requestId,
                data: fftInput,
                windowFunction: $6b17f08f738443dc$var$currentWindowFunction
            });
        }
        // Update waveform display
        $6b17f08f738443dc$var$drawWaveform();
    }
}
function $6b17f08f738443dc$var$drawLabels() {
    $6b17f08f738443dc$var$labelsCtx.clearRect(0, 0, $6b17f08f738443dc$var$labelsCanvas.width, $6b17f08f738443dc$var$labelsCanvas.height);
    $6b17f08f738443dc$var$labelsCtx.fillStyle = '#fff';
    $6b17f08f738443dc$var$labelsCtx.font = '10px Arial';
    $6b17f08f738443dc$var$labelsCtx.textAlign = 'right';
    $6b17f08f738443dc$var$labelsCtx.textBaseline = 'middle';
    const labelFrequencies = [
        50,
        100,
        200,
        500,
        1000,
        2000,
        5000,
        10000,
        20000
    ];
    for (const freq of labelFrequencies){
        if (freq < $6b17f08f738443dc$var$minFrequency || freq > $6b17f08f738443dc$var$maxFrequency) continue; // Skip frequencies outside the current range
        let yPos;
        if ($6b17f08f738443dc$var$isLogScale) {
            const logMin = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency);
            const logMax = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency);
            const logFreq = $6b17f08f738443dc$var$frequencyToLog(freq);
            yPos = $6b17f08f738443dc$var$labelsCanvas.height - 1 - (logFreq - logMin) / (logMax - logMin) * ($6b17f08f738443dc$var$labelsCanvas.height - 1);
        } else {
            const linearMin = $6b17f08f738443dc$var$minFrequency;
            const linearMax = $6b17f08f738443dc$var$maxFrequency;
            yPos = $6b17f08f738443dc$var$labelsCanvas.height - 1 - (freq - linearMin) / (linearMax - linearMin) * ($6b17f08f738443dc$var$labelsCanvas.height - 1);
        }
        // Draw text label
        $6b17f08f738443dc$var$labelsCtx.fillText(freq >= 1000 ? freq / 1000 + 'k' : freq, $6b17f08f738443dc$var$labelsCanvas.width - 5, yPos);
        // Draw a small line
        $6b17f08f738443dc$var$labelsCtx.strokeStyle = 'white';
        $6b17f08f738443dc$var$labelsCtx.lineWidth = 0.5;
        $6b17f08f738443dc$var$labelsCtx.beginPath();
        $6b17f08f738443dc$var$labelsCtx.moveTo($6b17f08f738443dc$var$labelsCanvas.width - 10, yPos);
        $6b17f08f738443dc$var$labelsCtx.lineTo($6b17f08f738443dc$var$labelsCanvas.width, yPos);
        $6b17f08f738443dc$var$labelsCtx.stroke();
    }
}
function $6b17f08f738443dc$var$getTimePerPixel() {
    return Math.max($6b17f08f738443dc$var$lastDrawnTimePerPixel, $6b17f08f738443dc$var$MIN_TIME_PER_PIXEL);
}
function $6b17f08f738443dc$var$drawTimeScale() {
    if (!$6b17f08f738443dc$var$timeScaleCanvas || !$6b17f08f738443dc$var$timeScaleCtx) return;
    const canvasWidth = $6b17f08f738443dc$var$timeScaleCanvas.clientWidth || $6b17f08f738443dc$var$timeScaleCanvas.width;
    if (canvasWidth <= 0) return;
    const currentTimePerPixel = Math.max($6b17f08f738443dc$var$smoothedTimePerPixel, $6b17f08f738443dc$var$MIN_TIME_PER_PIXEL);
    $6b17f08f738443dc$var$lastDrawnTimePerPixel = currentTimePerPixel;
    $6b17f08f738443dc$var$lastTimeScaleUpdate = typeof performance !== 'undefined' ? performance.now() : Date.now();
    $6b17f08f738443dc$var$lastTotalTimeSpan = canvasWidth * currentTimePerPixel;
    // Clear the canvas
    $6b17f08f738443dc$var$timeScaleCtx.clearRect(0, 0, $6b17f08f738443dc$var$timeScaleCanvas.width, $6b17f08f738443dc$var$timeScaleCanvas.height);
    // Set up the drawing context
    $6b17f08f738443dc$var$timeScaleCtx.fillStyle = '#fff';
    $6b17f08f738443dc$var$timeScaleCtx.font = '10px Arial';
    $6b17f08f738443dc$var$timeScaleCtx.textAlign = 'center';
    $6b17f08f738443dc$var$timeScaleCtx.textBaseline = 'top';
    // The time per frame depends on how often we process FFTs and the scrolling speed
    const timePerPixel = currentTimePerPixel;
    // Calculate total time span based on canvas width
    const totalTimeSpan = canvasWidth * timePerPixel;
    // Determine appropriate time intervals for labels
    let timeInterval;
    if (totalTimeSpan <= 1) timeInterval = 0.1; // 100ms intervals
    else if (totalTimeSpan <= 5) timeInterval = 0.5; // 500ms intervals
    else if (totalTimeSpan <= 10) timeInterval = 1; // 1 second intervals
    else if (totalTimeSpan <= 30) timeInterval = 5; // 5 second intervals
    else timeInterval = 10; // 10 second intervals
    // Draw time labels (0 at right edge, increasing towards left)
    const numLabels = Math.floor(totalTimeSpan / timeInterval) + 1;
    for(let i = 0; i < numLabels; i++){
        const time = i * timeInterval;
        // Calculate x position from right edge (0) towards left (increasing time)
        const xPos = canvasWidth - time / totalTimeSpan * canvasWidth;
        // Only draw if the label is within the canvas
        if (xPos >= 0) {
            // Format time label
            let timeLabel;
            if (time < 1) timeLabel = `${(time * 1000).toFixed(0)}ms`;
            else if (time < 60) timeLabel = `${time.toFixed(1)}s`;
            else {
                const minutes = Math.floor(time / 60);
                const seconds = time % 60;
                timeLabel = `${minutes}:${seconds.toFixed(0).padStart(2, '0')}`;
            }
            // Draw tick mark at the top
            $6b17f08f738443dc$var$timeScaleCtx.strokeStyle = '#fff';
            $6b17f08f738443dc$var$timeScaleCtx.lineWidth = 1;
            $6b17f08f738443dc$var$timeScaleCtx.beginPath();
            $6b17f08f738443dc$var$timeScaleCtx.moveTo(xPos, 0);
            $6b17f08f738443dc$var$timeScaleCtx.lineTo(xPos, 10);
            $6b17f08f738443dc$var$timeScaleCtx.stroke();
            // Draw the label below the tick mark
            $6b17f08f738443dc$var$timeScaleCtx.fillText(timeLabel, xPos, 15);
        }
    }
    // Draw a horizontal line at the top
    $6b17f08f738443dc$var$timeScaleCtx.strokeStyle = '#ccc';
    $6b17f08f738443dc$var$timeScaleCtx.lineWidth = 1;
    $6b17f08f738443dc$var$timeScaleCtx.beginPath();
    $6b17f08f738443dc$var$timeScaleCtx.moveTo(0, 0);
    $6b17f08f738443dc$var$timeScaleCtx.lineTo(canvasWidth, 0);
    $6b17f08f738443dc$var$timeScaleCtx.stroke();
}
window.onload = ()=>{
    // Get references to all control elements
    $6b17f08f738443dc$var$canvas = document.getElementById('spectrogram');
    $6b17f08f738443dc$var$ctx = $6b17f08f738443dc$var$canvas.getContext('2d');
    $6b17f08f738443dc$var$labelsCanvas = document.getElementById('frequency-labels');
    $6b17f08f738443dc$var$labelsCtx = $6b17f08f738443dc$var$labelsCanvas.getContext('2d');
    $6b17f08f738443dc$var$cursorLineCanvas = document.getElementById('cursor-line-canvas');
    $6b17f08f738443dc$var$cursorLineCtx = $6b17f08f738443dc$var$cursorLineCanvas.getContext('2d');
    $6b17f08f738443dc$var$timeScaleCanvas = document.getElementById('time-scale');
    $6b17f08f738443dc$var$timeScaleCtx = $6b17f08f738443dc$var$timeScaleCanvas ? $6b17f08f738443dc$var$timeScaleCanvas.getContext('2d') : null;
    $6b17f08f738443dc$var$waveformCanvas = document.getElementById('waveform-canvas');
    $6b17f08f738443dc$var$waveformCtx = $6b17f08f738443dc$var$waveformCanvas.getContext('2d');
    $6b17f08f738443dc$var$waveformArea = document.querySelector('.waveform-area');
    $6b17f08f738443dc$var$spectrogramArea = document.querySelector('.main-spectrogram-area');
    $6b17f08f738443dc$var$resizeHandle = document.getElementById('resize-handle');
    $6b17f08f738443dc$var$populateBuildInfo();
    // Initialize waveform canvas size
    if ($6b17f08f738443dc$var$waveformCanvas) {
        $6b17f08f738443dc$var$waveformCanvas.width = $6b17f08f738443dc$var$canvas.clientWidth || $6b17f08f738443dc$var$canvas.width || 1000;
        $6b17f08f738443dc$var$waveformCanvas.height = $6b17f08f738443dc$var$waveformHeight; // Use default waveform height
    }
    $6b17f08f738443dc$var$pauseResumeBtn = document.getElementById('pause-resume-btn');
    const minFreqSlider = document.getElementById('min-freq');
    const maxFreqSlider = document.getElementById('max-freq');
    const minFreqDisplay = document.getElementById('min-freq-display');
    const maxFreqDisplay = document.getElementById('max-freq-display');
    const colorSchemeSelect = document.getElementById('color-scheme');
    $6b17f08f738443dc$var$logScaleCheckbox = document.getElementById('log-scale-checkbox');
    $6b17f08f738443dc$var$fftSizeSelect = document.getElementById('fft-size');
    $6b17f08f738443dc$var$sampleRateSelect = document.getElementById('sample-rate');
    const scrollingSpeedSlider = document.getElementById('scrolling-speed');
    const scrollingSpeedDisplay = document.getElementById('scrolling-speed-display');
    const phosphorDecaySlider = document.getElementById('phosphor-decay');
    const phosphorDecayDisplay = document.getElementById('phosphor-decay-display');
    $6b17f08f738443dc$var$selectionOverlay = document.getElementById('selection-overlay');
    const mainSpectrogramArea = document.querySelector('.main-spectrogram-area');
    $6b17f08f738443dc$var$fpsDisplay = document.getElementById('fps-display');
    // Tapping/clicking anywhere on the waveform toggles pause.
    if ($6b17f08f738443dc$var$waveformCanvas) {
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('click', ()=>{
            $6b17f08f738443dc$var$pauseResumeBtn.click();
        });
        const clampZoom = (z)=>Math.max($6b17f08f738443dc$var$MIN_WAVEFORM_TIME_ZOOM, Math.min($6b17f08f738443dc$var$MAX_WAVEFORM_TIME_ZOOM, z));
        // Mouse wheel + touchpad pinch. Browsers translate a trackpad pinch
        // into a wheel event with ctrlKey=true; we treat both the same — any
        // wheel over the waveform zooms the time axis. deltaY>0 (scroll down
        // or pinch in) zooms out (more time); deltaY<0 zooms in (less time).
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('wheel', (e)=>{
            e.preventDefault();
            const factor = Math.pow(1.0015, e.deltaY);
            $6b17f08f738443dc$var$waveformTimeZoom = clampZoom($6b17f08f738443dc$var$waveformTimeZoom * factor);
        }, {
            passive: false
        });
        // Two-finger pinch on touchscreens.
        let pinchPrevDistance = 0;
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('touchstart', (e)=>{
            if (e.touches.length === 2) {
                e.preventDefault();
                pinchPrevDistance = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            }
        }, {
            passive: false
        });
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('touchmove', (e)=>{
            if (e.touches.length !== 2) return;
            e.preventDefault();
            const distance = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            if (pinchPrevDistance > 0) {
                // Fingers apart (distance grows) → zoom in → less time shown.
                const ratio = distance / pinchPrevDistance;
                $6b17f08f738443dc$var$waveformTimeZoom = clampZoom($6b17f08f738443dc$var$waveformTimeZoom / ratio);
            }
            pinchPrevDistance = distance;
        }, {
            passive: false
        });
        const resetPinch = ()=>{
            pinchPrevDistance = 0;
        };
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('touchend', resetPinch);
        $6b17f08f738443dc$var$waveformCanvas.addEventListener('touchcancel', resetPinch);
    }
    // Set up pause/resume button
    $6b17f08f738443dc$var$pauseResumeBtn.addEventListener('click', ()=>{
        $6b17f08f738443dc$var$isPaused = !$6b17f08f738443dc$var$isPaused;
        if ($6b17f08f738443dc$var$isPaused) {
            $6b17f08f738443dc$var$pauseResumeBtn.textContent = 'Resume';
            $6b17f08f738443dc$var$lastFrameTimestamp = null;
        } else {
            $6b17f08f738443dc$var$pauseResumeBtn.textContent = 'Pause';
            // If resuming, we need to kick off the draw loop again.
            if (!$6b17f08f738443dc$var$audioContext) {
                // Audio was released (tab was hidden or never started); re-acquire.
                const rate = $6b17f08f738443dc$var$sampleRateSelect ? parseInt($6b17f08f738443dc$var$sampleRateSelect.value) : 44100;
                $6b17f08f738443dc$var$lastFrameTimestamp = null;
                $6b17f08f738443dc$var$startAudio(rate);
            } else if ($6b17f08f738443dc$var$audioContext.state === 'running') {
                $6b17f08f738443dc$var$lastFrameTimestamp = null;
                $6b17f08f738443dc$var$draw();
            }
        }
    });
    // Set up toggle controls button
    $6b17f08f738443dc$var$toggleControlsBtn = document.getElementById('toggle-controls-btn');
    $6b17f08f738443dc$var$toggleControlsBtn.addEventListener('click', ()=>{
        const controls = document.querySelector('.controls');
        const fpsCounter = document.querySelector('.fps-counter');
        if (controls.style.display === 'none') {
            controls.style.display = 'flex';
            fpsCounter.style.display = 'block';
            $6b17f08f738443dc$var$toggleControlsBtn.textContent = 'Hide Settings';
        } else {
            controls.style.display = 'none';
            fpsCounter.style.display = 'none';
            $6b17f08f738443dc$var$toggleControlsBtn.textContent = 'Show Settings';
        }
        // Trigger resize to recalculate canvas positions
        setTimeout(()=>$6b17f08f738443dc$var$resizeCanvas(), 0);
    });
    // Initialize WebFFT instance
    try {
        $6b17f08f738443dc$var$fftInstance = new (0, $304b9fcf638b77cf$export$2e2bcd8739ae039)($6b17f08f738443dc$var$currentFftSize);
    } catch (error) {
        console.error('Failed to initialize WebFFT with size', $6b17f08f738443dc$var$currentFftSize, ':', error);
        alert('Error: Failed to initialize WebFFT. Please refresh the page.');
    }
    $6b17f08f738443dc$var$startAudio(parseInt($6b17f08f738443dc$var$sampleRateSelect.value));
    $6b17f08f738443dc$var$resizeCanvas();
    $6b17f08f738443dc$var$updateFrequencyMappings(); // Initialize frequency mappings
    $6b17f08f738443dc$var$initFftWorker(); // Initialize FFT Web Worker
    $6b17f08f738443dc$var$drawTimeScale(); // Initialize time scale
    // Initialize slider values and displays
    minFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency)) * 1000;
    maxFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency)) * 1000;
    minFreqDisplay.textContent = $6b17f08f738443dc$var$minFrequency;
    maxFreqDisplay.textContent = $6b17f08f738443dc$var$maxFrequency;
    // Initialize color scheme dropdown
    colorSchemeSelect.value = $6b17f08f738443dc$var$currentColorScheme;
    // Add event listeners for frequency sliders
    minFreqSlider.addEventListener('input', (event)=>{
        const linearValue = parseInt(event.target.value) / 1000;
        $6b17f08f738443dc$var$minFrequency = Math.round($6b17f08f738443dc$var$logToFrequency($6b17f08f738443dc$var$linearToLog(linearValue)));
        minFreqDisplay.textContent = $6b17f08f738443dc$var$minFrequency;
        // Ensure minFreq is not greater than maxFreq
        if ($6b17f08f738443dc$var$minFrequency >= $6b17f08f738443dc$var$maxFrequency) {
            $6b17f08f738443dc$var$maxFrequency = $6b17f08f738443dc$var$minFrequency + 1; // Ensure max is always greater than min
            maxFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency)) * 1000;
            maxFreqDisplay.textContent = $6b17f08f738443dc$var$maxFrequency;
        }
        $6b17f08f738443dc$var$drawLabels(); // Redraw labels on frequency change
        $6b17f08f738443dc$var$updateFrequencyMappings(); // Update frequency mappings
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new frequency range
    });
    function getFrequencyFromY(y) {
        const canvasHeight = $6b17f08f738443dc$var$canvas.height;
        let freq;
        if ($6b17f08f738443dc$var$isLogScale) {
            const logMin = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency);
            const logMax = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency);
            const logFreq = logMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (logMax - logMin);
            freq = $6b17f08f738443dc$var$logToFrequency(logFreq);
        } else {
            const linearMin = $6b17f08f738443dc$var$minFrequency;
            const linearMax = $6b17f08f738443dc$var$maxFrequency;
            freq = linearMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (linearMax - linearMin);
        }
        return freq;
    }
    maxFreqSlider.addEventListener('input', (event)=>{
        const linearValue = parseInt(event.target.value) / 1000;
        $6b17f08f738443dc$var$maxFrequency = Math.round($6b17f08f738443dc$var$logToFrequency($6b17f08f738443dc$var$linearToLog(linearValue)));
        maxFreqDisplay.textContent = $6b17f08f738443dc$var$maxFrequency;
        // Ensure maxFreq is not less than minFreq
        if ($6b17f08f738443dc$var$maxFrequency <= $6b17f08f738443dc$var$minFrequency) {
            $6b17f08f738443dc$var$minFrequency = $6b17f08f738443dc$var$maxFrequency - 1; // Ensure min is always less than max
            if ($6b17f08f738443dc$var$minFrequency < 20) $6b17f08f738443dc$var$minFrequency = 20; // Don't go below 20Hz
            minFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency)) * 1000;
            minFreqDisplay.textContent = $6b17f08f738443dc$var$minFrequency;
        }
        $6b17f08f738443dc$var$drawLabels(); // Redraw labels on frequency change
        $6b17f08f738443dc$var$updateFrequencyMappings(); // Update frequency mappings
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new frequency range
    });
    colorSchemeSelect.addEventListener('change', (event)=>{
        $6b17f08f738443dc$var$currentColorScheme = event.target.value;
        $6b17f08f738443dc$var$colorCache.clear(); // Clear color cache when scheme changes
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new color scheme
    });
    function handleFrequencyScaleChange1(event) {
        $6b17f08f738443dc$var$isLogScale = event.target.checked;
        $6b17f08f738443dc$var$drawLabels(); // Redraw labels on scale change
        $6b17f08f738443dc$var$updateFrequencyMappings(); // Update frequency mappings
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new frequency scale
    }
    // Make handleFrequencyScaleChange globally accessible
    window.handleFrequencyScaleChange = handleFrequencyScaleChange1;
    $6b17f08f738443dc$var$logScaleCheckbox.addEventListener('change', handleFrequencyScaleChange1);
    // Set default selected value (convert FFT size to log2)
    $6b17f08f738443dc$var$fftSizeSelect.value = Math.log2($6b17f08f738443dc$var$currentFftSize);
    $6b17f08f738443dc$var$fftSizeSelect.addEventListener('change', async (event)=>{
        // Convert slider value (log2) to actual FFT size
        const newFftSize = Math.pow(2, parseInt(event.target.value));
        console.log('FFT size changed:', {
            old: $6b17f08f738443dc$var$currentFftSize,
            new: newFftSize
        });
        $6b17f08f738443dc$var$currentFftSize = newFftSize;
        // Update frame skip threshold based on FFT size - more aggressive processing for time resolution
        if ($6b17f08f738443dc$var$currentFftSize >= 32768) $6b17f08f738443dc$var$frameSkipThreshold = 2; // Skip every other frame only for extremely large FFTs
        else $6b17f08f738443dc$var$frameSkipThreshold = 1; // Process every frame for all other sizes
        // Create new WebFFT instance for the new size
        try {
            $6b17f08f738443dc$var$fftInstance = new (0, $304b9fcf638b77cf$export$2e2bcd8739ae039)($6b17f08f738443dc$var$currentFftSize);
        } catch (error) {
            console.error('Failed to initialize WebFFT with size', $6b17f08f738443dc$var$currentFftSize, ':', error);
            alert('Error: FFT size ' + $6b17f08f738443dc$var$currentFftSize + ' is not supported by WebFFT. Please choose a different size.');
            return;
        }
        // Reset reprocessing flag before restarting audio
        $6b17f08f738443dc$var$isReprocessing = false;
        // Re-initialize audio context with new FFT size
        if ($6b17f08f738443dc$var$audioContext) {
            await $6b17f08f738443dc$var$audioContext.close();
            $6b17f08f738443dc$var$audioContext = null;
        }
        // Cancel any existing animation frame before starting a new one
        if ($6b17f08f738443dc$var$animationFrameId) cancelAnimationFrame($6b17f08f738443dc$var$animationFrameId);
        $6b17f08f738443dc$var$startAudio(parseInt($6b17f08f738443dc$var$sampleRateSelect.value));
        // Add a small delay to ensure currentFftSize is properly set
        setTimeout(()=>{
            console.log('Delayed reprocessing with FFT size:', $6b17f08f738443dc$var$currentFftSize);
            $6b17f08f738443dc$var$drawTimeScale(); // Update time scale with new FFT size
            if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new FFT size
        }, 100);
    });
    const windowFunctionSelect = document.getElementById('window-function');
    // Map slider values to window function names
    const windowFunctionMap = [
        'blackman',
        'hann',
        'hamming',
        'rectangular'
    ];
    // Set default selected value (convert window function name to slider position)
    windowFunctionSelect.value = windowFunctionMap.indexOf($6b17f08f738443dc$var$currentWindowFunction);
    windowFunctionSelect.addEventListener('change', (event)=>{
        // Convert slider value to window function name
        $6b17f08f738443dc$var$currentWindowFunction = windowFunctionMap[parseInt(event.target.value)];
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new window function
    });
    $6b17f08f738443dc$var$sampleRateSelect.addEventListener('change', async (event)=>{
        await $6b17f08f738443dc$var$restartAudioContext(parseInt(event.target.value));
    });
    // Add event listeners for mouse selection on the spectrogram
    $6b17f08f738443dc$var$canvas.addEventListener('mousedown', (event)=>{
        $6b17f08f738443dc$var$isSelecting = true;
        $6b17f08f738443dc$var$selectionStart = {
            x: event.offsetX,
            y: event.offsetY
        };
        $6b17f08f738443dc$var$selectionOverlay.style.display = 'block';
        $6b17f08f738443dc$var$selectionOverlay.style.top = `${$6b17f08f738443dc$var$selectionStart.y}px`;
        $6b17f08f738443dc$var$selectionOverlay.style.height = '0px';
    });
    $6b17f08f738443dc$var$canvas.addEventListener('mousemove', (event)=>{
        if ($6b17f08f738443dc$var$isSelecting) {
            $6b17f08f738443dc$var$selectionEnd = {
                x: event.offsetX,
                y: event.offsetY
            };
            const startY = Math.min($6b17f08f738443dc$var$selectionStart.y, $6b17f08f738443dc$var$selectionEnd.y);
            const height = Math.abs($6b17f08f738443dc$var$selectionStart.y - $6b17f08f738443dc$var$selectionEnd.y);
            $6b17f08f738443dc$var$selectionOverlay.style.top = `${startY}px`;
            $6b17f08f738443dc$var$selectionOverlay.style.height = `${height}px`;
        }
    });
    $6b17f08f738443dc$var$canvas.addEventListener('mouseup', (event)=>{
        if ($6b17f08f738443dc$var$isSelecting) {
            $6b17f08f738443dc$var$isSelecting = false;
            $6b17f08f738443dc$var$selectionOverlay.style.display = 'none';
            const y1 = $6b17f08f738443dc$var$selectionStart.y;
            const y2 = $6b17f08f738443dc$var$selectionEnd.y;
            // Determine the new frequency range based on the selection
            const newMinFreq = getFrequencyFromY(Math.max(y1, y2));
            const newMaxFreq = getFrequencyFromY(Math.min(y1, y2));
            if (Math.abs(y1 - y2) > 5) {
                $6b17f08f738443dc$var$minFrequency = Math.round(newMinFreq);
                $6b17f08f738443dc$var$maxFrequency = Math.round(newMaxFreq);
                // Update sliders and displays
                minFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency)) * 1000;
                maxFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency)) * 1000;
                minFreqDisplay.textContent = $6b17f08f738443dc$var$minFrequency;
                maxFreqDisplay.textContent = $6b17f08f738443dc$var$maxFrequency;
                $6b17f08f738443dc$var$drawLabels();
                $6b17f08f738443dc$var$updateFrequencyMappings(); // Update frequency mappings after zoom
                if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new frequency range
            }
        }
    });
    $6b17f08f738443dc$var$canvas.addEventListener('dblclick', ()=>{
        // Reset to default frequency range
        $6b17f08f738443dc$var$minFrequency = 20;
        $6b17f08f738443dc$var$maxFrequency = 11025;
        // Update sliders and displays
        minFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency)) * 1000;
        maxFreqSlider.value = $6b17f08f738443dc$var$logToLinear($6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency)) * 1000;
        minFreqDisplay.textContent = $6b17f08f738443dc$var$minFrequency;
        maxFreqDisplay.textContent = $6b17f08f738443dc$var$maxFrequency;
        $6b17f08f738443dc$var$drawLabels();
        $6b17f08f738443dc$var$updateFrequencyMappings(); // Update frequency mappings after reset
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new frequency range
    });
    const frequencyTooltip = document.getElementById('frequency-tooltip');
    const minDbSlider = document.getElementById('min-db');
    const maxDbSlider = document.getElementById('max-db');
    const minDbDisplay = document.getElementById('min-db-display');
    const maxDbDisplay = document.getElementById('max-db-display');
    minDbSlider.addEventListener('input', (event)=>{
        minDbDisplay.textContent = event.target.value;
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new decibel range
    });
    maxDbSlider.addEventListener('input', (event)=>{
        maxDbDisplay.textContent = event.target.value;
        if ($6b17f08f738443dc$var$isPaused) $6b17f08f738443dc$var$reprocessAudioBuffer(); // Reprocess with new decibel range
    });
    // Scrolling speed control
    scrollingSpeedSlider.addEventListener('input', (event)=>{
        $6b17f08f738443dc$var$scrollingSpeed = parseFloat(event.target.value);
        scrollingSpeedDisplay.textContent = $6b17f08f738443dc$var$scrollingSpeed.toFixed(1);
        $6b17f08f738443dc$var$drawTimeScale(); // Update time scale to reflect new scrolling speed
    });
    // Phosphor decay control
    phosphorDecaySlider.addEventListener('input', (event)=>{
        $6b17f08f738443dc$var$phosphorDecayMs = parseInt(event.target.value);
        phosphorDecayDisplay.textContent = $6b17f08f738443dc$var$phosphorDecayMs;
    });
    const anchorWeightSlider = document.getElementById('anchor-weight');
    const anchorWeightDisplay = document.getElementById('anchor-weight-display');
    if (anchorWeightSlider && anchorWeightDisplay) anchorWeightSlider.addEventListener('input', (event)=>{
        $6b17f08f738443dc$var$waveformAnchorWeight = parseFloat(event.target.value);
        anchorWeightDisplay.textContent = $6b17f08f738443dc$var$waveformAnchorWeight.toFixed(1);
    });
    const fpsLimitSlider = document.getElementById('fps-limit');
    const fpsLimitDisplay = document.getElementById('fps-limit-display');
    if (fpsLimitSlider && fpsLimitDisplay) fpsLimitSlider.addEventListener('input', (event)=>{
        $6b17f08f738443dc$var$targetDrawFps = parseInt(event.target.value, 10);
        $6b17f08f738443dc$var$targetDrawIntervalMs = 1000 / $6b17f08f738443dc$var$targetDrawFps;
        fpsLimitDisplay.textContent = $6b17f08f738443dc$var$targetDrawFps;
    });
    const TOUCH_TOOLTIP_Y_OFFSET = 60; // keep the tooltip clear of the fingertip
    const updateCrosshair = (x, y, isTouchInput = false)=>{
        $6b17f08f738443dc$var$mouseCanvasX = x;
        $6b17f08f738443dc$var$mouseCanvasY = y;
        $6b17f08f738443dc$var$drawCursorLine($6b17f08f738443dc$var$mouseCanvasX, $6b17f08f738443dc$var$mouseCanvasY);
        if ($6b17f08f738443dc$var$isSelecting) return;
        const freq = getFrequencyFromY(y);
        const timeOffsetSeconds = $6b17f08f738443dc$var$getTimeOffsetFromX(x);
        const note = (0, $9423fef94170f602$export$5f7ad25582a6704)(freq);
        const notePart = note ? ` \xb7 ${note.name} ${note.cents >= 0 ? '+' : ''}${note.cents}\xa2` : '';
        frequencyTooltip.textContent = `${freq.toFixed(2)} Hz${notePart} | ${timeOffsetSeconds.toFixed(2)}s ago`;
        let tooltipX = x + $6b17f08f738443dc$var$canvas.offsetLeft - frequencyTooltip.offsetWidth - 10;
        let tooltipY = isTouchInput ? y + $6b17f08f738443dc$var$canvas.offsetTop - frequencyTooltip.offsetHeight - TOUCH_TOOLTIP_Y_OFFSET : y + $6b17f08f738443dc$var$canvas.offsetTop - frequencyTooltip.offsetHeight / 2;
        const mainSpectrogramAreaRect = mainSpectrogramArea.getBoundingClientRect();
        if (tooltipX < 0) tooltipX = x + $6b17f08f738443dc$var$canvas.offsetLeft + 10;
        if (tooltipY < 0) // Finger near the top of the canvas — flip the tooltip below instead.
        tooltipY = isTouchInput ? y + $6b17f08f738443dc$var$canvas.offsetTop + TOUCH_TOOLTIP_Y_OFFSET : 0;
        if (tooltipY + frequencyTooltip.offsetHeight > mainSpectrogramAreaRect.height) tooltipY = mainSpectrogramAreaRect.height - frequencyTooltip.offsetHeight - 5;
        frequencyTooltip.style.left = `${tooltipX}px`;
        frequencyTooltip.style.top = `${tooltipY}px`;
        frequencyTooltip.style.display = 'block';
    };
    const hideCrosshair = ()=>{
        frequencyTooltip.style.display = 'none';
        $6b17f08f738443dc$var$mouseCanvasX = -1;
        $6b17f08f738443dc$var$mouseCanvasY = -1;
        $6b17f08f738443dc$var$cursorLineCtx.clearRect(0, 0, $6b17f08f738443dc$var$cursorLineCanvas.width, $6b17f08f738443dc$var$cursorLineCanvas.height);
    };
    const canvasCoordsFromTouch = (touch)=>{
        const rect = $6b17f08f738443dc$var$canvas.getBoundingClientRect();
        return {
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top
        };
    };
    $6b17f08f738443dc$var$canvas.addEventListener('mousemove', (event)=>{
        updateCrosshair(event.offsetX, event.offsetY);
    });
    $6b17f08f738443dc$var$canvas.addEventListener('mouseenter', ()=>{
        if (!$6b17f08f738443dc$var$isSelecting) frequencyTooltip.style.display = 'block';
    });
    $6b17f08f738443dc$var$canvas.addEventListener('mouseleave', hideCrosshair);
    // Touch support for the crosshair/tooltip. Non-passive so preventDefault()
    // stops the page from scrolling while the finger is dragging across the
    // spectrogram.
    $6b17f08f738443dc$var$canvas.addEventListener('touchstart', (event)=>{
        if (event.touches.length === 0) return;
        event.preventDefault();
        const { x: x, y: y } = canvasCoordsFromTouch(event.touches[0]);
        updateCrosshair(x, y, true);
    }, {
        passive: false
    });
    $6b17f08f738443dc$var$canvas.addEventListener('touchmove', (event)=>{
        if (event.touches.length === 0) return;
        event.preventDefault();
        const { x: x, y: y } = canvasCoordsFromTouch(event.touches[0]);
        updateCrosshair(x, y, true);
    }, {
        passive: false
    });
    // Intentionally no touchend/touchcancel hide — on touchscreens there's
    // no hover state, so leaving the crosshair and tooltip visible after the
    // finger lifts lets the user read the value without keeping contact. The
    // next touchstart moves them to the new position.
    // Set up resize handle drag functionality (mouse + touch)
    const applyDragMove = (clientY)=>{
        const containerRect = document.querySelector('.container').getBoundingClientRect();
        const containerBottom = containerRect.bottom;
        // 20px for margins and handle
        const newHeight = Math.max(50, containerBottom - clientY - 20);
        $6b17f08f738443dc$var$waveformHeight = newHeight;
        $6b17f08f738443dc$var$waveformArea.style.flexBasis = `${newHeight}px`;
        $6b17f08f738443dc$var$waveformArea.style.flexGrow = '0';
        $6b17f08f738443dc$var$waveformArea.style.flexShrink = '0';
        setTimeout(()=>$6b17f08f738443dc$var$resizeCanvas(), 0);
    };
    if ($6b17f08f738443dc$var$resizeHandle) {
        $6b17f08f738443dc$var$resizeHandle.addEventListener('mousedown', (e)=>{
            $6b17f08f738443dc$var$isDragging = true;
            e.preventDefault();
        });
        // touchstart must be non-passive so preventDefault() can stop the
        // browser from treating the gesture as a page scroll.
        $6b17f08f738443dc$var$resizeHandle.addEventListener('touchstart', (e)=>{
            if (e.touches.length === 0) return;
            $6b17f08f738443dc$var$isDragging = true;
            e.preventDefault();
        }, {
            passive: false
        });
    }
    window.addEventListener('mousemove', (e)=>{
        if (!$6b17f08f738443dc$var$isDragging) return;
        applyDragMove(e.clientY);
    });
    window.addEventListener('touchmove', (e)=>{
        if (!$6b17f08f738443dc$var$isDragging || e.touches.length === 0) return;
        e.preventDefault();
        applyDragMove(e.touches[0].clientY);
    }, {
        passive: false
    });
    const endDrag = ()=>{
        if ($6b17f08f738443dc$var$isDragging) $6b17f08f738443dc$var$isDragging = false;
    };
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('touchcancel', endDrag);
};
function $6b17f08f738443dc$var$drawCursorLine(x, y) {
    $6b17f08f738443dc$var$cursorLineCtx.clearRect(0, 0, $6b17f08f738443dc$var$cursorLineCanvas.width, $6b17f08f738443dc$var$cursorLineCanvas.height); // Clear previous line
    $6b17f08f738443dc$var$cursorLineCtx.strokeStyle = 'rgba(255, 255, 255, 0.5)'; // Thin white, slightly transparent line
    $6b17f08f738443dc$var$cursorLineCtx.lineWidth = 1;
    if (y !== -1) {
        $6b17f08f738443dc$var$cursorLineCtx.beginPath();
        $6b17f08f738443dc$var$cursorLineCtx.moveTo(0, y);
        $6b17f08f738443dc$var$cursorLineCtx.lineTo($6b17f08f738443dc$var$cursorLineCanvas.width, y);
        $6b17f08f738443dc$var$cursorLineCtx.stroke();
    }
    if (x !== -1) {
        $6b17f08f738443dc$var$cursorLineCtx.beginPath();
        $6b17f08f738443dc$var$cursorLineCtx.moveTo(x, 0);
        $6b17f08f738443dc$var$cursorLineCtx.lineTo(x, $6b17f08f738443dc$var$cursorLineCanvas.height);
        $6b17f08f738443dc$var$cursorLineCtx.stroke();
    }
}
function $6b17f08f738443dc$var$getFrequencyFromY(y) {
    const canvasHeight = $6b17f08f738443dc$var$canvas.height;
    let freq;
    if ($6b17f08f738443dc$var$isLogScale) {
        const logMin = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$minFrequency);
        const logMax = $6b17f08f738443dc$var$frequencyToLog($6b17f08f738443dc$var$maxFrequency);
        const logFreq = logMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (logMax - logMin);
        freq = $6b17f08f738443dc$var$logToFrequency(logFreq);
    } else {
        const linearMin = $6b17f08f738443dc$var$minFrequency;
        const linearMax = $6b17f08f738443dc$var$maxFrequency;
        freq = linearMin + (canvasHeight - 1 - y) / (canvasHeight - 1) * (linearMax - linearMin);
    }
    return freq;
}
function $6b17f08f738443dc$var$getTimeOffsetFromX(x) {
    if (!$6b17f08f738443dc$var$canvas) return 0;
    const canvasWidth = $6b17f08f738443dc$var$canvas.clientWidth || $6b17f08f738443dc$var$canvas.width;
    if (canvasWidth <= 0) return 0;
    const clampedX = Math.min(Math.max(x, 0), canvasWidth);
    const totalTimeSpan = $6b17f08f738443dc$var$lastTotalTimeSpan || canvasWidth * $6b17f08f738443dc$var$getTimePerPixel();
    const fractionFromRight = (canvasWidth - clampedX) / canvasWidth;
    return fractionFromRight * totalTimeSpan;
}
window.addEventListener('resize', $6b17f08f738443dc$var$resizeCanvas);
// Page Visibility: when the tab is backgrounded, release the mic entirely —
// not just suspend the AudioContext. Suspending keeps the MediaStreamTrack
// active, which leaves the OS recording indicator lit. Stopping the track
// turns the indicator off; when the tab returns we re-acquire via
// getUserMedia (no re-prompt after the initial permission grant).
document.addEventListener('visibilitychange', ()=>{
    if (document.hidden) {
        $6b17f08f738443dc$var$isVisibilityHidden = true;
        $6b17f08f738443dc$var$releaseAudioResources();
    } else {
        $6b17f08f738443dc$var$isVisibilityHidden = false;
        if (!$6b17f08f738443dc$var$isPaused && !$6b17f08f738443dc$var$audioContext) {
            const rate = $6b17f08f738443dc$var$sampleRateSelect ? parseInt($6b17f08f738443dc$var$sampleRateSelect.value) : 44100;
            $6b17f08f738443dc$var$lastFrameTimestamp = null;
            $6b17f08f738443dc$var$startAudio(rate);
        }
    }
});
// Draggable resize handle between spectrogram and waveform
let $6b17f08f738443dc$var$resizeHandle;
let $6b17f08f738443dc$var$waveformArea;
let $6b17f08f738443dc$var$spectrogramArea;
let $6b17f08f738443dc$var$isDragging = false;
let $6b17f08f738443dc$var$waveformHeight = 100; // Default height in pixels
window.addEventListener('keydown', (event)=>{
    if (event.code === 'Space') $6b17f08f738443dc$var$pauseResumeBtn.click();
    else if (event.key === '`' || event.key === '~') $6b17f08f738443dc$var$toggleControlsBtn.click();
    else if (event.key === 'l') {
        $6b17f08f738443dc$var$isLogScale = !$6b17f08f738443dc$var$isLogScale;
        $6b17f08f738443dc$var$logScaleCheckbox.checked = $6b17f08f738443dc$var$isLogScale;
        $6b17f08f738443dc$var$logScaleCheckbox.dispatchEvent(new Event('change'));
        handleFrequencyScaleChange({
            target: $6b17f08f738443dc$var$logScaleCheckbox
        });
    } else if (event.key === 'F') {
        // Increase FFT size (slider value is log2, so increment by 1)
        const currentLog2 = parseInt($6b17f08f738443dc$var$fftSizeSelect.value);
        if (currentLog2 < 15) {
            $6b17f08f738443dc$var$fftSizeSelect.value = currentLog2 + 1;
            $6b17f08f738443dc$var$fftSizeSelect.dispatchEvent(new Event('change'));
        }
    } else if (event.key === 'f') {
        // Decrease FFT size (slider value is log2, so decrement by 1)
        const currentLog2 = parseInt($6b17f08f738443dc$var$fftSizeSelect.value);
        if (currentLog2 > 10) {
            $6b17f08f738443dc$var$fftSizeSelect.value = currentLog2 - 1;
            $6b17f08f738443dc$var$fftSizeSelect.dispatchEvent(new Event('change'));
        }
    } else if (event.key === 'S') {
        // Increase Sample Rate
        const sampleRates = [
            8000,
            16000,
            22050,
            32000,
            44100,
            48000,
            96000
        ];
        const currentSampleRate = parseInt($6b17f08f738443dc$var$sampleRateSelect.value);
        const currentIndex = sampleRates.indexOf(currentSampleRate);
        if (currentIndex < sampleRates.length - 1) {
            $6b17f08f738443dc$var$sampleRateSelect.value = sampleRates[currentIndex + 1];
            $6b17f08f738443dc$var$sampleRateSelect.dispatchEvent(new Event('change'));
        }
    } else if (event.key === 's') {
        // Decrease Sample Rate
        const sampleRates = [
            8000,
            16000,
            22050,
            32000,
            44100,
            48000,
            96000
        ];
        const currentSampleRate = parseInt($6b17f08f738443dc$var$sampleRateSelect.value);
        const currentIndex = sampleRates.indexOf(currentSampleRate);
        if (currentIndex > 0) {
            $6b17f08f738443dc$var$sampleRateSelect.value = sampleRates[currentIndex - 1];
            $6b17f08f738443dc$var$sampleRateSelect.dispatchEvent(new Event('change'));
        }
    } else if (event.key === 'Escape') // Cancel reprocessing
    {
        if ($6b17f08f738443dc$var$isReprocessing || window.reprocessingInProgress) {
            console.log('Cancelling reprocessing via Escape key');
            // Cancel any ongoing reprocessing
            $6b17f08f738443dc$var$isReprocessing = false;
            window.reprocessingInProgress = false;
            window.reprocessingRetryCount = 0;
            $6b17f08f738443dc$var$pendingFftRequest = null;
            // Clear any timeouts
            if (window.workerTimeout) {
                clearTimeout(window.workerTimeout);
                window.workerTimeout = null;
            }
            // Clear any main reprocessing timeout
            if (window.reprocessingTimeout) {
                clearTimeout(window.reprocessingTimeout);
                window.reprocessingTimeout = null;
            }
            // Reset column counter
            window.reprocessingColumn = undefined;
        }
    }
});


//# sourceMappingURL=spectroscope.1cacb7ac.js.map
